/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptLoadRequest,
  AcceptLoadResponse,
  AccountManagerNotifyRequest,
  AccountingPurchaseOrderLineItemCost,
  AllowedMaterialSpec,
  AnnotationFeedbackCreateRequest,
  AnnotationFeedbackDetail,
  AnnotationFeedbackListResponse,
  AnnotationFeedbackUpdateRequest,
  ApiAccountsV1AccountManagerNotifyCreate400,
  ApiAccountsV1BankDetailsListParams,
  ApiAccountsV1CompanyWeightUnitUpdate400,
  ApiAccountsV1PartnerSigninRequestCreate400,
  ApiAccountsV1PartnerSigninVerifyCreate400,
  ApiAccountsV1PortsListParams,
  ApiAccountsV1SigninRequestCreate400,
  ApiAccountsV1SigninVerifyCreate400,
  ApiAccountsV1SignupRequestCreate400,
  ApiAccountsV1SignupVerifyCreate400,
  ApiAccountsV1UserPartialUpdate400,
  ApiAccountsV1UserRetrieve400,
  ApiDataV1PurchaserPipelineRetrieveParams,
  ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
  ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
  ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
  ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
  ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
  ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
  ApiDealsV1Create400,
  ApiDealsV1DealChoicesListParams,
  ApiDealsV1SellerTransactionHistoryRetrieveParams,
  ApiDocumentsV1DocumentsCreate400,
  ApiDocumentsV1DocumentsExternalListParams,
  ApiDocumentsV1DocumentsListParams,
  ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate400,
  ApiEvidenceV1DataPartialUpdate400,
  ApiEvidenceV1EvidenceSessionRetrieve400,
  ApiEvidenceV1EvidenceSessionRetrieveParams,
  ApiEvidenceV1EvidenceTypesRetrieve200,
  ApiEvidenceV1StartRerunEvidenceJobCreate400,
  ApiFeatureFlagsRetrieve200,
  ApiInspectionsV1EvidenceBulkDeleteCreate400,
  ApiInspectionsV1EvidenceListParams,
  ApiInspectionsV1ListParams,
  ApiLogisticsV1LoadsEvidenceBulkDeleteCreate400,
  ApiLogisticsV1LoadsEvidenceListParams,
  ApiLogisticsV1LoadsListParams,
  ApiLogisticsV1ShipmentsListParams,
  ApiMaterialV1MaterialProductsListParams,
  ApiMaterialsV1AllowedMaterialSpecsListParams,
  ApiMaterialsV1MaterialComponentsListParams,
  ApiMaterialsV1MaterialGradesRetrieveParams,
  ApiMaterialsV1MaterialOriginsRetrieveParams,
  ApiMaterialsV1MaterialProductsCreate400,
  ApiMaterialsV1MaterialProductsUpdate400,
  ApiMaterialsV1MaterialsListParams,
  ApiMaterialsV1MaterialsSupportedComponentsRetrieve400,
  ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams,
  ApiOrdersV1PurchaseOrdersCreate400,
  ApiOrdersV1PurchaseOrdersUpdatePartialUpdate400,
  ApiOrdersV1SalesOrdersCreate400,
  ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate400,
  ApiOrdersV1SalesOrdersRetrieve400,
  ApiOrdersV1SalesOrdersUpdatePartialUpdate400,
  ApiPostDealTrackerV1CarriersRetrieveParams,
  ApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate400,
  ApiQualityAiFeedbackV1EvidenceFeedbackCreate400,
  ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams,
  ApiQualityAiFeedbackV1FeedbackUpdate400,
  ApiQualityAnalyticsV1QualityKpisRetrieveParams,
  ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams,
  ApiQualityAnalyticsV1QualityStatsRetrieveParams,
  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate400,
  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate400,
  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams,
  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams,
  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate400,
  ApiQualityClaimsV1ClaimsCreate400,
  ApiQualityClaimsV1ClaimsListParams,
  ApiQualityClaimsV1ClaimsUpdate400,
  ApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate400,
  ApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate400,
  ApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate400,
  ApiQualityExternalLoadsV1ExternalLoadsCreate400,
  ApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate400,
  ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams,
  ApiQualityExternalLoadsV1ExternalLoadsImportCreate400,
  ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400,
  ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams,
  ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams,
  ApiQualityExternalLoadsV1ExternalLoadsUpdate400,
  ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams,
  ApiQualityExternalLoadsV1MaterialQualityCategoriesCreate400,
  ApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate400,
  ApiQualityExternalLoadsV1MaterialQualityCategoriesUpdate400,
  ApiQualityExternalLoadsV1ProductCodesCreate400,
  ApiQualityExternalLoadsV1ProductCodesUpdate400,
  ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams,
  ApiQualityExternalUploadV1Create400,
  ApiQualityExternalUploadV1EvidenceBulkDeleteCreate400,
  ApiQualityExternalUploadV1EvidenceListParams,
  ApiQualityExternalUploadV1EvidenceUploadCreate400,
  ApiQualityExternalUploadV1EvidenceUploadUpdate400,
  ApiQualityInstructionsV1SpecificationsListParams,
  ApiQualityMaterialQualityCategoriesV1ListParams,
  ApiQualityProductCodesV1ListParams,
  ApiQualityProductionV1BatchesListParams,
  ApiQualityProductionV1BaysCreate400,
  ApiQualityProductionV1BaysListParams,
  ApiQualityProductionV1BaysReorderBatchesCreate400,
  ApiQualityProductionV1BaysUpdate400,
  ApiQualityProductionV1ConfigurationPartialUpdate400,
  ApiQualityProductionV1PickingListsListParams,
  ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams,
  ApiQualityProductionV1ProcessedBalesListParams,
  ApiQualityProductionV1ProcessingSummaryParams,
  ApiQualityProductionV1ProductionHistoryBalesParams,
  ApiQualityProductionV1ProductionHistoryCompositionParams,
  ApiQualityProductionV1ProductionHistoryParams,
  ApiQualityProductionV1ProductionWindowPickRecommendationsParams,
  ApiQualityProductionV1ProductionWindowProcessedCompositionParams,
  ApiQualityProductionV1ProductionWindowsListParams,
  ApiQualityProductionV1RejectedBalesListParams,
  ApiQualityProductionV1SkippedPicksHistoryParams,
  ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams,
  ApiQualityProductionV1ZonesCreate400,
  ApiQualityProductionV1ZonesListParams,
  ApiQualityProductionV1ZonesPartialUpdate400,
  ApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate400,
  ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams,
  ApiQualitySessionsV1TradeCompanySessionsPartialUpdate400,
  ApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate400,
  ApiQualitySessionsV2TradeCompanySessionEvidenceListParams,
  ApiQualitySpecificationsV1SpecificationsCreate400,
  ApiQualitySpecificationsV1SpecificationsUpdate400,
  ApiQualitySuppliersV1SuppliersCreate400,
  ApiQualitySuppliersV1SuppliersListParams,
  ApiQualitySuppliersV1SuppliersUpdate400,
  ApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate400,
  ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
  ApiTicketsV1FindListParams,
  ApiTradeV1BuyerMaterialSpecificationsCreate400,
  ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate400,
  ApiTradeV1BuyerMaterialSpecificationsUpdate400,
  ApiTradeV1PackagingSpecificationsUpdate400,
  ApiTradeV1SiteMaterialsCreate400,
  ApiTradeV1SiteMaterialsUpdate400,
  ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400,
  ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
  ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
  ApiTradeV1TradeCompaniesCreate400,
  ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
  ApiTradeV1TradeCompaniesListParams,
  ApiTradeV1TradeCompaniesPackagingSpecificationsCreate400,
  ApiTradeV1TradeCompaniesPaymentTermsListParams,
  ApiTradeV1TradeCompaniesSessionsExportRetrieveParams,
  ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
  ApiTradeV1TradeCompanyLeadsListParams,
  ApiTradeV1TradeSitesListParams,
  ApiTradeV2TradeCompaniesSessionsListParams,
  ApiTransportPricesV1EstimateCreate400,
  ApiTransportPricesV1TransitTimeEstimateCreate400,
  ApiV1OmnisearchParams,
  ApiV1SalesOrderDocumentListExternalParams,
  AssignedAccountManagersResponse,
  BaleLoadedRequestBody,
  BankDetails,
  BatchListResponse,
  BatchReorderDTO,
  BayCreateDTO,
  BayListItem,
  BayListResponse,
  BayUpdateDTO,
  BayWithBatches,
  BulkDeleteRequest,
  BulkQualityStatsResponse,
  BulkRefreshOceanRatesInput,
  BulkRefreshOceanRatesOutput,
  BuyerEvidenceRequestCreateDTO,
  BuyerEvidenceRequestDetailForSupplier,
  BuyerEvidenceRequestDetailResponse,
  BuyerEvidenceRequestOrderReferenceOptionsResponse,
  BuyerEvidenceRequestUpdateDTO,
  BuyerMaterialSpecificationsListResponse,
  CameraAdvancedSettingsDTO,
  CarrierList,
  CategoryTargetSpecSetRequest,
  CategoryTargetSpecSetResponse,
  ChatRequest,
  ClaimCreateResponse,
  ClaimDetailResponse,
  ClaimPDFStatusResponse,
  ClaimUpdateDTO,
  CopyEvidenceToTestCompanyRequest,
  CreateBuyerMaterialSpecificationResponse,
  CreateClaimDTO,
  CreateDealDTO,
  CreateExternalUpload,
  CreateInspection,
  CreateMaterialProductDTO,
  CreateMaterialProductOutput,
  CreatePackagingSpecificationDTO,
  CreatePackagingSpecificationsResponse,
  CreatePurchaseOrderDTO,
  CreateRequest,
  CreateSalesOrderDTO,
  CreateSiteMaterialDTO,
  CreateSiteMaterialResponse,
  CreateSupportTicket,
  CurrentShiftSummary,
  CustomUserInfoDTO,
  Deal,
  DealCreateResponse,
  DocumentContextURLOutput,
  DocumentCreate,
  DocumentInfo,
  DocumentPreSignedURLInput,
  DocumentPreSignedURLOutput,
  DocumentSigningURLResponse,
  DocumentUpload,
  ErrorResponse,
  Event,
  Evidence,
  EvidenceDetail,
  EvidenceSessionDetails,
  ExternalInspection,
  ExternalLoadBulkAssignCategoryRequest,
  ExternalLoadBulkCombinedCompositionsRequest,
  ExternalLoadBulkCombinedCompositionsResponse,
  ExternalLoadBulkDeleteRequest,
  ExternalLoadCreateDTO,
  ExternalLoadCreateResponse,
  ExternalLoadDetails,
  ExternalLoadFieldOptionsResponse,
  ExternalLoadGeneratePDFRequest,
  ExternalLoadImportRequest,
  ExternalLoadImportResponse,
  ExternalLoadPDFStatusResponse,
  ExternalLoadPreferencesDTO,
  ExternalLoadUpdateDTO,
  ExternalUploadWithUser,
  FullBuyerMaterialSpecification,
  FullPurchaseOrderInfo,
  FullSalesOrderInfo,
  FullTradeCompany,
  FullTradeCompanySession,
  GeneratePDFInput,
  GeneratePDFOutput,
  GeneratePDFResponse,
  GenerateUploadUrlRequest,
  GenerateUploadUrlResponse,
  Input,
  Inspection,
  InvalidateCompositionCacheRequest,
  InvalidateCompositionCacheResponse,
  InvoiceLineItemCost,
  ListResponse,
  LoadSupplierProductCodeResponse,
  LoadSuppliersResponse,
  ManuallyMarkPartyAsSigned,
  Material,
  MaterialColourList,
  MaterialFormList,
  MaterialGradeList,
  MaterialOriginList,
  MaterialProductInfoDetails,
  MaterialQualityCategoryCreateDTO,
  MaterialQualityCategoryCreateResponse,
  MaterialQualityCategoryDetail,
  MaterialQualityCategoryListResponse,
  MaterialQualityCategoryUpdateDTO,
  MaterialRegionList,
  MaterialSupportedComponentList,
  MoveBatchRequest,
  MoveBatchResponse,
  OmnisearchResponse,
  PackagingSpecificationsListResponse,
  PaginatedAllowedMaterialSpecList,
  PaginatedBankDetailsList,
  PaginatedClaimListList,
  PaginatedDealChoicesList,
  PaginatedDocumentInfoList,
  PaginatedEvidenceList,
  PaginatedExternalCustomerDocumentList,
  PaginatedExternalLoadListItemList,
  PaginatedFullPurchaseOrderInfoList,
  PaginatedFullSalesOrderInfoList,
  PaginatedGetTicketsOutputList,
  PaginatedListInspectionList,
  PaginatedMaterialList,
  PaginatedMaterialProductInfoListItemList,
  PaginatedPortList,
  PaginatedProcessedBaleWithLoadInfoList,
  PaginatedPurchaserLoadSummaryDTOList,
  PaginatedPurchaserSalesOrderSummaryDTOList,
  PaginatedPurchaserShipmentSummaryDTOList,
  PaginatedRejectedBaleListItemList,
  PaginatedShipmentInfoList,
  PaginatedSimpleCompanyPaymentTermsList,
  PaginatedSimpleLoadList,
  PaginatedSimpleTradeCompanyLeadListItemList,
  PaginatedSimpleTradeCompanyListItemList,
  PaginatedSimpleTradeSiteListItemList,
  PaginatedSpecificationListItemList,
  PaginatedSupplierListItemList,
  PaginatedTradeCompanySessionListItemList,
  PartnerSignIn,
  PartnerSignInResult,
  PartnerSignInVerify,
  PartnerSignInVerifyResult,
  PatchedBulkUpdateData,
  PatchedCustomerUpdateSalesOrderDTO,
  PatchedDeal,
  PatchedDocumentUpdate,
  PatchedEvidenceData,
  PatchedInspection,
  PatchedPickingListPatchRequest,
  PatchedProcessedBaleUpdateDTO,
  PatchedProductionConfigurationUpdateDTO,
  PatchedShipmentUpdate,
  PatchedTradeCompanySessionUpdateDTO,
  PatchedUpdatePurchaseOrderDTO,
  PatchedUpdateRequest,
  PatchedUpdateSalesOrderDTO,
  PatchedUpdateUser,
  PatchedZoneUpdateDTO,
  PickRecommendationsResponse,
  PickingListConflict,
  PickingListCreateRequest,
  PickingListGeneratePDFRequest,
  PickingListGeneratePDFResponse,
  PickingListPDFStatusResponse,
  PickingListPatchResult,
  PickingListResponse,
  PickingListWithItems,
  PointToPointTransportCostBreakdownResultDTO,
  Port,
  PreSignedURLInput,
  PreSignedURLOutput,
  ProcessBalesRequest,
  ProcessBalesResponse,
  ProcessStagedBaleRequest,
  ProcessStagedBaleResponse,
  ProcessUploadRequest,
  ProcessUploadResponse,
  ProcessedBaleWithLoadInfo,
  ProcessedCompositionBreakdown,
  ProcessingSummary,
  ProductCodeCreateDTO,
  ProductCodeCreateResponse,
  ProductCodeDetail,
  ProductCodeListResponse,
  ProductCodeUpdateDTO,
  ProductionConfiguration,
  ProductionHistory,
  ProductionLineListResponse,
  ProductionShiftListResponse,
  ProductionWindowDetail,
  PurchaseOrdersListParams,
  PurchaserPipelineTable,
  PushSubscriptionInput,
  QualityKPIsResponse,
  QualityStatsResponse,
  ReceivableInvoiceLineItemRevenue,
  RecordSkippedPickRequest,
  RecordSkippedPickResponse,
  RecordStorageRecommendationOutcomeRequest,
  RecordStorageRecommendationOutcomeResponse,
  RejectBalesRequest,
  RejectBalesResponse,
  RejectStagedBaleRequest,
  RejectStagedBaleResponse,
  ResyncFeedbackToSuperviselyRequestDTO,
  ResyncFeedbackToSuperviselyResponseDTO,
  SalesOrderListParams,
  SelfExportPurchaserSummariesRequest,
  SelfExportPurchaserSummariesResponse,
  SendSigningEmailResponse,
  ShipmentCreate,
  ShipmentInfo,
  SignIn,
  SignInResult,
  SignInVerify,
  SignInVerifyResult,
  SignOutResult,
  SignUp,
  SignUpResult,
  SignUpVerify,
  SignUpVerifyResult,
  SimpleExternalUploadDTO,
  SimpleMaterialComponent,
  SimplePickingList,
  SimpleResponse,
  SimpleSalesOrder,
  SimpleSigningParty,
  SimpleTradeSiteListResponse,
  SimpleUserNotificationPreference,
  SiteMaterialDetail,
  SiteMaterialListResponse,
  SiteWithTradeCompany,
  SkippedPickHistory,
  SpecificationCreateDTO,
  SpecificationCreateResponse,
  SpecificationDetail,
  SpecificationUpdateDTO,
  StaffExportPurchaserSummariesRequest,
  StaffExportPurchaserSummariesResponse,
  StageBaleRequest,
  StageBaleResponse,
  StageBalesRequest,
  StageBalesResponse,
  StagedBaleListItem,
  StartCopyEvidenceToTestCompanyJobResponseDTO,
  StartEvidenceRerunJobRequestDTO,
  StartEvidenceRerunJobResponseDTO,
  StorageRecommendationOutcomeHistory,
  StorageRecommendationsResponse,
  SupplierCreateDTO,
  SupplierCreateResponse,
  SupplierListItem,
  SupplierUpdateDTO,
  TakeBaleResponse,
  Ticket,
  TradeCompanyCreateEndUser,
  TradeCompanyCreateResponse,
  TradeCompanyEmployeesListResponse,
  TradeCompanySessionCreateDTO,
  TradeCompanySessionCreateResponse,
  TradeCompanySessionCreatorsResponse,
  TransactionHistoryResponseDTO,
  TransitTimeEstimateInput,
  TransitTimeEstimateResultDTO,
  TransportCostEstimateInput,
  UpdateDemoCompanyDataResponse,
  UpdateMaterialProductDTO,
  UpdateMaterialProductOutput,
  UpdatePackagingSpecificationDTO,
  UpdateSiteMaterialDTO,
  UpsertBuyerMaterialSpecification,
  UserNotificationPreferenceUpdate,
  WarehouseOverviewResponse,
  WarmCompositionCacheRequest,
  WarmCompositionCacheResponse,
  WeightUnit,
  ZoneCreateDTO,
  ZoneListItem,
  ZoneListResponse,
  _ShiftSchedule
} from '../../schemas';

import { customAxios } from '../../custom-instance';
import type { ErrorType , BodyType } from '../../custom-instance';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Notify account manager in Slack.
 */
export const apiAccountsV1AccountManagerNotifyCreate = (
    accountManagerId: number,
    accountManagerNotifyRequest: BodyType<AccountManagerNotifyRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/accounts/v1/account-manager/${accountManagerId}/notify/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountManagerNotifyRequest, signal
    },
      options);
    }




export const getApiAccountsV1AccountManagerNotifyCreateMutationOptions = <TError = ErrorType<ApiAccountsV1AccountManagerNotifyCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>, TError,{accountManagerId: number;data: BodyType<AccountManagerNotifyRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>, TError,{accountManagerId: number;data: BodyType<AccountManagerNotifyRequest>}, TContext> => {

const mutationKey = ['apiAccountsV1AccountManagerNotifyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>, {accountManagerId: number;data: BodyType<AccountManagerNotifyRequest>}> = (props) => {
          const {accountManagerId,data} = props ?? {};

          return  apiAccountsV1AccountManagerNotifyCreate(accountManagerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1AccountManagerNotifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>>
    export type ApiAccountsV1AccountManagerNotifyCreateMutationBody = BodyType<AccountManagerNotifyRequest>
    export type ApiAccountsV1AccountManagerNotifyCreateMutationError = ErrorType<ApiAccountsV1AccountManagerNotifyCreate400>

    export const useApiAccountsV1AccountManagerNotifyCreate = <TError = ErrorType<ApiAccountsV1AccountManagerNotifyCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>, TError,{accountManagerId: number;data: BodyType<AccountManagerNotifyRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1AccountManagerNotifyCreate>>,
        TError,
        {accountManagerId: number;data: BodyType<AccountManagerNotifyRequest>},
        TContext
      > => {
      return useMutation(getApiAccountsV1AccountManagerNotifyCreateMutationOptions(options), queryClient);
    }
    /**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiAccountsV1BankDetailsList = (
    params?: ApiAccountsV1BankDetailsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedBankDetailsList>(
      {url: `/api/accounts/v1/bank-details/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiAccountsV1BankDetailsListQueryKey = (params?: ApiAccountsV1BankDetailsListParams,) => {
    return [
    `/api/accounts/v1/bank-details/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiAccountsV1BankDetailsListQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiAccountsV1BankDetailsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1BankDetailsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>> = ({ signal }) => apiAccountsV1BankDetailsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1BankDetailsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>>
export type ApiAccountsV1BankDetailsListQueryError = ErrorType<ErrorResponse>


export function useApiAccountsV1BankDetailsList<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiAccountsV1BankDetailsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1BankDetailsList<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiAccountsV1BankDetailsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1BankDetailsList<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiAccountsV1BankDetailsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1BankDetailsList<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiAccountsV1BankDetailsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1BankDetailsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAccountsV1BankDetailsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiAccountsV1BankDetailsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1BankDetailsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>> = ({ signal }) => apiAccountsV1BankDetailsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1BankDetailsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>>
export type ApiAccountsV1BankDetailsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiAccountsV1BankDetailsListSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiAccountsV1BankDetailsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1BankDetailsListSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiAccountsV1BankDetailsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1BankDetailsListSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiAccountsV1BankDetailsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1BankDetailsListSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiAccountsV1BankDetailsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1BankDetailsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiAccountsV1BankDetailsRetrieve = (
    bankDetailsId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BankDetails>(
      {url: `/api/accounts/v1/bank-details/${bankDetailsId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiAccountsV1BankDetailsRetrieveQueryKey = (bankDetailsId: number,) => {
    return [
    `/api/accounts/v1/bank-details/${bankDetailsId}/`
    ] as const;
    }


export const getApiAccountsV1BankDetailsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(bankDetailsId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1BankDetailsRetrieveQueryKey(bankDetailsId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>> = ({ signal }) => apiAccountsV1BankDetailsRetrieve(bankDetailsId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: bankDetailsId !== null && bankDetailsId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1BankDetailsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>>
export type ApiAccountsV1BankDetailsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiAccountsV1BankDetailsRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bankDetailsId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1BankDetailsRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bankDetailsId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1BankDetailsRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bankDetailsId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1BankDetailsRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bankDetailsId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1BankDetailsRetrieveQueryOptions(bankDetailsId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAccountsV1BankDetailsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(bankDetailsId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1BankDetailsRetrieveQueryKey(bankDetailsId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>> = ({ signal }) => apiAccountsV1BankDetailsRetrieve(bankDetailsId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1BankDetailsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>>
export type ApiAccountsV1BankDetailsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiAccountsV1BankDetailsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bankDetailsId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1BankDetailsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bankDetailsId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1BankDetailsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bankDetailsId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1BankDetailsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bankDetailsId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1BankDetailsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1BankDetailsRetrieveSuspenseQueryOptions(bankDetailsId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update the current user's company preferred weight unit.
 */
export const apiAccountsV1CompanyWeightUnitUpdate = (
    weightUnit: BodyType<WeightUnit>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<WeightUnit>(
      {url: `/api/accounts/v1/company/weight-unit/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: weightUnit, signal
    },
      options);
    }




export const getApiAccountsV1CompanyWeightUnitUpdateMutationOptions = <TError = ErrorType<ApiAccountsV1CompanyWeightUnitUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1CompanyWeightUnitUpdate>>, TError,{data: BodyType<WeightUnit>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1CompanyWeightUnitUpdate>>, TError,{data: BodyType<WeightUnit>}, TContext> => {

const mutationKey = ['apiAccountsV1CompanyWeightUnitUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1CompanyWeightUnitUpdate>>, {data: BodyType<WeightUnit>}> = (props) => {
          const {data} = props ?? {};

          return  apiAccountsV1CompanyWeightUnitUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1CompanyWeightUnitUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1CompanyWeightUnitUpdate>>>
    export type ApiAccountsV1CompanyWeightUnitUpdateMutationBody = BodyType<WeightUnit>
    export type ApiAccountsV1CompanyWeightUnitUpdateMutationError = ErrorType<ApiAccountsV1CompanyWeightUnitUpdate400 | ErrorResponse>

    export const useApiAccountsV1CompanyWeightUnitUpdate = <TError = ErrorType<ApiAccountsV1CompanyWeightUnitUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1CompanyWeightUnitUpdate>>, TError,{data: BodyType<WeightUnit>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1CompanyWeightUnitUpdate>>,
        TError,
        {data: BodyType<WeightUnit>},
        TContext
      > => {
      return useMutation(getApiAccountsV1CompanyWeightUnitUpdateMutationOptions(options), queryClient);
    }
    /**
 * Starts partner OTP flow for email.
 */
export const apiAccountsV1PartnerSigninRequestCreate = (
    partnerSignIn: BodyType<PartnerSignIn>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PartnerSignInResult>(
      {url: `/api/accounts/v1/partner/signin/request/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: partnerSignIn, signal
    },
      options);
    }




export const getApiAccountsV1PartnerSigninRequestCreateMutationOptions = <TError = ErrorType<ApiAccountsV1PartnerSigninRequestCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninRequestCreate>>, TError,{data: BodyType<PartnerSignIn>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninRequestCreate>>, TError,{data: BodyType<PartnerSignIn>}, TContext> => {

const mutationKey = ['apiAccountsV1PartnerSigninRequestCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninRequestCreate>>, {data: BodyType<PartnerSignIn>}> = (props) => {
          const {data} = props ?? {};

          return  apiAccountsV1PartnerSigninRequestCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1PartnerSigninRequestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninRequestCreate>>>
    export type ApiAccountsV1PartnerSigninRequestCreateMutationBody = BodyType<PartnerSignIn>
    export type ApiAccountsV1PartnerSigninRequestCreateMutationError = ErrorType<ApiAccountsV1PartnerSigninRequestCreate400 | ErrorResponse>

    export const useApiAccountsV1PartnerSigninRequestCreate = <TError = ErrorType<ApiAccountsV1PartnerSigninRequestCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninRequestCreate>>, TError,{data: BodyType<PartnerSignIn>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1PartnerSigninRequestCreate>>,
        TError,
        {data: BodyType<PartnerSignIn>},
        TContext
      > => {
      return useMutation(getApiAccountsV1PartnerSigninRequestCreateMutationOptions(options), queryClient);
    }
    /**
 * Checks partner email verification code and creates a user if needed.
 */
export const apiAccountsV1PartnerSigninVerifyCreate = (
    partnerSignInVerify: BodyType<PartnerSignInVerify>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PartnerSignInVerifyResult>(
      {url: `/api/accounts/v1/partner/signin/verify/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: partnerSignInVerify, signal
    },
      options);
    }




export const getApiAccountsV1PartnerSigninVerifyCreateMutationOptions = <TError = ErrorType<ApiAccountsV1PartnerSigninVerifyCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninVerifyCreate>>, TError,{data: BodyType<PartnerSignInVerify>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninVerifyCreate>>, TError,{data: BodyType<PartnerSignInVerify>}, TContext> => {

const mutationKey = ['apiAccountsV1PartnerSigninVerifyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninVerifyCreate>>, {data: BodyType<PartnerSignInVerify>}> = (props) => {
          const {data} = props ?? {};

          return  apiAccountsV1PartnerSigninVerifyCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1PartnerSigninVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninVerifyCreate>>>
    export type ApiAccountsV1PartnerSigninVerifyCreateMutationBody = BodyType<PartnerSignInVerify>
    export type ApiAccountsV1PartnerSigninVerifyCreateMutationError = ErrorType<ApiAccountsV1PartnerSigninVerifyCreate400>

    export const useApiAccountsV1PartnerSigninVerifyCreate = <TError = ErrorType<ApiAccountsV1PartnerSigninVerifyCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1PartnerSigninVerifyCreate>>, TError,{data: BodyType<PartnerSignInVerify>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1PartnerSigninVerifyCreate>>,
        TError,
        {data: BodyType<PartnerSignInVerify>},
        TContext
      > => {
      return useMutation(getApiAccountsV1PartnerSigninVerifyCreateMutationOptions(options), queryClient);
    }
    export const apiAccountsV1PortsList = (
    params?: ApiAccountsV1PortsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedPortList>(
      {url: `/api/accounts/v1/ports/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiAccountsV1PortsListQueryKey = (params?: ApiAccountsV1PortsListParams,) => {
    return [
    `/api/accounts/v1/ports/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiAccountsV1PortsListQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(params?: ApiAccountsV1PortsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1PortsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1PortsList>>> = ({ signal }) => apiAccountsV1PortsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1PortsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PortsList>>>
export type ApiAccountsV1PortsListQueryError = ErrorType<unknown>


export function useApiAccountsV1PortsList<TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiAccountsV1PortsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1PortsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1PortsList<TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(
 params?: ApiAccountsV1PortsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1PortsList>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1PortsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1PortsList<TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(
 params?: ApiAccountsV1PortsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1PortsList<TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(
 params?: ApiAccountsV1PortsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1PortsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAccountsV1PortsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(params?: ApiAccountsV1PortsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1PortsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1PortsList>>> = ({ signal }) => apiAccountsV1PortsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1PortsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PortsList>>>
export type ApiAccountsV1PortsListSuspenseQueryError = ErrorType<unknown>


export function useApiAccountsV1PortsListSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiAccountsV1PortsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1PortsListSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(
 params?: ApiAccountsV1PortsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1PortsListSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(
 params?: ApiAccountsV1PortsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1PortsListSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError = ErrorType<unknown>>(
 params?: ApiAccountsV1PortsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1PortsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiAccountsV1PortsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Port>(
      {url: `/api/accounts/v1/ports/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiAccountsV1PortsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/accounts/v1/ports/${id}/`
    ] as const;
    }


export const getApiAccountsV1PortsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1PortsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>> = ({ signal }) => apiAccountsV1PortsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1PortsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>>
export type ApiAccountsV1PortsRetrieveQueryError = ErrorType<unknown>


export function useApiAccountsV1PortsRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1PortsRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1PortsRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1PortsRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1PortsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAccountsV1PortsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1PortsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>> = ({ signal }) => apiAccountsV1PortsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1PortsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>>
export type ApiAccountsV1PortsRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiAccountsV1PortsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1PortsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1PortsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1PortsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1PortsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1PortsRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Starts OTP flow for either email or phone depending on whats provided.
 */
export const apiAccountsV1SigninRequestCreate = (
    signIn?: BodyType<SignIn>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SignInResult>(
      {url: `/api/accounts/v1/signin/request/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signIn, signal
    },
      options);
    }




export const getApiAccountsV1SigninRequestCreateMutationOptions = <TError = ErrorType<ApiAccountsV1SigninRequestCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>, TError,{data?: BodyType<SignIn>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>, TError,{data?: BodyType<SignIn>}, TContext> => {

const mutationKey = ['apiAccountsV1SigninRequestCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>, {data?: BodyType<SignIn>}> = (props) => {
          const {data} = props ?? {};

          return  apiAccountsV1SigninRequestCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1SigninRequestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>>
    export type ApiAccountsV1SigninRequestCreateMutationBody = BodyType<SignIn> | undefined
    export type ApiAccountsV1SigninRequestCreateMutationError = ErrorType<ApiAccountsV1SigninRequestCreate400 | ErrorResponse>

    export const useApiAccountsV1SigninRequestCreate = <TError = ErrorType<ApiAccountsV1SigninRequestCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>, TError,{data?: BodyType<SignIn>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1SigninRequestCreate>>,
        TError,
        {data?: BodyType<SignIn>},
        TContext
      > => {
      return useMutation(getApiAccountsV1SigninRequestCreateMutationOptions(options), queryClient);
    }
    /**
 * Checks email/phone verification code.
 */
export const apiAccountsV1SigninVerifyCreate = (
    signInVerify: BodyType<SignInVerify>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SignInVerifyResult>(
      {url: `/api/accounts/v1/signin/verify/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signInVerify, signal
    },
      options);
    }




export const getApiAccountsV1SigninVerifyCreateMutationOptions = <TError = ErrorType<ApiAccountsV1SigninVerifyCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>, TError,{data: BodyType<SignInVerify>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>, TError,{data: BodyType<SignInVerify>}, TContext> => {

const mutationKey = ['apiAccountsV1SigninVerifyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>, {data: BodyType<SignInVerify>}> = (props) => {
          const {data} = props ?? {};

          return  apiAccountsV1SigninVerifyCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1SigninVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>>
    export type ApiAccountsV1SigninVerifyCreateMutationBody = BodyType<SignInVerify>
    export type ApiAccountsV1SigninVerifyCreateMutationError = ErrorType<ApiAccountsV1SigninVerifyCreate400>

    export const useApiAccountsV1SigninVerifyCreate = <TError = ErrorType<ApiAccountsV1SigninVerifyCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>, TError,{data: BodyType<SignInVerify>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1SigninVerifyCreate>>,
        TError,
        {data: BodyType<SignInVerify>},
        TContext
      > => {
      return useMutation(getApiAccountsV1SigninVerifyCreateMutationOptions(options), queryClient);
    }
    /**
 * Logs out the user.
 */
export const apiAccountsV1SignoutCreate = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SignOutResult>(
      {url: `/api/accounts/v1/signout/`, method: 'POST', signal
    },
      options);
    }




export const getApiAccountsV1SignoutCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, TError,void, TContext> => {

const mutationKey = ['apiAccountsV1SignoutCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, void> = () => {


          return  apiAccountsV1SignoutCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1SignoutCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>>

    export type ApiAccountsV1SignoutCreateMutationError = ErrorType<ErrorResponse>

    export const useApiAccountsV1SignoutCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1SignoutCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getApiAccountsV1SignoutCreateMutationOptions(options), queryClient);
    }
    /**
 * Registers a new user.
 */
export const apiAccountsV1SignupRequestCreate = (
    signUp: BodyType<SignUp>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SignUpResult>(
      {url: `/api/accounts/v1/signup/request/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signUp, signal
    },
      options);
    }




export const getApiAccountsV1SignupRequestCreateMutationOptions = <TError = ErrorType<ApiAccountsV1SignupRequestCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>, TError,{data: BodyType<SignUp>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>, TError,{data: BodyType<SignUp>}, TContext> => {

const mutationKey = ['apiAccountsV1SignupRequestCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>, {data: BodyType<SignUp>}> = (props) => {
          const {data} = props ?? {};

          return  apiAccountsV1SignupRequestCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1SignupRequestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>>
    export type ApiAccountsV1SignupRequestCreateMutationBody = BodyType<SignUp>
    export type ApiAccountsV1SignupRequestCreateMutationError = ErrorType<ApiAccountsV1SignupRequestCreate400>

    export const useApiAccountsV1SignupRequestCreate = <TError = ErrorType<ApiAccountsV1SignupRequestCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>, TError,{data: BodyType<SignUp>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1SignupRequestCreate>>,
        TError,
        {data: BodyType<SignUp>},
        TContext
      > => {
      return useMutation(getApiAccountsV1SignupRequestCreateMutationOptions(options), queryClient);
    }
    /**
 * Verifies email verification code.
 */
export const apiAccountsV1SignupVerifyCreate = (
    signUpVerify: BodyType<SignUpVerify>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SignUpVerifyResult>(
      {url: `/api/accounts/v1/signup/verify/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signUpVerify, signal
    },
      options);
    }




export const getApiAccountsV1SignupVerifyCreateMutationOptions = <TError = ErrorType<ApiAccountsV1SignupVerifyCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>, TError,{data: BodyType<SignUpVerify>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>, TError,{data: BodyType<SignUpVerify>}, TContext> => {

const mutationKey = ['apiAccountsV1SignupVerifyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>, {data: BodyType<SignUpVerify>}> = (props) => {
          const {data} = props ?? {};

          return  apiAccountsV1SignupVerifyCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1SignupVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>>
    export type ApiAccountsV1SignupVerifyCreateMutationBody = BodyType<SignUpVerify>
    export type ApiAccountsV1SignupVerifyCreateMutationError = ErrorType<ApiAccountsV1SignupVerifyCreate400>

    export const useApiAccountsV1SignupVerifyCreate = <TError = ErrorType<ApiAccountsV1SignupVerifyCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>, TError,{data: BodyType<SignUpVerify>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1SignupVerifyCreate>>,
        TError,
        {data: BodyType<SignUpVerify>},
        TContext
      > => {
      return useMutation(getApiAccountsV1SignupVerifyCreateMutationOptions(options), queryClient);
    }
    /**
 * Returns the current user's information.
 */
export const apiAccountsV1UserRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CustomUserInfoDTO>(
      {url: `/api/accounts/v1/user/`, method: 'GET', signal
    },
      options);
    }




export const getApiAccountsV1UserRetrieveQueryKey = () => {
    return [
    `/api/accounts/v1/user/`
    ] as const;
    }


export const getApiAccountsV1UserRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1UserRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>> = ({ signal }) => apiAccountsV1UserRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1UserRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>>
export type ApiAccountsV1UserRetrieveQueryError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>


export function useApiAccountsV1UserRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1UserRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1UserRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1UserRetrieve<TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1UserRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiAccountsV1UserRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAccountsV1UserRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>> = ({ signal }) => apiAccountsV1UserRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAccountsV1UserRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>>
export type ApiAccountsV1UserRetrieveSuspenseQueryError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>


export function useApiAccountsV1UserRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1UserRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAccountsV1UserRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiAccountsV1UserRetrieveSuspense<TData = Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError = ErrorType<ApiAccountsV1UserRetrieve400 | ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiAccountsV1UserRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAccountsV1UserRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update the current user's language preference.
 */
export const apiAccountsV1UserPartialUpdate = (
    patchedUpdateUser?: BodyType<PatchedUpdateUser>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CustomUserInfoDTO>(
      {url: `/api/accounts/v1/user/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedUpdateUser, signal
    },
      options);
    }




export const getApiAccountsV1UserPartialUpdateMutationOptions = <TError = ErrorType<ApiAccountsV1UserPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1UserPartialUpdate>>, TError,{data?: BodyType<PatchedUpdateUser>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1UserPartialUpdate>>, TError,{data?: BodyType<PatchedUpdateUser>}, TContext> => {

const mutationKey = ['apiAccountsV1UserPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAccountsV1UserPartialUpdate>>, {data?: BodyType<PatchedUpdateUser>}> = (props) => {
          const {data} = props ?? {};

          return  apiAccountsV1UserPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiAccountsV1UserPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiAccountsV1UserPartialUpdate>>>
    export type ApiAccountsV1UserPartialUpdateMutationBody = BodyType<PatchedUpdateUser> | undefined
    export type ApiAccountsV1UserPartialUpdateMutationError = ErrorType<ApiAccountsV1UserPartialUpdate400 | ErrorResponse>

    export const useApiAccountsV1UserPartialUpdate = <TError = ErrorType<ApiAccountsV1UserPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAccountsV1UserPartialUpdate>>, TError,{data?: BodyType<PatchedUpdateUser>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAccountsV1UserPartialUpdate>>,
        TError,
        {data?: BodyType<PatchedUpdateUser>},
        TContext
      > => {
      return useMutation(getApiAccountsV1UserPartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * Run a data explorer query. Returns a newline-delimited JSON stream (application/x-ndjson). Each line is a JSON object with a `type` field: `token`, `tool_call`, `answer`, or `error`.
 */
export const apiDataExplorerV1ChatCreate = (
    chatRequest: BodyType<ChatRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Blob>(
      {url: `/api/data-explorer/v1/chat/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: chatRequest,
        responseType: 'blob', signal
    },
      options);
    }




export const getApiDataExplorerV1ChatCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDataExplorerV1ChatCreate>>, TError,{data: BodyType<ChatRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDataExplorerV1ChatCreate>>, TError,{data: BodyType<ChatRequest>}, TContext> => {

const mutationKey = ['apiDataExplorerV1ChatCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDataExplorerV1ChatCreate>>, {data: BodyType<ChatRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiDataExplorerV1ChatCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDataExplorerV1ChatCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDataExplorerV1ChatCreate>>>
    export type ApiDataExplorerV1ChatCreateMutationBody = BodyType<ChatRequest>
    export type ApiDataExplorerV1ChatCreateMutationError = ErrorType<void>

    export const useApiDataExplorerV1ChatCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDataExplorerV1ChatCreate>>, TError,{data: BodyType<ChatRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDataExplorerV1ChatCreate>>,
        TError,
        {data: BodyType<ChatRequest>},
        TContext
      > => {
      return useMutation(getApiDataExplorerV1ChatCreateMutationOptions(options), queryClient);
    }
    /**
 * Generate and download export files for your own company directly. Note: This endpoint does not use async tasks due to a debouncing issue that causes duplicate emails.
 * @summary Export purchaser summaries (self)
 */
export const apiDataV1ExportsPurchaserSummariesSelfCreate = (
    selfExportPurchaserSummariesRequest?: BodyType<SelfExportPurchaserSummariesRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SelfExportPurchaserSummariesResponse>(
      {url: `/api/data/v1/exports/purchaser-summaries/self/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfExportPurchaserSummariesRequest, signal
    },
      options);
    }




export const getApiDataV1ExportsPurchaserSummariesSelfCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>, TError,{data?: BodyType<SelfExportPurchaserSummariesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>, TError,{data?: BodyType<SelfExportPurchaserSummariesRequest>}, TContext> => {

const mutationKey = ['apiDataV1ExportsPurchaserSummariesSelfCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>, {data?: BodyType<SelfExportPurchaserSummariesRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiDataV1ExportsPurchaserSummariesSelfCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDataV1ExportsPurchaserSummariesSelfCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>>
    export type ApiDataV1ExportsPurchaserSummariesSelfCreateMutationBody = BodyType<SelfExportPurchaserSummariesRequest> | undefined
    export type ApiDataV1ExportsPurchaserSummariesSelfCreateMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Export purchaser summaries (self)
 */
export const useApiDataV1ExportsPurchaserSummariesSelfCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>, TError,{data?: BodyType<SelfExportPurchaserSummariesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesSelfCreate>>,
        TError,
        {data?: BodyType<SelfExportPurchaserSummariesRequest>},
        TContext
      > => {
      return useMutation(getApiDataV1ExportsPurchaserSummariesSelfCreateMutationOptions(options), queryClient);
    }
    /**
 * Schedule an export task for the specified purchaser.
 * @summary Export purchaser summaries (staff)
 */
export const apiDataV1ExportsPurchaserSummariesStaffCreate = (
    staffExportPurchaserSummariesRequest: BodyType<StaffExportPurchaserSummariesRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<StaffExportPurchaserSummariesResponse>(
      {url: `/api/data/v1/exports/purchaser-summaries/staff/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: staffExportPurchaserSummariesRequest, signal
    },
      options);
    }




export const getApiDataV1ExportsPurchaserSummariesStaffCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>, TError,{data: BodyType<StaffExportPurchaserSummariesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>, TError,{data: BodyType<StaffExportPurchaserSummariesRequest>}, TContext> => {

const mutationKey = ['apiDataV1ExportsPurchaserSummariesStaffCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>, {data: BodyType<StaffExportPurchaserSummariesRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiDataV1ExportsPurchaserSummariesStaffCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDataV1ExportsPurchaserSummariesStaffCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>>
    export type ApiDataV1ExportsPurchaserSummariesStaffCreateMutationBody = BodyType<StaffExportPurchaserSummariesRequest>
    export type ApiDataV1ExportsPurchaserSummariesStaffCreateMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Export purchaser summaries (staff)
 */
export const useApiDataV1ExportsPurchaserSummariesStaffCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>, TError,{data: BodyType<StaffExportPurchaserSummariesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDataV1ExportsPurchaserSummariesStaffCreate>>,
        TError,
        {data: BodyType<StaffExportPurchaserSummariesRequest>},
        TContext
      > => {
      return useMutation(getApiDataV1ExportsPurchaserSummariesStaffCreateMutationOptions(options), queryClient);
    }
    /**
 * Retrieves pipeline data for purchaser companies. Staff users can access any purchaser's data by providing purchaser_id. Non-staff users can only access their own company's data.
 * @summary Get pipeline data for purchaser companies
 */
export const apiDataV1PurchaserPipelineRetrieve = (
    params?: ApiDataV1PurchaserPipelineRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PurchaserPipelineTable>(
      {url: `/api/data/v1/purchaser-pipeline/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDataV1PurchaserPipelineRetrieveQueryKey = (params?: ApiDataV1PurchaserPipelineRetrieveParams,) => {
    return [
    `/api/data/v1/purchaser-pipeline/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDataV1PurchaserPipelineRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1PurchaserPipelineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1PurchaserPipelineRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>> = ({ signal }) => apiDataV1PurchaserPipelineRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1PurchaserPipelineRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>>
export type ApiDataV1PurchaserPipelineRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiDataV1PurchaserPipelineRetrieve<TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1PurchaserPipelineRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1PurchaserPipelineRetrieve<TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1PurchaserPipelineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1PurchaserPipelineRetrieve<TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1PurchaserPipelineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get pipeline data for purchaser companies
 */

export function useApiDataV1PurchaserPipelineRetrieve<TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1PurchaserPipelineRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1PurchaserPipelineRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDataV1PurchaserPipelineRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1PurchaserPipelineRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1PurchaserPipelineRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>> = ({ signal }) => apiDataV1PurchaserPipelineRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1PurchaserPipelineRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>>
export type ApiDataV1PurchaserPipelineRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDataV1PurchaserPipelineRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1PurchaserPipelineRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1PurchaserPipelineRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1PurchaserPipelineRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1PurchaserPipelineRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1PurchaserPipelineRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get pipeline data for purchaser companies
 */

export function useApiDataV1PurchaserPipelineRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1PurchaserPipelineRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1PurchaserPipelineRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1PurchaserPipelineRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesLoadsSelfList = (
    params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedPurchaserLoadSummaryDTOList>(
      {url: `/api/data/v1/views/purchaser-summaries/loads/self/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryKey = (params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams,) => {
    return [
    `/api/data/v1/views/purchaser-summaries/loads/self/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesLoadsSelfList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>>
export type ApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesLoadsSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesLoadsSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesLoadsSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesLoadsSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesLoadsSelfListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesLoadsSelfList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>>
export type ApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesLoadsSelfListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesLoadsStaffList = (
    params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedPurchaserLoadSummaryDTOList>(
      {url: `/api/data/v1/views/purchaser-summaries/loads/staff/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryKey = (params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams,) => {
    return [
    `/api/data/v1/views/purchaser-summaries/loads/staff/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesLoadsStaffList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>>
export type ApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesLoadsStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesLoadsStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesLoadsStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesLoadsStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesLoadsStaffListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesLoadsStaffList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>>
export type ApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesLoadsStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesLoadsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesLoadsStaffListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList = (
    params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedPurchaserSalesOrderSummaryDTOList>(
      {url: `/api/data/v1/views/purchaser-summaries/sales-orders/self/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryKey = (params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams,) => {
    return [
    `/api/data/v1/views/purchaser-summaries/sales-orders/self/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>>
export type ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>>
export type ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesSalesOrdersSelfListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList = (
    params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedPurchaserSalesOrderSummaryDTOList>(
      {url: `/api/data/v1/views/purchaser-summaries/sales-orders/staff/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryKey = (params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams,) => {
    return [
    `/api/data/v1/views/purchaser-summaries/sales-orders/staff/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>>
export type ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>>
export type ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesSalesOrdersStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesSalesOrdersStaffListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesShipmentsSelfList = (
    params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedPurchaserShipmentSummaryDTOList>(
      {url: `/api/data/v1/views/purchaser-summaries/shipments/self/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryKey = (params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams,) => {
    return [
    `/api/data/v1/views/purchaser-summaries/shipments/self/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesShipmentsSelfList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>>
export type ApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesShipmentsSelfListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesShipmentsSelfList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>>
export type ApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsSelfListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsSelfList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesShipmentsSelfListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDataV1ViewsPurchaserSummariesShipmentsStaffList = (
    params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedPurchaserShipmentSummaryDTOList>(
      {url: `/api/data/v1/views/purchaser-summaries/shipments/staff/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryKey = (params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams,) => {
    return [
    `/api/data/v1/views/purchaser-summaries/shipments/staff/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesShipmentsStaffList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>>
export type ApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>,
          TError,
          Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffList<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDataV1ViewsPurchaserSummariesShipmentsStaffListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>> = ({ signal }) => apiDataV1ViewsPurchaserSummariesShipmentsStaffList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>>
export type ApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspense<TData = Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDataV1ViewsPurchaserSummariesShipmentsStaffListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDataV1ViewsPurchaserSummariesShipmentsStaffList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDataV1ViewsPurchaserSummariesShipmentsStaffListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiDealsV1Create = (
    createDealDTO: BodyType<CreateDealDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DealCreateResponse>(
      {url: `/api/deals/v1/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDealDTO, signal
    },
      options);
    }




export const getApiDealsV1CreateMutationOptions = <TError = ErrorType<ApiDealsV1Create400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1Create>>, TError,{data: BodyType<CreateDealDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1Create>>, TError,{data: BodyType<CreateDealDTO>}, TContext> => {

const mutationKey = ['apiDealsV1Create'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDealsV1Create>>, {data: BodyType<CreateDealDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiDealsV1Create(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDealsV1CreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1Create>>>
    export type ApiDealsV1CreateMutationBody = BodyType<CreateDealDTO>
    export type ApiDealsV1CreateMutationError = ErrorType<ApiDealsV1Create400 | ErrorResponse>

    export const useApiDealsV1Create = <TError = ErrorType<ApiDealsV1Create400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1Create>>, TError,{data: BodyType<CreateDealDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDealsV1Create>>,
        TError,
        {data: BodyType<CreateDealDTO>},
        TContext
      > => {
      return useMutation(getApiDealsV1CreateMutationOptions(options), queryClient);
    }
    /**
 * Helper class that provides a standard way to create an ABC using
 * inheritance.
 */
export const apiDealsV1ApproveCreate = (
    dealId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleResponse>(
      {url: `/api/deals/v1/${dealId}/approve/`, method: 'POST', signal
    },
      options);
    }




export const getApiDealsV1ApproveCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>, TError,{dealId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>, TError,{dealId: number}, TContext> => {

const mutationKey = ['apiDealsV1ApproveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>, {dealId: number}> = (props) => {
          const {dealId} = props ?? {};

          return  apiDealsV1ApproveCreate(dealId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDealsV1ApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>>

    export type ApiDealsV1ApproveCreateMutationError = ErrorType<unknown>

    export const useApiDealsV1ApproveCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>, TError,{dealId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDealsV1ApproveCreate>>,
        TError,
        {dealId: number},
        TContext
      > => {
      return useMutation(getApiDealsV1ApproveCreateMutationOptions(options), queryClient);
    }
    export const apiDealsV1CostAposList = (
    dealId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<AccountingPurchaseOrderLineItemCost[]>(
      {url: `/api/deals/v1/${dealId}/cost_apos/`, method: 'GET', signal
    },
      options);
    }




export const getApiDealsV1CostAposListQueryKey = (dealId: number,) => {
    return [
    `/api/deals/v1/${dealId}/cost_apos/`
    ] as const;
    }


export const getApiDealsV1CostAposListQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1CostAposListQueryKey(dealId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1CostAposList>>> = ({ signal }) => apiDealsV1CostAposList(dealId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: dealId !== null && dealId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1CostAposListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1CostAposList>>>
export type ApiDealsV1CostAposListQueryError = ErrorType<unknown>


export function useApiDealsV1CostAposList<TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(
 dealId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1CostAposList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1CostAposList<TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1CostAposList>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1CostAposList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1CostAposList<TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1CostAposList<TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1CostAposListQueryOptions(dealId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDealsV1CostAposListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1CostAposListQueryKey(dealId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1CostAposList>>> = ({ signal }) => apiDealsV1CostAposList(dealId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1CostAposListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1CostAposList>>>
export type ApiDealsV1CostAposListSuspenseQueryError = ErrorType<unknown>


export function useApiDealsV1CostAposListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(
 dealId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1CostAposListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1CostAposListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1CostAposListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostAposList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1CostAposListSuspenseQueryOptions(dealId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiDealsV1CostsList = (
    dealId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<InvoiceLineItemCost[]>(
      {url: `/api/deals/v1/${dealId}/costs/`, method: 'GET', signal
    },
      options);
    }




export const getApiDealsV1CostsListQueryKey = (dealId: number,) => {
    return [
    `/api/deals/v1/${dealId}/costs/`
    ] as const;
    }


export const getApiDealsV1CostsListQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1CostsListQueryKey(dealId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1CostsList>>> = ({ signal }) => apiDealsV1CostsList(dealId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: dealId !== null && dealId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1CostsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1CostsList>>>
export type ApiDealsV1CostsListQueryError = ErrorType<unknown>


export function useApiDealsV1CostsList<TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(
 dealId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1CostsList>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1CostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1CostsList<TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1CostsList>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1CostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1CostsList<TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1CostsList<TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1CostsListQueryOptions(dealId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDealsV1CostsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1CostsListQueryKey(dealId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1CostsList>>> = ({ signal }) => apiDealsV1CostsList(dealId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1CostsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1CostsList>>>
export type ApiDealsV1CostsListSuspenseQueryError = ErrorType<unknown>


export function useApiDealsV1CostsListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(
 dealId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1CostsListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1CostsListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1CostsListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1CostsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1CostsListSuspenseQueryOptions(dealId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Helper class that provides a standard way to create an ABC using
 * inheritance.
 */
export const apiDealsV1HandOverCreate = (
    dealId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleResponse>(
      {url: `/api/deals/v1/${dealId}/hand-over/`, method: 'POST', signal
    },
      options);
    }




export const getApiDealsV1HandOverCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>, TError,{dealId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>, TError,{dealId: number}, TContext> => {

const mutationKey = ['apiDealsV1HandOverCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>, {dealId: number}> = (props) => {
          const {dealId} = props ?? {};

          return  apiDealsV1HandOverCreate(dealId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDealsV1HandOverCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>>

    export type ApiDealsV1HandOverCreateMutationError = ErrorType<unknown>

    export const useApiDealsV1HandOverCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>, TError,{dealId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDealsV1HandOverCreate>>,
        TError,
        {dealId: number},
        TContext
      > => {
      return useMutation(getApiDealsV1HandOverCreateMutationOptions(options), queryClient);
    }
    /**
 * Helper class that provides a standard way to create an ABC using
 * inheritance.
 */
export const apiDealsV1RejectCreate = (
    dealId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleResponse>(
      {url: `/api/deals/v1/${dealId}/reject/`, method: 'POST', signal
    },
      options);
    }




export const getApiDealsV1RejectCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>, TError,{dealId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>, TError,{dealId: number}, TContext> => {

const mutationKey = ['apiDealsV1RejectCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>, {dealId: number}> = (props) => {
          const {dealId} = props ?? {};

          return  apiDealsV1RejectCreate(dealId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDealsV1RejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>>

    export type ApiDealsV1RejectCreateMutationError = ErrorType<unknown>

    export const useApiDealsV1RejectCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1RejectCreate>>, TError,{dealId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDealsV1RejectCreate>>,
        TError,
        {dealId: number},
        TContext
      > => {
      return useMutation(getApiDealsV1RejectCreateMutationOptions(options), queryClient);
    }
    export const apiDealsV1RevenueList = (
    dealId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ReceivableInvoiceLineItemRevenue[]>(
      {url: `/api/deals/v1/${dealId}/revenue/`, method: 'GET', signal
    },
      options);
    }




export const getApiDealsV1RevenueListQueryKey = (dealId: number,) => {
    return [
    `/api/deals/v1/${dealId}/revenue/`
    ] as const;
    }


export const getApiDealsV1RevenueListQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1RevenueListQueryKey(dealId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1RevenueList>>> = ({ signal }) => apiDealsV1RevenueList(dealId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: dealId !== null && dealId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1RevenueListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1RevenueList>>>
export type ApiDealsV1RevenueListQueryError = ErrorType<unknown>


export function useApiDealsV1RevenueList<TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(
 dealId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1RevenueList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1RevenueList<TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1RevenueList>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1RevenueList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1RevenueList<TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1RevenueList<TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1RevenueListQueryOptions(dealId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDealsV1RevenueListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1RevenueListQueryKey(dealId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1RevenueList>>> = ({ signal }) => apiDealsV1RevenueList(dealId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1RevenueListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1RevenueList>>>
export type ApiDealsV1RevenueListSuspenseQueryError = ErrorType<unknown>


export function useApiDealsV1RevenueListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(
 dealId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1RevenueListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1RevenueListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1RevenueListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError = ErrorType<unknown>>(
 dealId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1RevenueList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1RevenueListSuspenseQueryOptions(dealId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiDealsV1Retrieve = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Deal>(
      {url: `/api/deals/v1/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiDealsV1RetrieveQueryKey = (id: number,) => {
    return [
    `/api/deals/v1/${id}/`
    ] as const;
    }


export const getApiDealsV1RetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1RetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1Retrieve>>> = ({ signal }) => apiDealsV1Retrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1Retrieve>>>
export type ApiDealsV1RetrieveQueryError = ErrorType<unknown>


export function useApiDealsV1Retrieve<TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1Retrieve<TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1Retrieve<TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1Retrieve<TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1RetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDealsV1RetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1RetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1Retrieve>>> = ({ signal }) => apiDealsV1Retrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1RetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1Retrieve>>>
export type ApiDealsV1RetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiDealsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1RetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiDealsV1PartialUpdate = (
    id: number,
    patchedDeal?: BodyType<NonReadonly<PatchedDeal>>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Deal>(
      {url: `/api/deals/v1/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedDeal, signal
    },
      options);
    }




export const getApiDealsV1PartialUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>, TError,{id: number;data?: BodyType<NonReadonly<PatchedDeal>>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>, TError,{id: number;data?: BodyType<NonReadonly<PatchedDeal>>}, TContext> => {

const mutationKey = ['apiDealsV1PartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>, {id: number;data?: BodyType<NonReadonly<PatchedDeal>>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiDealsV1PartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDealsV1PartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>>
    export type ApiDealsV1PartialUpdateMutationBody = BodyType<NonReadonly<PatchedDeal>> | undefined
    export type ApiDealsV1PartialUpdateMutationError = ErrorType<unknown>

    export const useApiDealsV1PartialUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>, TError,{id: number;data?: BodyType<NonReadonly<PatchedDeal>>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDealsV1PartialUpdate>>,
        TError,
        {id: number;data?: BodyType<NonReadonly<PatchedDeal>>},
        TContext
      > => {
      return useMutation(getApiDealsV1PartialUpdateMutationOptions(options), queryClient);
    }
    export const apiDealsV1DealChoicesList = (
    params?: ApiDealsV1DealChoicesListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedDealChoicesList>(
      {url: `/api/deals/v1/deal-choices`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDealsV1DealChoicesListQueryKey = (params?: ApiDealsV1DealChoicesListParams,) => {
    return [
    `/api/deals/v1/deal-choices`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDealsV1DealChoicesListQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(params?: ApiDealsV1DealChoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1DealChoicesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>> = ({ signal }) => apiDealsV1DealChoicesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1DealChoicesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>>
export type ApiDealsV1DealChoicesListQueryError = ErrorType<unknown>


export function useApiDealsV1DealChoicesList<TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiDealsV1DealChoicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1DealChoicesList<TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(
 params?: ApiDealsV1DealChoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1DealChoicesList<TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(
 params?: ApiDealsV1DealChoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1DealChoicesList<TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(
 params?: ApiDealsV1DealChoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1DealChoicesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDealsV1DealChoicesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(params?: ApiDealsV1DealChoicesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1DealChoicesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>> = ({ signal }) => apiDealsV1DealChoicesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1DealChoicesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>>
export type ApiDealsV1DealChoicesListSuspenseQueryError = ErrorType<unknown>


export function useApiDealsV1DealChoicesListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiDealsV1DealChoicesListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1DealChoicesListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(
 params?: ApiDealsV1DealChoicesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1DealChoicesListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(
 params?: ApiDealsV1DealChoicesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1DealChoicesListSuspense<TData = Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError = ErrorType<unknown>>(
 params?: ApiDealsV1DealChoicesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1DealChoicesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1DealChoicesListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiDealsV1SellerTransactionHistoryRetrieve = (
    sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<TransactionHistoryResponseDTO>(
      {url: `/api/deals/v1/seller-transaction-history/${sellerId}/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDealsV1SellerTransactionHistoryRetrieveQueryKey = (sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams,) => {
    return [
    `/api/deals/v1/seller-transaction-history/${sellerId}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDealsV1SellerTransactionHistoryRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1SellerTransactionHistoryRetrieveQueryKey(sellerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>> = ({ signal }) => apiDealsV1SellerTransactionHistoryRetrieve(sellerId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sellerId !== null && sellerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1SellerTransactionHistoryRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>>
export type ApiDealsV1SellerTransactionHistoryRetrieveQueryError = ErrorType<unknown>


export function useApiDealsV1SellerTransactionHistoryRetrieve<TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(
 sellerId: number,
    params: undefined |  ApiDealsV1SellerTransactionHistoryRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1SellerTransactionHistoryRetrieve<TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(
 sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1SellerTransactionHistoryRetrieve<TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(
 sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1SellerTransactionHistoryRetrieve<TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(
 sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1SellerTransactionHistoryRetrieveQueryOptions(sellerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDealsV1SellerTransactionHistoryRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDealsV1SellerTransactionHistoryRetrieveQueryKey(sellerId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>> = ({ signal }) => apiDealsV1SellerTransactionHistoryRetrieve(sellerId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDealsV1SellerTransactionHistoryRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>>
export type ApiDealsV1SellerTransactionHistoryRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiDealsV1SellerTransactionHistoryRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(
 sellerId: number,
    params: undefined |  ApiDealsV1SellerTransactionHistoryRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1SellerTransactionHistoryRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(
 sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDealsV1SellerTransactionHistoryRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(
 sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDealsV1SellerTransactionHistoryRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError = ErrorType<unknown>>(
 sellerId: number,
    params?: ApiDealsV1SellerTransactionHistoryRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDealsV1SellerTransactionHistoryRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDealsV1SellerTransactionHistoryRetrieveSuspenseQueryOptions(sellerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDocumentsV1DocumentsList = (
    params?: ApiDocumentsV1DocumentsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedDocumentInfoList>(
      {url: `/api/documents/v1/documents/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsListQueryKey = (params?: ApiDocumentsV1DocumentsListParams,) => {
    return [
    `/api/documents/v1/documents/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDocumentsV1DocumentsListQueryOptions = <TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDocumentsV1DocumentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDocumentsV1DocumentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>> = ({ signal }) => apiDocumentsV1DocumentsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDocumentsV1DocumentsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>>
export type ApiDocumentsV1DocumentsListQueryError = ErrorType<ErrorResponse>


export function useApiDocumentsV1DocumentsList<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDocumentsV1DocumentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
          TError,
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsList<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDocumentsV1DocumentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>,
          TError,
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsList<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDocumentsV1DocumentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDocumentsV1DocumentsList<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDocumentsV1DocumentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDocumentsV1DocumentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDocumentsV1DocumentsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiDocumentsV1DocumentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDocumentsV1DocumentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>> = ({ signal }) => apiDocumentsV1DocumentsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDocumentsV1DocumentsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>>
export type ApiDocumentsV1DocumentsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDocumentsV1DocumentsListSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiDocumentsV1DocumentsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsListSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDocumentsV1DocumentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsListSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDocumentsV1DocumentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDocumentsV1DocumentsListSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiDocumentsV1DocumentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDocumentsV1DocumentsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiDocumentsV1DocumentsCreate = (
    documentCreate: BodyType<DocumentCreate>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentInfo>(
      {url: `/api/documents/v1/documents/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentCreate, signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsCreateMutationOptions = <TError = ErrorType<ApiDocumentsV1DocumentsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>, TError,{data: BodyType<DocumentCreate>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>, TError,{data: BodyType<DocumentCreate>}, TContext> => {

const mutationKey = ['apiDocumentsV1DocumentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>, {data: BodyType<DocumentCreate>}> = (props) => {
          const {data} = props ?? {};

          return  apiDocumentsV1DocumentsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDocumentsV1DocumentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>>
    export type ApiDocumentsV1DocumentsCreateMutationBody = BodyType<DocumentCreate>
    export type ApiDocumentsV1DocumentsCreateMutationError = ErrorType<ApiDocumentsV1DocumentsCreate400 | ErrorResponse>

    export const useApiDocumentsV1DocumentsCreate = <TError = ErrorType<ApiDocumentsV1DocumentsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>, TError,{data: BodyType<DocumentCreate>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDocumentsV1DocumentsCreate>>,
        TError,
        {data: BodyType<DocumentCreate>},
        TContext
      > => {
      return useMutation(getApiDocumentsV1DocumentsCreateMutationOptions(options), queryClient);
    }
    export const apiDocumentsV1DocumentsSendSigningEmailCreate = (
    documentId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SendSigningEmailResponse>(
      {url: `/api/documents/v1/documents/${documentId}/send-signing-email/`, method: 'POST', signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsSendSigningEmailCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>, TError,{documentId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>, TError,{documentId: number}, TContext> => {

const mutationKey = ['apiDocumentsV1DocumentsSendSigningEmailCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>, {documentId: number}> = (props) => {
          const {documentId} = props ?? {};

          return  apiDocumentsV1DocumentsSendSigningEmailCreate(documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDocumentsV1DocumentsSendSigningEmailCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>>

    export type ApiDocumentsV1DocumentsSendSigningEmailCreateMutationError = ErrorType<ErrorResponse>

    export const useApiDocumentsV1DocumentsSendSigningEmailCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>, TError,{documentId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDocumentsV1DocumentsSendSigningEmailCreate>>,
        TError,
        {documentId: number},
        TContext
      > => {
      return useMutation(getApiDocumentsV1DocumentsSendSigningEmailCreateMutationOptions(options), queryClient);
    }
    export const apiDocumentsV1DocumentsSigningUrlCreate = (
    documentId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentSigningURLResponse>(
      {url: `/api/documents/v1/documents/${documentId}/signing-url/`, method: 'POST', signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsSigningUrlCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>, TError,{documentId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>, TError,{documentId: number}, TContext> => {

const mutationKey = ['apiDocumentsV1DocumentsSigningUrlCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>, {documentId: number}> = (props) => {
          const {documentId} = props ?? {};

          return  apiDocumentsV1DocumentsSigningUrlCreate(documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDocumentsV1DocumentsSigningUrlCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>>

    export type ApiDocumentsV1DocumentsSigningUrlCreateMutationError = ErrorType<ErrorResponse>

    export const useApiDocumentsV1DocumentsSigningUrlCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>, TError,{documentId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDocumentsV1DocumentsSigningUrlCreate>>,
        TError,
        {documentId: number},
        TContext
      > => {
      return useMutation(getApiDocumentsV1DocumentsSigningUrlCreateMutationOptions(options), queryClient);
    }
    export const apiDocumentsV1DocumentsUnsignCreate = (
    documentId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentInfo>(
      {url: `/api/documents/v1/documents/${documentId}/unsign/`, method: 'POST', signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsUnsignCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>, TError,{documentId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>, TError,{documentId: number}, TContext> => {

const mutationKey = ['apiDocumentsV1DocumentsUnsignCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>, {documentId: number}> = (props) => {
          const {documentId} = props ?? {};

          return  apiDocumentsV1DocumentsUnsignCreate(documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDocumentsV1DocumentsUnsignCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>>

    export type ApiDocumentsV1DocumentsUnsignCreateMutationError = ErrorType<ErrorResponse>

    export const useApiDocumentsV1DocumentsUnsignCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>, TError,{documentId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDocumentsV1DocumentsUnsignCreate>>,
        TError,
        {documentId: number},
        TContext
      > => {
      return useMutation(getApiDocumentsV1DocumentsUnsignCreateMutationOptions(options), queryClient);
    }
    export const apiDocumentsV1DocumentsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentInfo>(
      {url: `/api/documents/v1/documents/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/documents/v1/documents/${id}/`
    ] as const;
    }


export const getApiDocumentsV1DocumentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDocumentsV1DocumentsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>> = ({ signal }) => apiDocumentsV1DocumentsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDocumentsV1DocumentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>>
export type ApiDocumentsV1DocumentsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiDocumentsV1DocumentsRetrieve<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsRetrieve<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsRetrieve<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDocumentsV1DocumentsRetrieve<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDocumentsV1DocumentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDocumentsV1DocumentsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDocumentsV1DocumentsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>> = ({ signal }) => apiDocumentsV1DocumentsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDocumentsV1DocumentsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>>
export type ApiDocumentsV1DocumentsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDocumentsV1DocumentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDocumentsV1DocumentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDocumentsV1DocumentsRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiDocumentsV1DocumentsPartialUpdate = (
    id: number,
    patchedDocumentUpdate?: BodyType<PatchedDocumentUpdate>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentInfo>(
      {url: `/api/documents/v1/documents/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedDocumentUpdate, signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsPartialUpdateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>, TError,{id: number;data?: BodyType<PatchedDocumentUpdate>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>, TError,{id: number;data?: BodyType<PatchedDocumentUpdate>}, TContext> => {

const mutationKey = ['apiDocumentsV1DocumentsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>, {id: number;data?: BodyType<PatchedDocumentUpdate>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiDocumentsV1DocumentsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDocumentsV1DocumentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>>
    export type ApiDocumentsV1DocumentsPartialUpdateMutationBody = BodyType<PatchedDocumentUpdate> | undefined
    export type ApiDocumentsV1DocumentsPartialUpdateMutationError = ErrorType<ErrorResponse>

    export const useApiDocumentsV1DocumentsPartialUpdate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>, TError,{id: number;data?: BodyType<PatchedDocumentUpdate>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDocumentsV1DocumentsPartialUpdate>>,
        TError,
        {id: number;data?: BodyType<PatchedDocumentUpdate>},
        TContext
      > => {
      return useMutation(getApiDocumentsV1DocumentsPartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * Get the URL for a document's context model.
 */
export const apiDocumentsV1DocumentsContextUrlRetrieve = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentContextURLOutput>(
      {url: `/api/documents/v1/documents/${id}/context-url/`, method: 'GET', signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsContextUrlRetrieveQueryKey = (id: number,) => {
    return [
    `/api/documents/v1/documents/${id}/context-url/`
    ] as const;
    }


export const getApiDocumentsV1DocumentsContextUrlRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDocumentsV1DocumentsContextUrlRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>> = ({ signal }) => apiDocumentsV1DocumentsContextUrlRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDocumentsV1DocumentsContextUrlRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>>
export type ApiDocumentsV1DocumentsContextUrlRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiDocumentsV1DocumentsContextUrlRetrieve<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsContextUrlRetrieve<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsContextUrlRetrieve<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDocumentsV1DocumentsContextUrlRetrieve<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDocumentsV1DocumentsContextUrlRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDocumentsV1DocumentsContextUrlRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDocumentsV1DocumentsContextUrlRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>> = ({ signal }) => apiDocumentsV1DocumentsContextUrlRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDocumentsV1DocumentsContextUrlRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>>
export type ApiDocumentsV1DocumentsContextUrlRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDocumentsV1DocumentsContextUrlRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsContextUrlRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsContextUrlRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDocumentsV1DocumentsContextUrlRetrieveSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsContextUrlRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDocumentsV1DocumentsContextUrlRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Generate an upload URL for a document.
 */
export const apiDocumentsV1DocumentsPdfCreate = (
    id: number,
    generatePDFInput?: BodyType<GeneratePDFInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GeneratePDFOutput>(
      {url: `/api/documents/v1/documents/${id}/pdf/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generatePDFInput, signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsPdfCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>, TError,{id: number;data?: BodyType<GeneratePDFInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>, TError,{id: number;data?: BodyType<GeneratePDFInput>}, TContext> => {

const mutationKey = ['apiDocumentsV1DocumentsPdfCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>, {id: number;data?: BodyType<GeneratePDFInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiDocumentsV1DocumentsPdfCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDocumentsV1DocumentsPdfCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>>
    export type ApiDocumentsV1DocumentsPdfCreateMutationBody = BodyType<GeneratePDFInput> | undefined
    export type ApiDocumentsV1DocumentsPdfCreateMutationError = ErrorType<ErrorResponse>

    export const useApiDocumentsV1DocumentsPdfCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>, TError,{id: number;data?: BodyType<GeneratePDFInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDocumentsV1DocumentsPdfCreate>>,
        TError,
        {id: number;data?: BodyType<GeneratePDFInput>},
        TContext
      > => {
      return useMutation(getApiDocumentsV1DocumentsPdfCreateMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for a document.
 */
export const apiDocumentsV1DocumentsUploadCreate = (
    id: number,
    preSignedURLInput: BodyType<PreSignedURLInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PreSignedURLOutput>(
      {url: `/api/documents/v1/documents/${id}/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: preSignedURLInput, signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>, TError,{id: number;data: BodyType<PreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>, TError,{id: number;data: BodyType<PreSignedURLInput>}, TContext> => {

const mutationKey = ['apiDocumentsV1DocumentsUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>, {id: number;data: BodyType<PreSignedURLInput>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiDocumentsV1DocumentsUploadCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDocumentsV1DocumentsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>>
    export type ApiDocumentsV1DocumentsUploadCreateMutationBody = BodyType<PreSignedURLInput>
    export type ApiDocumentsV1DocumentsUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiDocumentsV1DocumentsUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>, TError,{id: number;data: BodyType<PreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDocumentsV1DocumentsUploadCreate>>,
        TError,
        {id: number;data: BodyType<PreSignedURLInput>},
        TContext
      > => {
      return useMutation(getApiDocumentsV1DocumentsUploadCreateMutationOptions(options), queryClient);
    }
    /**
 * List documents for a specific sales order, filtered by user's trade company access.
 */
export const apiV1SalesOrderDocumentListExternal = (
    salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedExternalCustomerDocumentList>(
      {url: `/api/documents/v1/documents/${salesOrderSlug}/external/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiV1SalesOrderDocumentListExternalQueryKey = (salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams,) => {
    return [
    `/api/documents/v1/documents/${salesOrderSlug}/external/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiV1SalesOrderDocumentListExternalQueryOptions = <TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiV1SalesOrderDocumentListExternalQueryKey(salesOrderSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>> = ({ signal }) => apiV1SalesOrderDocumentListExternal(salesOrderSlug,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: salesOrderSlug !== null && salesOrderSlug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1SalesOrderDocumentListExternalQueryResult = NonNullable<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>>
export type ApiV1SalesOrderDocumentListExternalQueryError = ErrorType<ErrorResponse>


export function useApiV1SalesOrderDocumentListExternal<TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(
 salesOrderSlug: string,
    params: undefined |  ApiV1SalesOrderDocumentListExternalParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
          TError,
          Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiV1SalesOrderDocumentListExternal<TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(
 salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>,
          TError,
          Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiV1SalesOrderDocumentListExternal<TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(
 salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiV1SalesOrderDocumentListExternal<TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(
 salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiV1SalesOrderDocumentListExternalQueryOptions(salesOrderSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1SalesOrderDocumentListExternalSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiV1SalesOrderDocumentListExternalQueryKey(salesOrderSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>> = ({ signal }) => apiV1SalesOrderDocumentListExternal(salesOrderSlug,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1SalesOrderDocumentListExternalSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>>
export type ApiV1SalesOrderDocumentListExternalSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiV1SalesOrderDocumentListExternalSuspense<TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(
 salesOrderSlug: string,
    params: undefined |  ApiV1SalesOrderDocumentListExternalParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiV1SalesOrderDocumentListExternalSuspense<TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(
 salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiV1SalesOrderDocumentListExternalSuspense<TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(
 salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiV1SalesOrderDocumentListExternalSuspense<TData = Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError = ErrorType<ErrorResponse>>(
 salesOrderSlug: string,
    params?: ApiV1SalesOrderDocumentListExternalParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1SalesOrderDocumentListExternal>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiV1SalesOrderDocumentListExternalSuspenseQueryOptions(salesOrderSlug,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * List documents for a specific shipment, filtered by user's trade company access.
 */
export const apiDocumentsV1DocumentsExternalList = (
    shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedExternalCustomerDocumentList>(
      {url: `/api/documents/v1/documents/${shipmentId}/external/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiDocumentsV1DocumentsExternalListQueryKey = (shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams,) => {
    return [
    `/api/documents/v1/documents/${shipmentId}/external/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiDocumentsV1DocumentsExternalListQueryOptions = <TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDocumentsV1DocumentsExternalListQueryKey(shipmentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>> = ({ signal }) => apiDocumentsV1DocumentsExternalList(shipmentId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: shipmentId !== null && shipmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDocumentsV1DocumentsExternalListQueryResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>>
export type ApiDocumentsV1DocumentsExternalListQueryError = ErrorType<ErrorResponse>


export function useApiDocumentsV1DocumentsExternalList<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(
 shipmentId: number,
    params: undefined |  ApiDocumentsV1DocumentsExternalListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
          TError,
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsExternalList<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(
 shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>,
          TError,
          Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsExternalList<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(
 shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDocumentsV1DocumentsExternalList<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(
 shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDocumentsV1DocumentsExternalListQueryOptions(shipmentId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiDocumentsV1DocumentsExternalListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiDocumentsV1DocumentsExternalListQueryKey(shipmentId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>> = ({ signal }) => apiDocumentsV1DocumentsExternalList(shipmentId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiDocumentsV1DocumentsExternalListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>>
export type ApiDocumentsV1DocumentsExternalListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiDocumentsV1DocumentsExternalListSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(
 shipmentId: number,
    params: undefined |  ApiDocumentsV1DocumentsExternalListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsExternalListSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(
 shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiDocumentsV1DocumentsExternalListSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(
 shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiDocumentsV1DocumentsExternalListSuspense<TData = Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError = ErrorType<ErrorResponse>>(
 shipmentId: number,
    params?: ApiDocumentsV1DocumentsExternalListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiDocumentsV1DocumentsExternalList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiDocumentsV1DocumentsExternalListSuspenseQueryOptions(shipmentId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiDocumentsV1SigningPartiesMarkSignedCreate = (
    signingPartyId: number,
    manuallyMarkPartyAsSigned: BodyType<ManuallyMarkPartyAsSigned>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleSigningParty>(
      {url: `/api/documents/v1/signing-parties/${signingPartyId}/mark-signed/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: manuallyMarkPartyAsSigned, signal
    },
      options);
    }




export const getApiDocumentsV1SigningPartiesMarkSignedCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>, TError,{signingPartyId: number;data: BodyType<ManuallyMarkPartyAsSigned>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>, TError,{signingPartyId: number;data: BodyType<ManuallyMarkPartyAsSigned>}, TContext> => {

const mutationKey = ['apiDocumentsV1SigningPartiesMarkSignedCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>, {signingPartyId: number;data: BodyType<ManuallyMarkPartyAsSigned>}> = (props) => {
          const {signingPartyId,data} = props ?? {};

          return  apiDocumentsV1SigningPartiesMarkSignedCreate(signingPartyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiDocumentsV1SigningPartiesMarkSignedCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>>
    export type ApiDocumentsV1SigningPartiesMarkSignedCreateMutationBody = BodyType<ManuallyMarkPartyAsSigned>
    export type ApiDocumentsV1SigningPartiesMarkSignedCreateMutationError = ErrorType<ErrorResponse>

    export const useApiDocumentsV1SigningPartiesMarkSignedCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>, TError,{signingPartyId: number;data: BodyType<ManuallyMarkPartyAsSigned>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiDocumentsV1SigningPartiesMarkSignedCreate>>,
        TError,
        {signingPartyId: number;data: BodyType<ManuallyMarkPartyAsSigned>},
        TContext
      > => {
      return useMutation(getApiDocumentsV1SigningPartiesMarkSignedCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsCreateMaterialAndTransportCostsEventHandlerCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/create_material_and_transport_costs_event_handler/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsCreateMaterialAndTransportCostsEventHandlerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsCreateMaterialAndTransportCostsEventHandlerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>>
    export type ApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsCreateMaterialAndTransportCostsEventHandlerCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsCreateMaterialAndTransportCostsEventHandlerCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsCreateMaterialAndTransportCostsEventHandlerCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsCreateMaterialRevenuesEventHandlerCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/create_material_revenues_event_handler/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsCreateMaterialRevenuesEventHandlerCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsCreateMaterialRevenuesEventHandlerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsCreateMaterialRevenuesEventHandlerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsCreateMaterialRevenuesEventHandlerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>>
    export type ApiEventsCreateMaterialRevenuesEventHandlerCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsCreateMaterialRevenuesEventHandlerCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsCreateMaterialRevenuesEventHandlerCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsCreateMaterialRevenuesEventHandlerCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsCreateMaterialRevenuesEventHandlerCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsCreateNewTradeCompanyKybTicketCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/create_new_trade_company_kyb_ticket/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsCreateNewTradeCompanyKybTicketCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsCreateNewTradeCompanyKybTicketCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsCreateNewTradeCompanyKybTicketCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsCreateNewTradeCompanyKybTicketCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>>
    export type ApiEventsCreateNewTradeCompanyKybTicketCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsCreateNewTradeCompanyKybTicketCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsCreateNewTradeCompanyKybTicketCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsCreateNewTradeCompanyKybTicketCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsCreateNewTradeCompanyKybTicketCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsEvaluatePurchaseOrderBlockingRulesCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/evaluate_purchase_order_blocking_rules/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsEvaluatePurchaseOrderBlockingRulesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsEvaluatePurchaseOrderBlockingRulesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>>
    export type ApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsEvaluatePurchaseOrderBlockingRulesCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsEvaluatePurchaseOrderBlockingRulesCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsEvaluatePurchaseOrderBlockingRulesCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsEvaluateSalesOrderBlockingRulesCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/evaluate_sales_order_blocking_rules/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsEvaluateSalesOrderBlockingRulesCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsEvaluateSalesOrderBlockingRulesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsEvaluateSalesOrderBlockingRulesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsEvaluateSalesOrderBlockingRulesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>>
    export type ApiEventsEvaluateSalesOrderBlockingRulesCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsEvaluateSalesOrderBlockingRulesCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsEvaluateSalesOrderBlockingRulesCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsEvaluateSalesOrderBlockingRulesCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsEvaluateSalesOrderBlockingRulesCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/mark_purchase_order_as_fulfilled_on_load_update/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>>
    export type ApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsMarkPurchaseOrderAsFulfilledOnLoadUpdateCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/mark_sales_order_as_fulfilled_on_load_update/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>>
    export type ApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsMarkSalesOrderAsFulfilledOnLoadUpdateCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsRegenerateAnnexViiForShipmentLoadsCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/regenerate_annex_vii_for_shipment_loads/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsRegenerateAnnexViiForShipmentLoadsCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsRegenerateAnnexViiForShipmentLoadsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsRegenerateAnnexViiForShipmentLoadsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsRegenerateAnnexViiForShipmentLoadsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsRegenerateAnnexViiForShipmentLoadsCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsRegenerateAnnexViiForShipmentLoadsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsRegenerateAnnexViiForShipmentLoadsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsRegenerateAnnexViiForShipmentLoadsCreate>>>
    export type ApiEventsRegenerateAnnexViiForShipmentLoadsCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsRegenerateAnnexViiForShipmentLoadsCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsRegenerateAnnexViiForShipmentLoadsCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsRegenerateAnnexViiForShipmentLoadsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsRegenerateAnnexViiForShipmentLoadsCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsRegenerateAnnexViiForShipmentLoadsCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsSendShipmentConfirmationEmailsCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/send_shipment_confirmation_emails/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsSendShipmentConfirmationEmailsCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsSendShipmentConfirmationEmailsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsSendShipmentConfirmationEmailsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsSendShipmentConfirmationEmailsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>>
    export type ApiEventsSendShipmentConfirmationEmailsCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsSendShipmentConfirmationEmailsCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsSendShipmentConfirmationEmailsCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsSendShipmentConfirmationEmailsCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsSendShipmentConfirmationEmailsCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsUpdateOrCreateDealApprovalTicketsCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/update_or_create_deal_approval_tickets/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsUpdateOrCreateDealApprovalTicketsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsUpdateOrCreateDealApprovalTicketsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>>
    export type ApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsUpdateOrCreateDealApprovalTicketsCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsUpdateOrCreateDealApprovalTicketsCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsUpdateOrCreateDealApprovalTicketsCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsUpdateOrCreateInspectionTicketCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/update_or_create_inspection_ticket/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsUpdateOrCreateInspectionTicketCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsUpdateOrCreateInspectionTicketCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsUpdateOrCreateInspectionTicketCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsUpdateOrCreateInspectionTicketCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>>
    export type ApiEventsUpdateOrCreateInspectionTicketCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsUpdateOrCreateInspectionTicketCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsUpdateOrCreateInspectionTicketCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsUpdateOrCreateInspectionTicketCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsUpdateOrCreateInspectionTicketCreateMutationOptions(options), queryClient);
    }
    /**
 * A wrapper view that receives events from Pub/Sub and triggers a service method to process them.
 *
 * This view verifies the incoming token, validates the event data, and calls the
 * specified method in the configuration (`PushSubscriptionConfig`) based on the event type.
 *
 * See definition of Events here: https://www.notion.so/safi-ltd/Events-Async-Tasks-Summary-177b8449f7a6802c98e2feee24b6ca21?pvs=4
 */
export const apiEventsUpdateShipmentStatusEventHandlerCreate = (
    pushSubscriptionInput: BodyType<PushSubscriptionInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Event>(
      {url: `/api/events/update_shipment_status_event_handler/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionInput, signal
    },
      options);
    }




export const getApiEventsUpdateShipmentStatusEventHandlerCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext> => {

const mutationKey = ['apiEventsUpdateShipmentStatusEventHandlerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>, {data: BodyType<PushSubscriptionInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiEventsUpdateShipmentStatusEventHandlerCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEventsUpdateShipmentStatusEventHandlerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>>
    export type ApiEventsUpdateShipmentStatusEventHandlerCreateMutationBody = BodyType<PushSubscriptionInput>
    export type ApiEventsUpdateShipmentStatusEventHandlerCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEventsUpdateShipmentStatusEventHandlerCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>, TError,{data: BodyType<PushSubscriptionInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEventsUpdateShipmentStatusEventHandlerCreate>>,
        TError,
        {data: BodyType<PushSubscriptionInput>},
        TContext
      > => {
      return useMutation(getApiEventsUpdateShipmentStatusEventHandlerCreateMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for large files.
 */
export const apiEvidenceUploadCreate = (
    generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GenerateUploadUrlResponse>(
      {url: `/api/evidence/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateUploadUrlRequest, signal
    },
      options);
    }




export const getApiEvidenceUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceUploadCreate>>, TError,{data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceUploadCreate>>, TError,{data: BodyType<GenerateUploadUrlRequest>}, TContext> => {

const mutationKey = ['apiEvidenceUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEvidenceUploadCreate>>, {data: BodyType<GenerateUploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiEvidenceUploadCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEvidenceUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceUploadCreate>>>
    export type ApiEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>
    export type ApiEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiEvidenceUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceUploadCreate>>, TError,{data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEvidenceUploadCreate>>,
        TError,
        {data: BodyType<GenerateUploadUrlRequest>},
        TContext
      > => {
      return useMutation(getApiEvidenceUploadCreateMutationOptions(options), queryClient);
    }
    /**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiEvidenceUploadUpdate = (
    processUploadRequest: BodyType<ProcessUploadRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessUploadResponse>(
      {url: `/api/evidence/upload/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: processUploadRequest, signal
    },
      options);
    }




export const getApiEvidenceUploadUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>, TError,{data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>, TError,{data: BodyType<ProcessUploadRequest>}, TContext> => {

const mutationKey = ['apiEvidenceUploadUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>, {data: BodyType<ProcessUploadRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiEvidenceUploadUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEvidenceUploadUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>>
    export type ApiEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>
    export type ApiEvidenceUploadUpdateMutationError = ErrorType<unknown>

    export const useApiEvidenceUploadUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>, TError,{data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEvidenceUploadUpdate>>,
        TError,
        {data: BodyType<ProcessUploadRequest>},
        TContext
      > => {
      return useMutation(getApiEvidenceUploadUpdateMutationOptions(options), queryClient);
    }
    export const apiEvidenceV1DataPartialUpdate = (
    id: number,
    patchedEvidenceData?: BodyType<PatchedEvidenceData>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/evidence/v1/${id}/data`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedEvidenceData, signal
    },
      options);
    }




export const getApiEvidenceV1DataPartialUpdateMutationOptions = <TError = ErrorType<ApiEvidenceV1DataPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>, TError,{id: number;data?: BodyType<PatchedEvidenceData>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>, TError,{id: number;data?: BodyType<PatchedEvidenceData>}, TContext> => {

const mutationKey = ['apiEvidenceV1DataPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>, {id: number;data?: BodyType<PatchedEvidenceData>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiEvidenceV1DataPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEvidenceV1DataPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>>
    export type ApiEvidenceV1DataPartialUpdateMutationBody = BodyType<PatchedEvidenceData> | undefined
    export type ApiEvidenceV1DataPartialUpdateMutationError = ErrorType<ApiEvidenceV1DataPartialUpdate400 | ErrorResponse>

    export const useApiEvidenceV1DataPartialUpdate = <TError = ErrorType<ApiEvidenceV1DataPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>, TError,{id: number;data?: BodyType<PatchedEvidenceData>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEvidenceV1DataPartialUpdate>>,
        TError,
        {id: number;data?: BodyType<PatchedEvidenceData>},
        TContext
      > => {
      return useMutation(getApiEvidenceV1DataPartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * Endpoint for bulk updating evidence. model passed in url determines model of a new parent obj
 */
export const apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate = (
    patchedBulkUpdateData?: BodyType<PatchedBulkUpdateData>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/evidence/v1/bulk-update/site-material/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedBulkUpdateData, signal
    },
      options);
    }




export const getApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationOptions = <TError = ErrorType<ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>, TError,{data?: BodyType<PatchedBulkUpdateData>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>, TError,{data?: BodyType<PatchedBulkUpdateData>}, TContext> => {

const mutationKey = ['apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>, {data?: BodyType<PatchedBulkUpdateData>}> = (props) => {
          const {data} = props ?? {};

          return  apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>>
    export type ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationBody = BodyType<PatchedBulkUpdateData> | undefined
    export type ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationError = ErrorType<ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate400 | ErrorResponse>

    export const useApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate = <TError = ErrorType<ApiEvidenceV1BulkUpdateSiteMaterialPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>, TError,{data?: BodyType<PatchedBulkUpdateData>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEvidenceV1BulkUpdateSiteMaterialPartialUpdate>>,
        TError,
        {data?: BodyType<PatchedBulkUpdateData>},
        TContext
      > => {
      return useMutation(getApiEvidenceV1BulkUpdateSiteMaterialPartialUpdateMutationOptions(options), queryClient);
    }
    export const apiEvidenceV1EvidenceSessionRetrieve = (
    params: ApiEvidenceV1EvidenceSessionRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<EvidenceSessionDetails>(
      {url: `/api/evidence/v1/evidence-session`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiEvidenceV1EvidenceSessionRetrieveQueryKey = (params?: ApiEvidenceV1EvidenceSessionRetrieveParams,) => {
    return [
    `/api/evidence/v1/evidence-session`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiEvidenceV1EvidenceSessionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(params: ApiEvidenceV1EvidenceSessionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiEvidenceV1EvidenceSessionRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>> = ({ signal }) => apiEvidenceV1EvidenceSessionRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiEvidenceV1EvidenceSessionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>>
export type ApiEvidenceV1EvidenceSessionRetrieveQueryError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>


export function useApiEvidenceV1EvidenceSessionRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(
 params: ApiEvidenceV1EvidenceSessionRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1EvidenceSessionRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(
 params: ApiEvidenceV1EvidenceSessionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1EvidenceSessionRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(
 params: ApiEvidenceV1EvidenceSessionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiEvidenceV1EvidenceSessionRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(
 params: ApiEvidenceV1EvidenceSessionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiEvidenceV1EvidenceSessionRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiEvidenceV1EvidenceSessionRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(params: ApiEvidenceV1EvidenceSessionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiEvidenceV1EvidenceSessionRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>> = ({ signal }) => apiEvidenceV1EvidenceSessionRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiEvidenceV1EvidenceSessionRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>>
export type ApiEvidenceV1EvidenceSessionRetrieveSuspenseQueryError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>


export function useApiEvidenceV1EvidenceSessionRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(
 params: ApiEvidenceV1EvidenceSessionRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1EvidenceSessionRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(
 params: ApiEvidenceV1EvidenceSessionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1EvidenceSessionRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(
 params: ApiEvidenceV1EvidenceSessionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiEvidenceV1EvidenceSessionRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError = ErrorType<ApiEvidenceV1EvidenceSessionRetrieve400 | ErrorResponse>>(
 params: ApiEvidenceV1EvidenceSessionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiEvidenceV1EvidenceSessionRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiEvidenceV1EvidenceTypesRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ApiEvidenceV1EvidenceTypesRetrieve200>(
      {url: `/api/evidence/v1/evidence-types`, method: 'GET', signal
    },
      options);
    }




export const getApiEvidenceV1EvidenceTypesRetrieveQueryKey = () => {
    return [
    `/api/evidence/v1/evidence-types`
    ] as const;
    }


export const getApiEvidenceV1EvidenceTypesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiEvidenceV1EvidenceTypesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>> = ({ signal }) => apiEvidenceV1EvidenceTypesRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiEvidenceV1EvidenceTypesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>>
export type ApiEvidenceV1EvidenceTypesRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiEvidenceV1EvidenceTypesRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1EvidenceTypesRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1EvidenceTypesRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiEvidenceV1EvidenceTypesRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiEvidenceV1EvidenceTypesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiEvidenceV1EvidenceTypesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiEvidenceV1EvidenceTypesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>> = ({ signal }) => apiEvidenceV1EvidenceTypesRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiEvidenceV1EvidenceTypesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>>
export type ApiEvidenceV1EvidenceTypesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiEvidenceV1EvidenceTypesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1EvidenceTypesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1EvidenceTypesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiEvidenceV1EvidenceTypesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1EvidenceTypesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiEvidenceV1EvidenceTypesRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiEvidenceV1InternalRetrieve = (
    evidenceId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<EvidenceDetail>(
      {url: `/api/evidence/v1/internal/${evidenceId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiEvidenceV1InternalRetrieveQueryKey = (evidenceId: number,) => {
    return [
    `/api/evidence/v1/internal/${evidenceId}/`
    ] as const;
    }


export const getApiEvidenceV1InternalRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(evidenceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiEvidenceV1InternalRetrieveQueryKey(evidenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>> = ({ signal }) => apiEvidenceV1InternalRetrieve(evidenceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: evidenceId !== null && evidenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiEvidenceV1InternalRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>>
export type ApiEvidenceV1InternalRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiEvidenceV1InternalRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1InternalRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1InternalRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiEvidenceV1InternalRetrieve<TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiEvidenceV1InternalRetrieveQueryOptions(evidenceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiEvidenceV1InternalRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(evidenceId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiEvidenceV1InternalRetrieveQueryKey(evidenceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>> = ({ signal }) => apiEvidenceV1InternalRetrieve(evidenceId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiEvidenceV1InternalRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>>
export type ApiEvidenceV1InternalRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiEvidenceV1InternalRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1InternalRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiEvidenceV1InternalRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiEvidenceV1InternalRetrieveSuspense<TData = Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiEvidenceV1InternalRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiEvidenceV1InternalRetrieveSuspenseQueryOptions(evidenceId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiEvidenceV1StartRerunEvidenceJobCreate = (
    startEvidenceRerunJobRequestDTO: BodyType<StartEvidenceRerunJobRequestDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<StartEvidenceRerunJobResponseDTO>(
      {url: `/api/evidence/v1/start-rerun-evidence-job/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startEvidenceRerunJobRequestDTO, signal
    },
      options);
    }




export const getApiEvidenceV1StartRerunEvidenceJobCreateMutationOptions = <TError = ErrorType<ApiEvidenceV1StartRerunEvidenceJobCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1StartRerunEvidenceJobCreate>>, TError,{data: BodyType<StartEvidenceRerunJobRequestDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1StartRerunEvidenceJobCreate>>, TError,{data: BodyType<StartEvidenceRerunJobRequestDTO>}, TContext> => {

const mutationKey = ['apiEvidenceV1StartRerunEvidenceJobCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiEvidenceV1StartRerunEvidenceJobCreate>>, {data: BodyType<StartEvidenceRerunJobRequestDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiEvidenceV1StartRerunEvidenceJobCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiEvidenceV1StartRerunEvidenceJobCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiEvidenceV1StartRerunEvidenceJobCreate>>>
    export type ApiEvidenceV1StartRerunEvidenceJobCreateMutationBody = BodyType<StartEvidenceRerunJobRequestDTO>
    export type ApiEvidenceV1StartRerunEvidenceJobCreateMutationError = ErrorType<ApiEvidenceV1StartRerunEvidenceJobCreate400 | ErrorResponse>

    export const useApiEvidenceV1StartRerunEvidenceJobCreate = <TError = ErrorType<ApiEvidenceV1StartRerunEvidenceJobCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiEvidenceV1StartRerunEvidenceJobCreate>>, TError,{data: BodyType<StartEvidenceRerunJobRequestDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiEvidenceV1StartRerunEvidenceJobCreate>>,
        TError,
        {data: BodyType<StartEvidenceRerunJobRequestDTO>},
        TContext
      > => {
      return useMutation(getApiEvidenceV1StartRerunEvidenceJobCreateMutationOptions(options), queryClient);
    }
    export const apiFeatureFlagsRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ApiFeatureFlagsRetrieve200>(
      {url: `/api/feature-flags/`, method: 'GET', signal
    },
      options);
    }




export const getApiFeatureFlagsRetrieveQueryKey = () => {
    return [
    `/api/feature-flags/`
    ] as const;
    }


export const getApiFeatureFlagsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiFeatureFlagsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>> = ({ signal }) => apiFeatureFlagsRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiFeatureFlagsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>>
export type ApiFeatureFlagsRetrieveQueryError = ErrorType<unknown>


export function useApiFeatureFlagsRetrieve<TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiFeatureFlagsRetrieve<TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiFeatureFlagsRetrieve<TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiFeatureFlagsRetrieve<TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiFeatureFlagsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiFeatureFlagsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiFeatureFlagsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>> = ({ signal }) => apiFeatureFlagsRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiFeatureFlagsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>>
export type ApiFeatureFlagsRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiFeatureFlagsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiFeatureFlagsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiFeatureFlagsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiFeatureFlagsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiFeatureFlagsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiFeatureFlagsRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiInspectionsBaleLoadedUpdate = (
    id: number,
    baleLoadedRequestBody: BodyType<BaleLoadedRequestBody>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/inspections/${id}/bale_loaded/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: baleLoadedRequestBody, signal
    },
      options);
    }




export const getApiInspectionsBaleLoadedUpdateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>, TError,{id: number;data: BodyType<BaleLoadedRequestBody>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>, TError,{id: number;data: BodyType<BaleLoadedRequestBody>}, TContext> => {

const mutationKey = ['apiInspectionsBaleLoadedUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>, {id: number;data: BodyType<BaleLoadedRequestBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiInspectionsBaleLoadedUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsBaleLoadedUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>>
    export type ApiInspectionsBaleLoadedUpdateMutationBody = BodyType<BaleLoadedRequestBody>
    export type ApiInspectionsBaleLoadedUpdateMutationError = ErrorType<ErrorResponse>

    export const useApiInspectionsBaleLoadedUpdate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>, TError,{id: number;data: BodyType<BaleLoadedRequestBody>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsBaleLoadedUpdate>>,
        TError,
        {id: number;data: BodyType<BaleLoadedRequestBody>},
        TContext
      > => {
      return useMutation(getApiInspectionsBaleLoadedUpdateMutationOptions(options), queryClient);
    }
    export const apiInspectionsExternalV1Retrieve = (
    slug: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalInspection>(
      {url: `/api/inspections/external/v1/${slug}/`, method: 'GET', signal
    },
      options);
    }




export const getApiInspectionsExternalV1RetrieveQueryKey = (slug: string,) => {
    return [
    `/api/inspections/external/v1/${slug}/`
    ] as const;
    }


export const getApiInspectionsExternalV1RetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsExternalV1RetrieveQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>> = ({ signal }) => apiInspectionsExternalV1Retrieve(slug, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsExternalV1RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>>
export type ApiInspectionsExternalV1RetrieveQueryError = ErrorType<ErrorResponse>


export function useApiInspectionsExternalV1Retrieve<TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsExternalV1Retrieve<TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsExternalV1Retrieve<TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiInspectionsExternalV1Retrieve<TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsExternalV1RetrieveQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiInspectionsExternalV1RetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsExternalV1RetrieveQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>> = ({ signal }) => apiInspectionsExternalV1Retrieve(slug, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsExternalV1RetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>>
export type ApiInspectionsExternalV1RetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiInspectionsExternalV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsExternalV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsExternalV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiInspectionsExternalV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsExternalV1RetrieveSuspenseQueryOptions(slug,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiInspectionsExternalV1MarkAsCompleteUpdate = (
    slug: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalInspection>(
      {url: `/api/inspections/external/v1/${slug}/mark_as_complete/`, method: 'PUT', signal
    },
      options);
    }




export const getApiInspectionsExternalV1MarkAsCompleteUpdateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>, TError,{slug: string}, TContext> => {

const mutationKey = ['apiInspectionsExternalV1MarkAsCompleteUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  apiInspectionsExternalV1MarkAsCompleteUpdate(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsExternalV1MarkAsCompleteUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>>

    export type ApiInspectionsExternalV1MarkAsCompleteUpdateMutationError = ErrorType<ErrorResponse>

    export const useApiInspectionsExternalV1MarkAsCompleteUpdate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsExternalV1MarkAsCompleteUpdate>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getApiInspectionsExternalV1MarkAsCompleteUpdateMutationOptions(options), queryClient);
    }
    /**
 * @deprecated
 */
export const apiInspectionsV1List = (
    params?: ApiInspectionsV1ListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedListInspectionList>(
      {url: `/api/inspections/v1/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiInspectionsV1ListQueryKey = (params?: ApiInspectionsV1ListParams,) => {
    return [
    `/api/inspections/v1/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiInspectionsV1ListQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(params?: ApiInspectionsV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsV1ListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1List>>> = ({ signal }) => apiInspectionsV1List(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsV1ListQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1List>>>
export type ApiInspectionsV1ListQueryError = ErrorType<unknown>


export function useApiInspectionsV1List<TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiInspectionsV1ListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsV1List>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsV1List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1List<TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(
 params?: ApiInspectionsV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsV1List>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsV1List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1List<TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(
 params?: ApiInspectionsV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useApiInspectionsV1List<TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(
 params?: ApiInspectionsV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsV1ListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiInspectionsV1ListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(params?: ApiInspectionsV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsV1ListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1List>>> = ({ signal }) => apiInspectionsV1List(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsV1ListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1List>>>
export type ApiInspectionsV1ListSuspenseQueryError = ErrorType<unknown>


export function useApiInspectionsV1ListSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiInspectionsV1ListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1ListSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(
 params?: ApiInspectionsV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1ListSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(
 params?: ApiInspectionsV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useApiInspectionsV1ListSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1List>>, TError = ErrorType<unknown>>(
 params?: ApiInspectionsV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsV1ListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiInspectionsV1Create = (
    createInspection: BodyType<NonReadonly<CreateInspection>>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CreateInspection>(
      {url: `/api/inspections/v1/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInspection, signal
    },
      options);
    }




export const getApiInspectionsV1CreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Create>>, TError,{data: BodyType<NonReadonly<CreateInspection>>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Create>>, TError,{data: BodyType<NonReadonly<CreateInspection>>}, TContext> => {

const mutationKey = ['apiInspectionsV1Create'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsV1Create>>, {data: BodyType<NonReadonly<CreateInspection>>}> = (props) => {
          const {data} = props ?? {};

          return  apiInspectionsV1Create(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsV1CreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Create>>>
    export type ApiInspectionsV1CreateMutationBody = BodyType<NonReadonly<CreateInspection>>
    export type ApiInspectionsV1CreateMutationError = ErrorType<unknown>

    export const useApiInspectionsV1Create = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Create>>, TError,{data: BodyType<NonReadonly<CreateInspection>>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsV1Create>>,
        TError,
        {data: BodyType<NonReadonly<CreateInspection>>},
        TContext
      > => {
      return useMutation(getApiInspectionsV1CreateMutationOptions(options), queryClient);
    }
    export const apiInspectionsV1Retrieve = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Inspection>(
      {url: `/api/inspections/v1/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiInspectionsV1RetrieveQueryKey = (id: number,) => {
    return [
    `/api/inspections/v1/${id}/`
    ] as const;
    }


export const getApiInspectionsV1RetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsV1RetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>> = ({ signal }) => apiInspectionsV1Retrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsV1RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>>
export type ApiInspectionsV1RetrieveQueryError = ErrorType<unknown>


export function useApiInspectionsV1Retrieve<TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1Retrieve<TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1Retrieve<TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiInspectionsV1Retrieve<TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsV1RetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiInspectionsV1RetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsV1RetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>> = ({ signal }) => apiInspectionsV1Retrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsV1RetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>>
export type ApiInspectionsV1RetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiInspectionsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiInspectionsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsV1RetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiInspectionsV1Update = (
    id: number,
    inspection: BodyType<NonReadonly<Inspection>>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Inspection>(
      {url: `/api/inspections/v1/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: inspection, signal
    },
      options);
    }




export const getApiInspectionsV1UpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Update>>, TError,{id: number;data: BodyType<NonReadonly<Inspection>>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Update>>, TError,{id: number;data: BodyType<NonReadonly<Inspection>>}, TContext> => {

const mutationKey = ['apiInspectionsV1Update'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsV1Update>>, {id: number;data: BodyType<NonReadonly<Inspection>>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiInspectionsV1Update(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsV1UpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Update>>>
    export type ApiInspectionsV1UpdateMutationBody = BodyType<NonReadonly<Inspection>>
    export type ApiInspectionsV1UpdateMutationError = ErrorType<unknown>

    export const useApiInspectionsV1Update = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Update>>, TError,{id: number;data: BodyType<NonReadonly<Inspection>>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsV1Update>>,
        TError,
        {id: number;data: BodyType<NonReadonly<Inspection>>},
        TContext
      > => {
      return useMutation(getApiInspectionsV1UpdateMutationOptions(options), queryClient);
    }
    export const apiInspectionsV1PartialUpdate = (
    id: number,
    patchedInspection?: BodyType<NonReadonly<PatchedInspection>>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Inspection>(
      {url: `/api/inspections/v1/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedInspection, signal
    },
      options);
    }




export const getApiInspectionsV1PartialUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>, TError,{id: number;data?: BodyType<NonReadonly<PatchedInspection>>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>, TError,{id: number;data?: BodyType<NonReadonly<PatchedInspection>>}, TContext> => {

const mutationKey = ['apiInspectionsV1PartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>, {id: number;data?: BodyType<NonReadonly<PatchedInspection>>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiInspectionsV1PartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsV1PartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>>
    export type ApiInspectionsV1PartialUpdateMutationBody = BodyType<NonReadonly<PatchedInspection>> | undefined
    export type ApiInspectionsV1PartialUpdateMutationError = ErrorType<unknown>

    export const useApiInspectionsV1PartialUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>, TError,{id: number;data?: BodyType<NonReadonly<PatchedInspection>>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsV1PartialUpdate>>,
        TError,
        {id: number;data?: BodyType<NonReadonly<PatchedInspection>>},
        TContext
      > => {
      return useMutation(getApiInspectionsV1PartialUpdateMutationOptions(options), queryClient);
    }
    export const apiInspectionsV1Destroy = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/inspections/v1/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiInspectionsV1DestroyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, TError,{id: number}, TContext> => {

const mutationKey = ['apiInspectionsV1Destroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  apiInspectionsV1Destroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsV1DestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>>

    export type ApiInspectionsV1DestroyMutationError = ErrorType<unknown>

    export const useApiInspectionsV1Destroy = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1Destroy>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsV1Destroy>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApiInspectionsV1DestroyMutationOptions(options), queryClient);
    }
    export const apiInspectionsV1EvidenceList = (
    slug: string,
    params?: ApiInspectionsV1EvidenceListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedEvidenceList>(
      {url: `/api/inspections/v1/${slug}/evidence/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiInspectionsV1EvidenceListQueryKey = (slug: string,
    params?: ApiInspectionsV1EvidenceListParams,) => {
    return [
    `/api/inspections/v1/${slug}/evidence/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiInspectionsV1EvidenceListQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(slug: string,
    params?: ApiInspectionsV1EvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsV1EvidenceListQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>> = ({ signal }) => apiInspectionsV1EvidenceList(slug,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsV1EvidenceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>>
export type ApiInspectionsV1EvidenceListQueryError = ErrorType<ErrorResponse>


export function useApiInspectionsV1EvidenceList<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    params: undefined |  ApiInspectionsV1EvidenceListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1EvidenceList<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    params?: ApiInspectionsV1EvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1EvidenceList<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    params?: ApiInspectionsV1EvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiInspectionsV1EvidenceList<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    params?: ApiInspectionsV1EvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsV1EvidenceListQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiInspectionsV1EvidenceListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(slug: string,
    params?: ApiInspectionsV1EvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsV1EvidenceListQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>> = ({ signal }) => apiInspectionsV1EvidenceList(slug,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsV1EvidenceListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>>
export type ApiInspectionsV1EvidenceListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiInspectionsV1EvidenceListSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    params: undefined |  ApiInspectionsV1EvidenceListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1EvidenceListSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    params?: ApiInspectionsV1EvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1EvidenceListSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    params?: ApiInspectionsV1EvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiInspectionsV1EvidenceListSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    params?: ApiInspectionsV1EvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsV1EvidenceListSuspenseQueryOptions(slug,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiInspectionsV1EvidenceRetrieve = (
    slug: string,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Evidence>(
      {url: `/api/inspections/v1/${slug}/evidence/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiInspectionsV1EvidenceRetrieveQueryKey = (slug: string,
    id: number,) => {
    return [
    `/api/inspections/v1/${slug}/evidence/${id}/`
    ] as const;
    }


export const getApiInspectionsV1EvidenceRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(slug: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsV1EvidenceRetrieveQueryKey(slug,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>> = ({ signal }) => apiInspectionsV1EvidenceRetrieve(slug,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsV1EvidenceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>>
export type ApiInspectionsV1EvidenceRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiInspectionsV1EvidenceRetrieve<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1EvidenceRetrieve<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1EvidenceRetrieve<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiInspectionsV1EvidenceRetrieve<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsV1EvidenceRetrieveQueryOptions(slug,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiInspectionsV1EvidenceRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(slug: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiInspectionsV1EvidenceRetrieveQueryKey(slug,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>> = ({ signal }) => apiInspectionsV1EvidenceRetrieve(slug,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiInspectionsV1EvidenceRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>>
export type ApiInspectionsV1EvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiInspectionsV1EvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1EvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiInspectionsV1EvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiInspectionsV1EvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiInspectionsV1EvidenceRetrieveSuspenseQueryOptions(slug,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiInspectionsV1EvidenceBulkDeleteCreate = (
    slug: string,
    bulkDeleteRequest: BodyType<BulkDeleteRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/inspections/v1/${slug}/evidence/bulk-delete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteRequest, signal
    },
      options);
    }




export const getApiInspectionsV1EvidenceBulkDeleteCreateMutationOptions = <TError = ErrorType<ApiInspectionsV1EvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceBulkDeleteCreate>>, TError,{slug: string;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceBulkDeleteCreate>>, TError,{slug: string;data: BodyType<BulkDeleteRequest>}, TContext> => {

const mutationKey = ['apiInspectionsV1EvidenceBulkDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceBulkDeleteCreate>>, {slug: string;data: BodyType<BulkDeleteRequest>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiInspectionsV1EvidenceBulkDeleteCreate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsV1EvidenceBulkDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1EvidenceBulkDeleteCreate>>>
    export type ApiInspectionsV1EvidenceBulkDeleteCreateMutationBody = BodyType<BulkDeleteRequest>
    export type ApiInspectionsV1EvidenceBulkDeleteCreateMutationError = ErrorType<ApiInspectionsV1EvidenceBulkDeleteCreate400 | ErrorResponse>

    export const useApiInspectionsV1EvidenceBulkDeleteCreate = <TError = ErrorType<ApiInspectionsV1EvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceBulkDeleteCreate>>, TError,{slug: string;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsV1EvidenceBulkDeleteCreate>>,
        TError,
        {slug: string;data: BodyType<BulkDeleteRequest>},
        TContext
      > => {
      return useMutation(getApiInspectionsV1EvidenceBulkDeleteCreateMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for large files.
 */
export const apiInspectionsV1EvidenceUploadCreate = (
    slug: string,
    generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GenerateUploadUrlResponse>(
      {url: `/api/inspections/v1/${slug}/evidence/upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateUploadUrlRequest, signal
    },
      options);
    }




export const getApiInspectionsV1EvidenceUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>, TError,{slug: string;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>, TError,{slug: string;data: BodyType<GenerateUploadUrlRequest>}, TContext> => {

const mutationKey = ['apiInspectionsV1EvidenceUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>, {slug: string;data: BodyType<GenerateUploadUrlRequest>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiInspectionsV1EvidenceUploadCreate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsV1EvidenceUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>>
    export type ApiInspectionsV1EvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>
    export type ApiInspectionsV1EvidenceUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiInspectionsV1EvidenceUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>, TError,{slug: string;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadCreate>>,
        TError,
        {slug: string;data: BodyType<GenerateUploadUrlRequest>},
        TContext
      > => {
      return useMutation(getApiInspectionsV1EvidenceUploadCreateMutationOptions(options), queryClient);
    }
    /**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiInspectionsV1EvidenceUploadUpdate = (
    slug: string,
    processUploadRequest: BodyType<ProcessUploadRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessUploadResponse>(
      {url: `/api/inspections/v1/${slug}/evidence/upload`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: processUploadRequest, signal
    },
      options);
    }




export const getApiInspectionsV1EvidenceUploadUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>, TError,{slug: string;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>, TError,{slug: string;data: BodyType<ProcessUploadRequest>}, TContext> => {

const mutationKey = ['apiInspectionsV1EvidenceUploadUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>, {slug: string;data: BodyType<ProcessUploadRequest>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiInspectionsV1EvidenceUploadUpdate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiInspectionsV1EvidenceUploadUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>>
    export type ApiInspectionsV1EvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>
    export type ApiInspectionsV1EvidenceUploadUpdateMutationError = ErrorType<unknown>

    export const useApiInspectionsV1EvidenceUploadUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>, TError,{slug: string;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiInspectionsV1EvidenceUploadUpdate>>,
        TError,
        {slug: string;data: BodyType<ProcessUploadRequest>},
        TContext
      > => {
      return useMutation(getApiInspectionsV1EvidenceUploadUpdateMutationOptions(options), queryClient);
    }
    export const apiLogisticsShipmentsCreate = (
    shipmentCreate?: BodyType<ShipmentCreate>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShipmentInfo>(
      {url: `/api/logistics/shipments/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shipmentCreate, signal
    },
      options);
    }




export const getApiLogisticsShipmentsCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>, TError,{data?: BodyType<ShipmentCreate>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>, TError,{data?: BodyType<ShipmentCreate>}, TContext> => {

const mutationKey = ['apiLogisticsShipmentsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>, {data?: BodyType<ShipmentCreate>}> = (props) => {
          const {data} = props ?? {};

          return  apiLogisticsShipmentsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiLogisticsShipmentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>>
    export type ApiLogisticsShipmentsCreateMutationBody = BodyType<ShipmentCreate> | undefined
    export type ApiLogisticsShipmentsCreateMutationError = ErrorType<ErrorResponse>

    export const useApiLogisticsShipmentsCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>, TError,{data?: BodyType<ShipmentCreate>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiLogisticsShipmentsCreate>>,
        TError,
        {data?: BodyType<ShipmentCreate>},
        TContext
      > => {
      return useMutation(getApiLogisticsShipmentsCreateMutationOptions(options), queryClient);
    }
    export const apiLogisticsShipmentsRetrieve = (
    name: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShipmentInfo>(
      {url: `/api/logistics/shipments/${name}/`, method: 'GET', signal
    },
      options);
    }




export const getApiLogisticsShipmentsRetrieveQueryKey = (name: string,) => {
    return [
    `/api/logistics/shipments/${name}/`
    ] as const;
    }


export const getApiLogisticsShipmentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsShipmentsRetrieveQueryKey(name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>> = ({ signal }) => apiLogisticsShipmentsRetrieve(name, requestOptions, signal);





   return  { queryKey, queryFn, enabled: name !== null && name !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsShipmentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>>
export type ApiLogisticsShipmentsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsShipmentsRetrieve<TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 name: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsShipmentsRetrieve<TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsShipmentsRetrieve<TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsShipmentsRetrieve<TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 name: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsShipmentsRetrieveQueryOptions(name,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiLogisticsShipmentsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsShipmentsRetrieveQueryKey(name);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>> = ({ signal }) => apiLogisticsShipmentsRetrieve(name, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsShipmentsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>>
export type ApiLogisticsShipmentsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsShipmentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 name: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsShipmentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsShipmentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsShipmentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 name: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsShipmentsRetrieveSuspenseQueryOptions(name,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiLogisticsShipmentsPartialUpdate = (
    name: string,
    patchedShipmentUpdate?: BodyType<PatchedShipmentUpdate>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ShipmentInfo>(
      {url: `/api/logistics/shipments/${name}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedShipmentUpdate, signal
    },
      options);
    }




export const getApiLogisticsShipmentsPartialUpdateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>, TError,{name: string;data?: BodyType<PatchedShipmentUpdate>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>, TError,{name: string;data?: BodyType<PatchedShipmentUpdate>}, TContext> => {

const mutationKey = ['apiLogisticsShipmentsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>, {name: string;data?: BodyType<PatchedShipmentUpdate>}> = (props) => {
          const {name,data} = props ?? {};

          return  apiLogisticsShipmentsPartialUpdate(name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiLogisticsShipmentsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>>
    export type ApiLogisticsShipmentsPartialUpdateMutationBody = BodyType<PatchedShipmentUpdate> | undefined
    export type ApiLogisticsShipmentsPartialUpdateMutationError = ErrorType<ErrorResponse>

    export const useApiLogisticsShipmentsPartialUpdate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>, TError,{name: string;data?: BodyType<PatchedShipmentUpdate>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiLogisticsShipmentsPartialUpdate>>,
        TError,
        {name: string;data?: BodyType<PatchedShipmentUpdate>},
        TContext
      > => {
      return useMutation(getApiLogisticsShipmentsPartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiLogisticsV1LoadsList = (
    params?: ApiLogisticsV1LoadsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedSimpleLoadList>(
      {url: `/api/logistics/v1/loads/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiLogisticsV1LoadsListQueryKey = (params?: ApiLogisticsV1LoadsListParams,) => {
    return [
    `/api/logistics/v1/loads/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiLogisticsV1LoadsListQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiLogisticsV1LoadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsV1LoadsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>> = ({ signal }) => apiLogisticsV1LoadsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsV1LoadsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>>
export type ApiLogisticsV1LoadsListQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsV1LoadsList<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiLogisticsV1LoadsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsList<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1LoadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsList<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1LoadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsV1LoadsList<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1LoadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsV1LoadsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiLogisticsV1LoadsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiLogisticsV1LoadsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsV1LoadsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>> = ({ signal }) => apiLogisticsV1LoadsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsV1LoadsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>>
export type ApiLogisticsV1LoadsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsV1LoadsListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiLogisticsV1LoadsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1LoadsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1LoadsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsV1LoadsListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1LoadsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsV1LoadsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiLogisticsV1LoadsEvidenceList = (
    loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedEvidenceList>(
      {url: `/api/logistics/v1/loads/${loadId}/evidence/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiLogisticsV1LoadsEvidenceListQueryKey = (loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams,) => {
    return [
    `/api/logistics/v1/loads/${loadId}/evidence/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiLogisticsV1LoadsEvidenceListQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsV1LoadsEvidenceListQueryKey(loadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>> = ({ signal }) => apiLogisticsV1LoadsEvidenceList(loadId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: loadId !== null && loadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsV1LoadsEvidenceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>>
export type ApiLogisticsV1LoadsEvidenceListQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsV1LoadsEvidenceList<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    params: undefined |  ApiLogisticsV1LoadsEvidenceListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsEvidenceList<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsEvidenceList<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsV1LoadsEvidenceList<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsV1LoadsEvidenceListQueryOptions(loadId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiLogisticsV1LoadsEvidenceListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsV1LoadsEvidenceListQueryKey(loadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>> = ({ signal }) => apiLogisticsV1LoadsEvidenceList(loadId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsV1LoadsEvidenceListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>>
export type ApiLogisticsV1LoadsEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsV1LoadsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    params: undefined |  ApiLogisticsV1LoadsEvidenceListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsV1LoadsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    params?: ApiLogisticsV1LoadsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsV1LoadsEvidenceListSuspenseQueryOptions(loadId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiLogisticsV1LoadsEvidenceRetrieve = (
    loadId: string,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Evidence>(
      {url: `/api/logistics/v1/loads/${loadId}/evidence/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiLogisticsV1LoadsEvidenceRetrieveQueryKey = (loadId: string,
    id: number,) => {
    return [
    `/api/logistics/v1/loads/${loadId}/evidence/${id}/`
    ] as const;
    }


export const getApiLogisticsV1LoadsEvidenceRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(loadId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsV1LoadsEvidenceRetrieveQueryKey(loadId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>> = ({ signal }) => apiLogisticsV1LoadsEvidenceRetrieve(loadId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: loadId !== null && loadId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsV1LoadsEvidenceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>>
export type ApiLogisticsV1LoadsEvidenceRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsV1LoadsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsV1LoadsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsV1LoadsEvidenceRetrieveQueryOptions(loadId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiLogisticsV1LoadsEvidenceRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(loadId: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsV1LoadsEvidenceRetrieveQueryKey(loadId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>> = ({ signal }) => apiLogisticsV1LoadsEvidenceRetrieve(loadId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsV1LoadsEvidenceRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>>
export type ApiLogisticsV1LoadsEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsV1LoadsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1LoadsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsV1LoadsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 loadId: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsV1LoadsEvidenceRetrieveSuspenseQueryOptions(loadId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiLogisticsV1LoadsEvidenceBulkDeleteCreate = (
    loadId: string,
    bulkDeleteRequest: BodyType<BulkDeleteRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/logistics/v1/loads/${loadId}/evidence/bulk-delete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteRequest, signal
    },
      options);
    }




export const getApiLogisticsV1LoadsEvidenceBulkDeleteCreateMutationOptions = <TError = ErrorType<ApiLogisticsV1LoadsEvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceBulkDeleteCreate>>, TError,{loadId: string;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceBulkDeleteCreate>>, TError,{loadId: string;data: BodyType<BulkDeleteRequest>}, TContext> => {

const mutationKey = ['apiLogisticsV1LoadsEvidenceBulkDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceBulkDeleteCreate>>, {loadId: string;data: BodyType<BulkDeleteRequest>}> = (props) => {
          const {loadId,data} = props ?? {};

          return  apiLogisticsV1LoadsEvidenceBulkDeleteCreate(loadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiLogisticsV1LoadsEvidenceBulkDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceBulkDeleteCreate>>>
    export type ApiLogisticsV1LoadsEvidenceBulkDeleteCreateMutationBody = BodyType<BulkDeleteRequest>
    export type ApiLogisticsV1LoadsEvidenceBulkDeleteCreateMutationError = ErrorType<ApiLogisticsV1LoadsEvidenceBulkDeleteCreate400 | ErrorResponse>

    export const useApiLogisticsV1LoadsEvidenceBulkDeleteCreate = <TError = ErrorType<ApiLogisticsV1LoadsEvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceBulkDeleteCreate>>, TError,{loadId: string;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceBulkDeleteCreate>>,
        TError,
        {loadId: string;data: BodyType<BulkDeleteRequest>},
        TContext
      > => {
      return useMutation(getApiLogisticsV1LoadsEvidenceBulkDeleteCreateMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for large files.
 */
export const apiLogisticsV1LoadsEvidenceUploadCreate = (
    loadId: number,
    generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GenerateUploadUrlResponse>(
      {url: `/api/logistics/v1/loads/${loadId}/evidence/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateUploadUrlRequest, signal
    },
      options);
    }




export const getApiLogisticsV1LoadsEvidenceUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>, TError,{loadId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>, TError,{loadId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext> => {

const mutationKey = ['apiLogisticsV1LoadsEvidenceUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>, {loadId: number;data: BodyType<GenerateUploadUrlRequest>}> = (props) => {
          const {loadId,data} = props ?? {};

          return  apiLogisticsV1LoadsEvidenceUploadCreate(loadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiLogisticsV1LoadsEvidenceUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>>
    export type ApiLogisticsV1LoadsEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>
    export type ApiLogisticsV1LoadsEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiLogisticsV1LoadsEvidenceUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>, TError,{loadId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadCreate>>,
        TError,
        {loadId: number;data: BodyType<GenerateUploadUrlRequest>},
        TContext
      > => {
      return useMutation(getApiLogisticsV1LoadsEvidenceUploadCreateMutationOptions(options), queryClient);
    }
    /**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiLogisticsV1LoadsEvidenceUploadUpdate = (
    loadId: number,
    processUploadRequest: BodyType<ProcessUploadRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessUploadResponse>(
      {url: `/api/logistics/v1/loads/${loadId}/evidence/upload/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: processUploadRequest, signal
    },
      options);
    }




export const getApiLogisticsV1LoadsEvidenceUploadUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>, TError,{loadId: number;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>, TError,{loadId: number;data: BodyType<ProcessUploadRequest>}, TContext> => {

const mutationKey = ['apiLogisticsV1LoadsEvidenceUploadUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>, {loadId: number;data: BodyType<ProcessUploadRequest>}> = (props) => {
          const {loadId,data} = props ?? {};

          return  apiLogisticsV1LoadsEvidenceUploadUpdate(loadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiLogisticsV1LoadsEvidenceUploadUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>>
    export type ApiLogisticsV1LoadsEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>
    export type ApiLogisticsV1LoadsEvidenceUploadUpdateMutationError = ErrorType<unknown>

    export const useApiLogisticsV1LoadsEvidenceUploadUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>, TError,{loadId: number;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiLogisticsV1LoadsEvidenceUploadUpdate>>,
        TError,
        {loadId: number;data: BodyType<ProcessUploadRequest>},
        TContext
      > => {
      return useMutation(getApiLogisticsV1LoadsEvidenceUploadUpdateMutationOptions(options), queryClient);
    }
    /**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiLogisticsV1ShipmentsList = (
    params?: ApiLogisticsV1ShipmentsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedShipmentInfoList>(
      {url: `/api/logistics/v1/shipments/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiLogisticsV1ShipmentsListQueryKey = (params?: ApiLogisticsV1ShipmentsListParams,) => {
    return [
    `/api/logistics/v1/shipments/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiLogisticsV1ShipmentsListQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiLogisticsV1ShipmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsV1ShipmentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>> = ({ signal }) => apiLogisticsV1ShipmentsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsV1ShipmentsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>>
export type ApiLogisticsV1ShipmentsListQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsV1ShipmentsList<TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiLogisticsV1ShipmentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1ShipmentsList<TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1ShipmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>,
          TError,
          Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1ShipmentsList<TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1ShipmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsV1ShipmentsList<TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1ShipmentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsV1ShipmentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiLogisticsV1ShipmentsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiLogisticsV1ShipmentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLogisticsV1ShipmentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>> = ({ signal }) => apiLogisticsV1ShipmentsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLogisticsV1ShipmentsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>>
export type ApiLogisticsV1ShipmentsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiLogisticsV1ShipmentsListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiLogisticsV1ShipmentsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1ShipmentsListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1ShipmentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLogisticsV1ShipmentsListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1ShipmentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiLogisticsV1ShipmentsListSuspense<TData = Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiLogisticsV1ShipmentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLogisticsV1ShipmentsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Generate an upload URL for documents.
 */
export const apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate = (
    name: string,
    documentPreSignedURLInput: BodyType<DocumentPreSignedURLInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentPreSignedURLOutput>(
      {url: `/api/logistics/v1/shipments/${name}/documents/pre-signed-url/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentPreSignedURLInput, signal
    },
      options);
    }




export const getApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>, TError,{name: string;data: BodyType<DocumentPreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>, TError,{name: string;data: BodyType<DocumentPreSignedURLInput>}, TContext> => {

const mutationKey = ['apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>, {name: string;data: BodyType<DocumentPreSignedURLInput>}> = (props) => {
          const {name,data} = props ?? {};

          return  apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate(name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>>
    export type ApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationBody = BodyType<DocumentPreSignedURLInput>
    export type ApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationError = ErrorType<ErrorResponse>

    export const useApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>, TError,{name: string;data: BodyType<DocumentPreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsPreSignedUrlCreate>>,
        TError,
        {name: string;data: BodyType<DocumentPreSignedURLInput>},
        TContext
      > => {
      return useMutation(getApiLogisticsV1ShipmentsDocumentsPreSignedUrlCreateMutationOptions(options), queryClient);
    }
    export const apiLogisticsV1ShipmentsDocumentsUploadCreate = (
    name: string,
    documentUpload: BodyType<DocumentUpload>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/logistics/v1/shipments/${name}/documents/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentUpload, signal
    },
      options);
    }




export const getApiLogisticsV1ShipmentsDocumentsUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>, TError,{name: string;data: BodyType<DocumentUpload>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>, TError,{name: string;data: BodyType<DocumentUpload>}, TContext> => {

const mutationKey = ['apiLogisticsV1ShipmentsDocumentsUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>, {name: string;data: BodyType<DocumentUpload>}> = (props) => {
          const {name,data} = props ?? {};

          return  apiLogisticsV1ShipmentsDocumentsUploadCreate(name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiLogisticsV1ShipmentsDocumentsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>>
    export type ApiLogisticsV1ShipmentsDocumentsUploadCreateMutationBody = BodyType<DocumentUpload>
    export type ApiLogisticsV1ShipmentsDocumentsUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiLogisticsV1ShipmentsDocumentsUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>, TError,{name: string;data: BodyType<DocumentUpload>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiLogisticsV1ShipmentsDocumentsUploadCreate>>,
        TError,
        {name: string;data: BodyType<DocumentUpload>},
        TContext
      > => {
      return useMutation(getApiLogisticsV1ShipmentsDocumentsUploadCreateMutationOptions(options), queryClient);
    }
    export const apiMaterialsV1AllowedMaterialSpecsList = (
    params?: ApiMaterialsV1AllowedMaterialSpecsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedAllowedMaterialSpecList>(
      {url: `/api/materials/v1/allowed-material-specs/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiMaterialsV1AllowedMaterialSpecsListQueryKey = (params?: ApiMaterialsV1AllowedMaterialSpecsListParams,) => {
    return [
    `/api/materials/v1/allowed-material-specs/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiMaterialsV1AllowedMaterialSpecsListQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(params?: ApiMaterialsV1AllowedMaterialSpecsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1AllowedMaterialSpecsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>> = ({ signal }) => apiMaterialsV1AllowedMaterialSpecsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1AllowedMaterialSpecsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>>
export type ApiMaterialsV1AllowedMaterialSpecsListQueryError = ErrorType<unknown>


export function useApiMaterialsV1AllowedMaterialSpecsList<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiMaterialsV1AllowedMaterialSpecsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1AllowedMaterialSpecsList<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1AllowedMaterialSpecsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1AllowedMaterialSpecsList<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1AllowedMaterialSpecsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1AllowedMaterialSpecsList<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1AllowedMaterialSpecsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1AllowedMaterialSpecsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1AllowedMaterialSpecsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(params?: ApiMaterialsV1AllowedMaterialSpecsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1AllowedMaterialSpecsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>> = ({ signal }) => apiMaterialsV1AllowedMaterialSpecsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1AllowedMaterialSpecsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>>
export type ApiMaterialsV1AllowedMaterialSpecsListSuspenseQueryError = ErrorType<unknown>


export function useApiMaterialsV1AllowedMaterialSpecsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiMaterialsV1AllowedMaterialSpecsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1AllowedMaterialSpecsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1AllowedMaterialSpecsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1AllowedMaterialSpecsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1AllowedMaterialSpecsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1AllowedMaterialSpecsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1AllowedMaterialSpecsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1AllowedMaterialSpecsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1AllowedMaterialSpecsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<AllowedMaterialSpec>(
      {url: `/api/materials/v1/allowed-material-specs/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/materials/v1/allowed-material-specs/${id}/`
    ] as const;
    }


export const getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>> = ({ signal }) => apiMaterialsV1AllowedMaterialSpecsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1AllowedMaterialSpecsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>>
export type ApiMaterialsV1AllowedMaterialSpecsRetrieveQueryError = ErrorType<unknown>


export function useApiMaterialsV1AllowedMaterialSpecsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1AllowedMaterialSpecsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1AllowedMaterialSpecsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1AllowedMaterialSpecsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1AllowedMaterialSpecsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1AllowedMaterialSpecsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>> = ({ signal }) => apiMaterialsV1AllowedMaterialSpecsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1AllowedMaterialSpecsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>>
export type ApiMaterialsV1AllowedMaterialSpecsRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiMaterialsV1AllowedMaterialSpecsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1AllowedMaterialSpecsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1AllowedMaterialSpecsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1AllowedMaterialSpecsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1AllowedMaterialSpecsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1AllowedMaterialSpecsRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialColoursRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialColourList>(
      {url: `/api/materials/v1/material-colours/`, method: 'GET', signal
    },
      options);
    }




export const getApiMaterialsV1MaterialColoursRetrieveQueryKey = () => {
    return [
    `/api/materials/v1/material-colours/`
    ] as const;
    }


export const getApiMaterialsV1MaterialColoursRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialColoursRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialColoursRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialColoursRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>>
export type ApiMaterialsV1MaterialColoursRetrieveQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialColoursRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialColoursRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialColoursRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialColoursRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialColoursRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialColoursRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialColoursRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialColoursRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialColoursRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>>
export type ApiMaterialsV1MaterialColoursRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialColoursRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialColoursRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialColoursRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialColoursRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialColoursRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialColoursRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialComponentsList = (
    params?: ApiMaterialsV1MaterialComponentsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleMaterialComponent[]>(
      {url: `/api/materials/v1/material-components/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiMaterialsV1MaterialComponentsListQueryKey = (params?: ApiMaterialsV1MaterialComponentsListParams,) => {
    return [
    `/api/materials/v1/material-components/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiMaterialsV1MaterialComponentsListQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(params?: ApiMaterialsV1MaterialComponentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialComponentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>> = ({ signal }) => apiMaterialsV1MaterialComponentsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialComponentsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>>
export type ApiMaterialsV1MaterialComponentsListQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialComponentsList<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiMaterialsV1MaterialComponentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialComponentsList<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialComponentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialComponentsList<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialComponentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialComponentsList<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialComponentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialComponentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialComponentsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(params?: ApiMaterialsV1MaterialComponentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialComponentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>> = ({ signal }) => apiMaterialsV1MaterialComponentsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialComponentsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>>
export type ApiMaterialsV1MaterialComponentsListSuspenseQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialComponentsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiMaterialsV1MaterialComponentsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialComponentsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialComponentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialComponentsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialComponentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialComponentsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialComponentsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialComponentsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialComponentsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialFormsRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialFormList>(
      {url: `/api/materials/v1/material-forms/`, method: 'GET', signal
    },
      options);
    }




export const getApiMaterialsV1MaterialFormsRetrieveQueryKey = () => {
    return [
    `/api/materials/v1/material-forms/`
    ] as const;
    }


export const getApiMaterialsV1MaterialFormsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialFormsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialFormsRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialFormsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>>
export type ApiMaterialsV1MaterialFormsRetrieveQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialFormsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialFormsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialFormsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialFormsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialFormsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialFormsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialFormsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialFormsRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialFormsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>>
export type ApiMaterialsV1MaterialFormsRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialFormsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialFormsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialFormsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialFormsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialFormsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialFormsRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialGradesRetrieve = (
    params?: ApiMaterialsV1MaterialGradesRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialGradeList>(
      {url: `/api/materials/v1/material-grades/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiMaterialsV1MaterialGradesRetrieveQueryKey = (params?: ApiMaterialsV1MaterialGradesRetrieveParams,) => {
    return [
    `/api/materials/v1/material-grades/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiMaterialsV1MaterialGradesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(params?: ApiMaterialsV1MaterialGradesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialGradesRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialGradesRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialGradesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>>
export type ApiMaterialsV1MaterialGradesRetrieveQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialGradesRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiMaterialsV1MaterialGradesRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialGradesRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialGradesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialGradesRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialGradesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialGradesRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialGradesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialGradesRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialGradesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(params?: ApiMaterialsV1MaterialGradesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialGradesRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialGradesRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialGradesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>>
export type ApiMaterialsV1MaterialGradesRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialGradesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiMaterialsV1MaterialGradesRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialGradesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialGradesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialGradesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialGradesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialGradesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialGradesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialGradesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialGradesRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialOriginsRetrieve = (
    params?: ApiMaterialsV1MaterialOriginsRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialOriginList>(
      {url: `/api/materials/v1/material-origins/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiMaterialsV1MaterialOriginsRetrieveQueryKey = (params?: ApiMaterialsV1MaterialOriginsRetrieveParams,) => {
    return [
    `/api/materials/v1/material-origins/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiMaterialsV1MaterialOriginsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiMaterialsV1MaterialOriginsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialOriginsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialOriginsRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialOriginsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>>
export type ApiMaterialsV1MaterialOriginsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiMaterialsV1MaterialOriginsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiMaterialsV1MaterialOriginsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialOriginsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialsV1MaterialOriginsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialOriginsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialsV1MaterialOriginsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialOriginsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialsV1MaterialOriginsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialOriginsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialOriginsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiMaterialsV1MaterialOriginsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialOriginsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialOriginsRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialOriginsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>>
export type ApiMaterialsV1MaterialOriginsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiMaterialsV1MaterialOriginsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiMaterialsV1MaterialOriginsRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialOriginsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialsV1MaterialOriginsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialOriginsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialsV1MaterialOriginsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialOriginsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialsV1MaterialOriginsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialOriginsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialOriginsRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiMaterialV1MaterialProductsList = (
    params?: ApiMaterialV1MaterialProductsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedMaterialProductInfoListItemList>(
      {url: `/api/materials/v1/material-products/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiMaterialV1MaterialProductsListQueryKey = (params?: ApiMaterialV1MaterialProductsListParams,) => {
    return [
    `/api/materials/v1/material-products/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiMaterialV1MaterialProductsListQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiMaterialV1MaterialProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialV1MaterialProductsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>> = ({ signal }) => apiMaterialV1MaterialProductsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialV1MaterialProductsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>>
export type ApiMaterialV1MaterialProductsListQueryError = ErrorType<ErrorResponse>


export function useApiMaterialV1MaterialProductsList<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiMaterialV1MaterialProductsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialV1MaterialProductsList<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialV1MaterialProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialV1MaterialProductsList<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialV1MaterialProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialV1MaterialProductsList<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialV1MaterialProductsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialV1MaterialProductsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialV1MaterialProductsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiMaterialV1MaterialProductsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialV1MaterialProductsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>> = ({ signal }) => apiMaterialV1MaterialProductsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialV1MaterialProductsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>>
export type ApiMaterialV1MaterialProductsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiMaterialV1MaterialProductsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiMaterialV1MaterialProductsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialV1MaterialProductsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialV1MaterialProductsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialV1MaterialProductsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialV1MaterialProductsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialV1MaterialProductsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiMaterialV1MaterialProductsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialV1MaterialProductsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiMaterialsV1MaterialProductsCreate = (
    createMaterialProductDTO: BodyType<CreateMaterialProductDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CreateMaterialProductOutput>(
      {url: `/api/materials/v1/material-products/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMaterialProductDTO, signal
    },
      options);
    }




export const getApiMaterialsV1MaterialProductsCreateMutationOptions = <TError = ErrorType<ApiMaterialsV1MaterialProductsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>, TError,{data: BodyType<CreateMaterialProductDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>, TError,{data: BodyType<CreateMaterialProductDTO>}, TContext> => {

const mutationKey = ['apiMaterialsV1MaterialProductsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>, {data: BodyType<CreateMaterialProductDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiMaterialsV1MaterialProductsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiMaterialsV1MaterialProductsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>>
    export type ApiMaterialsV1MaterialProductsCreateMutationBody = BodyType<CreateMaterialProductDTO>
    export type ApiMaterialsV1MaterialProductsCreateMutationError = ErrorType<ApiMaterialsV1MaterialProductsCreate400 | ErrorResponse>

    export const useApiMaterialsV1MaterialProductsCreate = <TError = ErrorType<ApiMaterialsV1MaterialProductsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>, TError,{data: BodyType<CreateMaterialProductDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsCreate>>,
        TError,
        {data: BodyType<CreateMaterialProductDTO>},
        TContext
      > => {
      return useMutation(getApiMaterialsV1MaterialProductsCreateMutationOptions(options), queryClient);
    }
    export const apiMaterialV1MaterialProductsDetail = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialProductInfoDetails>(
      {url: `/api/materials/v1/material-products/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiMaterialV1MaterialProductsDetailQueryKey = (id: number,) => {
    return [
    `/api/materials/v1/material-products/${id}/`
    ] as const;
    }


export const getApiMaterialV1MaterialProductsDetailQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialV1MaterialProductsDetailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>> = ({ signal }) => apiMaterialV1MaterialProductsDetail(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialV1MaterialProductsDetailQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>>
export type ApiMaterialV1MaterialProductsDetailQueryError = ErrorType<ErrorResponse>


export function useApiMaterialV1MaterialProductsDetail<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialV1MaterialProductsDetail<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialV1MaterialProductsDetail<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialV1MaterialProductsDetail<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialV1MaterialProductsDetailQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialV1MaterialProductsDetailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialV1MaterialProductsDetailQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>> = ({ signal }) => apiMaterialV1MaterialProductsDetail(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialV1MaterialProductsDetailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>>
export type ApiMaterialV1MaterialProductsDetailSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiMaterialV1MaterialProductsDetailSuspense<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialV1MaterialProductsDetailSuspense<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialV1MaterialProductsDetailSuspense<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialV1MaterialProductsDetailSuspense<TData = Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError = ErrorType<ErrorResponse>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDetail>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialV1MaterialProductsDetailSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialProductsUpdate = (
    id: number,
    updateMaterialProductDTO: BodyType<UpdateMaterialProductDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UpdateMaterialProductOutput>(
      {url: `/api/materials/v1/material-products/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateMaterialProductDTO, signal
    },
      options);
    }




export const getApiMaterialsV1MaterialProductsUpdateMutationOptions = <TError = ErrorType<ApiMaterialsV1MaterialProductsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>, TError,{id: number;data: BodyType<UpdateMaterialProductDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>, TError,{id: number;data: BodyType<UpdateMaterialProductDTO>}, TContext> => {

const mutationKey = ['apiMaterialsV1MaterialProductsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>, {id: number;data: BodyType<UpdateMaterialProductDTO>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiMaterialsV1MaterialProductsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiMaterialsV1MaterialProductsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>>
    export type ApiMaterialsV1MaterialProductsUpdateMutationBody = BodyType<UpdateMaterialProductDTO>
    export type ApiMaterialsV1MaterialProductsUpdateMutationError = ErrorType<ApiMaterialsV1MaterialProductsUpdate400 | ErrorResponse>

    export const useApiMaterialsV1MaterialProductsUpdate = <TError = ErrorType<ApiMaterialsV1MaterialProductsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>, TError,{id: number;data: BodyType<UpdateMaterialProductDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiMaterialsV1MaterialProductsUpdate>>,
        TError,
        {id: number;data: BodyType<UpdateMaterialProductDTO>},
        TContext
      > => {
      return useMutation(getApiMaterialsV1MaterialProductsUpdateMutationOptions(options), queryClient);
    }
    export const apiMaterialV1MaterialProductsDelete = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/materials/v1/material-products/${id}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiMaterialV1MaterialProductsDeleteMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>, TError,{id: number}, TContext> => {

const mutationKey = ['apiMaterialV1MaterialProductsDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  apiMaterialV1MaterialProductsDelete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiMaterialV1MaterialProductsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>>

    export type ApiMaterialV1MaterialProductsDeleteMutationError = ErrorType<ErrorResponse>

    export const useApiMaterialV1MaterialProductsDelete = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiMaterialV1MaterialProductsDelete>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getApiMaterialV1MaterialProductsDeleteMutationOptions(options), queryClient);
    }
    export const apiMaterialsV1MaterialRegionsRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialRegionList>(
      {url: `/api/materials/v1/material-regions/`, method: 'GET', signal
    },
      options);
    }




export const getApiMaterialsV1MaterialRegionsRetrieveQueryKey = () => {
    return [
    `/api/materials/v1/material-regions/`
    ] as const;
    }


export const getApiMaterialsV1MaterialRegionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialRegionsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialRegionsRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialRegionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>>
export type ApiMaterialsV1MaterialRegionsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiMaterialsV1MaterialRegionsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialRegionsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialRegionsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialRegionsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialRegionsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialRegionsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialRegionsRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialRegionsRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialRegionsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>>
export type ApiMaterialsV1MaterialRegionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiMaterialsV1MaterialRegionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialRegionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialRegionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialRegionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialRegionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialRegionsRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialsList = (
    params?: ApiMaterialsV1MaterialsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedMaterialList>(
      {url: `/api/materials/v1/materials/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiMaterialsV1MaterialsListQueryKey = (params?: ApiMaterialsV1MaterialsListParams,) => {
    return [
    `/api/materials/v1/materials/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiMaterialsV1MaterialsListQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(params?: ApiMaterialsV1MaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>> = ({ signal }) => apiMaterialsV1MaterialsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>>
export type ApiMaterialsV1MaterialsListQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialsList<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiMaterialsV1MaterialsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsList<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsList<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialsList<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(params?: ApiMaterialsV1MaterialsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>> = ({ signal }) => apiMaterialsV1MaterialsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>>
export type ApiMaterialsV1MaterialsListSuspenseQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(
 params: undefined |  ApiMaterialsV1MaterialsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialsListSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError = ErrorType<unknown>>(
 params?: ApiMaterialsV1MaterialsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialsSupportedComponentsRetrieve = (
    materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialSupportedComponentList>(
      {url: `/api/materials/v1/materials/${materialId}/supported-components/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiMaterialsV1MaterialsSupportedComponentsRetrieveQueryKey = (materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams,) => {
    return [
    `/api/materials/v1/materials/${materialId}/supported-components/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiMaterialsV1MaterialsSupportedComponentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialsSupportedComponentsRetrieveQueryKey(materialId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialsSupportedComponentsRetrieve(materialId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: materialId !== null && materialId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialsSupportedComponentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>>
export type ApiMaterialsV1MaterialsSupportedComponentsRetrieveQueryError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>


export function useApiMaterialsV1MaterialsSupportedComponentsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(
 materialId: number,
    params: undefined |  ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsSupportedComponentsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(
 materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsSupportedComponentsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(
 materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialsSupportedComponentsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(
 materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialsSupportedComponentsRetrieveQueryOptions(materialId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialsSupportedComponentsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialsSupportedComponentsRetrieveQueryKey(materialId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialsSupportedComponentsRetrieve(materialId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialsSupportedComponentsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>>
export type ApiMaterialsV1MaterialsSupportedComponentsRetrieveSuspenseQueryError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>


export function useApiMaterialsV1MaterialsSupportedComponentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(
 materialId: number,
    params: undefined |  ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsSupportedComponentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(
 materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsSupportedComponentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(
 materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialsSupportedComponentsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError = ErrorType<ApiMaterialsV1MaterialsSupportedComponentsRetrieve400 | ErrorResponse>>(
 materialId: number,
    params?: ApiMaterialsV1MaterialsSupportedComponentsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsSupportedComponentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialsSupportedComponentsRetrieveSuspenseQueryOptions(materialId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiMaterialsV1MaterialsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Material>(
      {url: `/api/materials/v1/materials/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiMaterialsV1MaterialsRetrieveQueryKey = (id: number,) => {
    return [
    `/api/materials/v1/materials/${id}/`
    ] as const;
    }


export const getApiMaterialsV1MaterialsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>>
export type ApiMaterialsV1MaterialsRetrieveQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialsRetrieve<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiMaterialsV1MaterialsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMaterialsV1MaterialsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>> = ({ signal }) => apiMaterialsV1MaterialsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMaterialsV1MaterialsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>>
export type ApiMaterialsV1MaterialsRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiMaterialsV1MaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMaterialsV1MaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiMaterialsV1MaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiMaterialsV1MaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMaterialsV1MaterialsRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiNotificationsV1PreferencesRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleUserNotificationPreference>(
      {url: `/api/notifications/v1/preferences/`, method: 'GET', signal
    },
      options);
    }




export const getApiNotificationsV1PreferencesRetrieveQueryKey = () => {
    return [
    `/api/notifications/v1/preferences/`
    ] as const;
    }


export const getApiNotificationsV1PreferencesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiNotificationsV1PreferencesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>> = ({ signal }) => apiNotificationsV1PreferencesRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiNotificationsV1PreferencesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>>
export type ApiNotificationsV1PreferencesRetrieveQueryError = ErrorType<unknown>


export function useApiNotificationsV1PreferencesRetrieve<TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiNotificationsV1PreferencesRetrieve<TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiNotificationsV1PreferencesRetrieve<TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiNotificationsV1PreferencesRetrieve<TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiNotificationsV1PreferencesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiNotificationsV1PreferencesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiNotificationsV1PreferencesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>> = ({ signal }) => apiNotificationsV1PreferencesRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiNotificationsV1PreferencesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>>
export type ApiNotificationsV1PreferencesRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiNotificationsV1PreferencesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiNotificationsV1PreferencesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiNotificationsV1PreferencesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiNotificationsV1PreferencesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiNotificationsV1PreferencesRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiNotificationsV1PreferencesUpdate = (
    userNotificationPreferenceUpdate?: BodyType<UserNotificationPreferenceUpdate>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleUserNotificationPreference>(
      {url: `/api/notifications/v1/preferences/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userNotificationPreferenceUpdate, signal
    },
      options);
    }




export const getApiNotificationsV1PreferencesUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesUpdate>>, TError,{data?: BodyType<UserNotificationPreferenceUpdate>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesUpdate>>, TError,{data?: BodyType<UserNotificationPreferenceUpdate>}, TContext> => {

const mutationKey = ['apiNotificationsV1PreferencesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiNotificationsV1PreferencesUpdate>>, {data?: BodyType<UserNotificationPreferenceUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  apiNotificationsV1PreferencesUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiNotificationsV1PreferencesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiNotificationsV1PreferencesUpdate>>>
    export type ApiNotificationsV1PreferencesUpdateMutationBody = BodyType<UserNotificationPreferenceUpdate> | undefined
    export type ApiNotificationsV1PreferencesUpdateMutationError = ErrorType<unknown>

    export const useApiNotificationsV1PreferencesUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiNotificationsV1PreferencesUpdate>>, TError,{data?: BodyType<UserNotificationPreferenceUpdate>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiNotificationsV1PreferencesUpdate>>,
        TError,
        {data?: BodyType<UserNotificationPreferenceUpdate>},
        TContext
      > => {
      return useMutation(getApiNotificationsV1PreferencesUpdateMutationOptions(options), queryClient);
    }
    export const apiV1Omnisearch = (
    params: ApiV1OmnisearchParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<OmnisearchResponse>(
      {url: `/api/omnisearch/v1/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiV1OmnisearchQueryKey = (params?: ApiV1OmnisearchParams,) => {
    return [
    `/api/omnisearch/v1/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiV1OmnisearchQueryOptions = <TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(params: ApiV1OmnisearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiV1OmnisearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiV1Omnisearch>>> = ({ signal }) => apiV1Omnisearch(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1OmnisearchQueryResult = NonNullable<Awaited<ReturnType<typeof apiV1Omnisearch>>>
export type ApiV1OmnisearchQueryError = ErrorType<ErrorResponse>


export function useApiV1Omnisearch<TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(
 params: ApiV1OmnisearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiV1Omnisearch>>,
          TError,
          Awaited<ReturnType<typeof apiV1Omnisearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiV1Omnisearch<TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(
 params: ApiV1OmnisearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiV1Omnisearch>>,
          TError,
          Awaited<ReturnType<typeof apiV1Omnisearch>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiV1Omnisearch<TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(
 params: ApiV1OmnisearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiV1Omnisearch<TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(
 params: ApiV1OmnisearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiV1OmnisearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiV1OmnisearchSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(params: ApiV1OmnisearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiV1OmnisearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiV1Omnisearch>>> = ({ signal }) => apiV1Omnisearch(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1OmnisearchSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiV1Omnisearch>>>
export type ApiV1OmnisearchSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiV1OmnisearchSuspense<TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(
 params: ApiV1OmnisearchParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiV1OmnisearchSuspense<TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(
 params: ApiV1OmnisearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiV1OmnisearchSuspense<TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(
 params: ApiV1OmnisearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiV1OmnisearchSuspense<TData = Awaited<ReturnType<typeof apiV1Omnisearch>>, TError = ErrorType<ErrorResponse>>(
 params: ApiV1OmnisearchParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiV1Omnisearch>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiV1OmnisearchSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const purchaseOrdersList = (
    params?: PurchaseOrdersListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedFullPurchaseOrderInfoList>(
      {url: `/api/orders/v1/purchase-orders/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPurchaseOrdersListQueryKey = (params?: PurchaseOrdersListParams,) => {
    return [
    `/api/orders/v1/purchase-orders/`, ...(params ? [params] : [])
    ] as const;
    }


export const getPurchaseOrdersListQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(params?: PurchaseOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersList>>> = ({ signal }) => purchaseOrdersList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersListQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersList>>>
export type PurchaseOrdersListQueryError = ErrorType<ErrorResponse>


export function usePurchaseOrdersList<TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  PurchaseOrdersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersList>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersList<TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(
 params?: PurchaseOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrdersList>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrdersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersList<TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(
 params?: PurchaseOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePurchaseOrdersList<TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(
 params?: PurchaseOrdersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPurchaseOrdersListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(params?: PurchaseOrdersListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPurchaseOrdersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrdersList>>> = ({ signal }) => purchaseOrdersList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PurchaseOrdersListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrdersList>>>
export type PurchaseOrdersListSuspenseQueryError = ErrorType<ErrorResponse>


export function usePurchaseOrdersListSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  PurchaseOrdersListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersListSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(
 params?: PurchaseOrdersListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePurchaseOrdersListSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(
 params?: PurchaseOrdersListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePurchaseOrdersListSuspense<TData = Awaited<ReturnType<typeof purchaseOrdersList>>, TError = ErrorType<ErrorResponse>>(
 params?: PurchaseOrdersListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrdersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPurchaseOrdersListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiOrdersV1PurchaseOrdersCreate = (
    createPurchaseOrderDTO: BodyType<CreatePurchaseOrderDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullPurchaseOrderInfo>(
      {url: `/api/orders/v1/purchase-orders/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPurchaseOrderDTO, signal
    },
      options);
    }




export const getApiOrdersV1PurchaseOrdersCreateMutationOptions = <TError = ErrorType<ApiOrdersV1PurchaseOrdersCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>, TError,{data: BodyType<CreatePurchaseOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>, TError,{data: BodyType<CreatePurchaseOrderDTO>}, TContext> => {

const mutationKey = ['apiOrdersV1PurchaseOrdersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>, {data: BodyType<CreatePurchaseOrderDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiOrdersV1PurchaseOrdersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1PurchaseOrdersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>>
    export type ApiOrdersV1PurchaseOrdersCreateMutationBody = BodyType<CreatePurchaseOrderDTO>
    export type ApiOrdersV1PurchaseOrdersCreateMutationError = ErrorType<ApiOrdersV1PurchaseOrdersCreate400 | ErrorResponse>

    export const useApiOrdersV1PurchaseOrdersCreate = <TError = ErrorType<ApiOrdersV1PurchaseOrdersCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>, TError,{data: BodyType<CreatePurchaseOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersCreate>>,
        TError,
        {data: BodyType<CreatePurchaseOrderDTO>},
        TContext
      > => {
      return useMutation(getApiOrdersV1PurchaseOrdersCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1PurchaseOrdersRetrieve = (
    slug: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullPurchaseOrderInfo>(
      {url: `/api/orders/v1/purchase-orders/${slug}/`, method: 'GET', signal
    },
      options);
    }




export const getApiOrdersV1PurchaseOrdersRetrieveQueryKey = (slug: string,) => {
    return [
    `/api/orders/v1/purchase-orders/${slug}/`
    ] as const;
    }


export const getApiOrdersV1PurchaseOrdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiOrdersV1PurchaseOrdersRetrieveQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>> = ({ signal }) => apiOrdersV1PurchaseOrdersRetrieve(slug, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiOrdersV1PurchaseOrdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>>
export type ApiOrdersV1PurchaseOrdersRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiOrdersV1PurchaseOrdersRetrieve<TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersV1PurchaseOrdersRetrieve<TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersV1PurchaseOrdersRetrieve<TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiOrdersV1PurchaseOrdersRetrieve<TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiOrdersV1PurchaseOrdersRetrieveQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiOrdersV1PurchaseOrdersRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiOrdersV1PurchaseOrdersRetrieveQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>> = ({ signal }) => apiOrdersV1PurchaseOrdersRetrieve(slug, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiOrdersV1PurchaseOrdersRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>>
export type ApiOrdersV1PurchaseOrdersRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiOrdersV1PurchaseOrdersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersV1PurchaseOrdersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersV1PurchaseOrdersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiOrdersV1PurchaseOrdersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiOrdersV1PurchaseOrdersRetrieveSuspenseQueryOptions(slug,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiOrdersV1PurchaseOrdersApproveCreate = (
    slug: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleResponse>(
      {url: `/api/orders/v1/purchase-orders/${slug}/approve/`, method: 'POST', signal
    },
      options);
    }




export const getApiOrdersV1PurchaseOrdersApproveCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>, TError,{slug: string}, TContext> => {

const mutationKey = ['apiOrdersV1PurchaseOrdersApproveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  apiOrdersV1PurchaseOrdersApproveCreate(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1PurchaseOrdersApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>>

    export type ApiOrdersV1PurchaseOrdersApproveCreateMutationError = ErrorType<unknown>

    export const useApiOrdersV1PurchaseOrdersApproveCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersApproveCreate>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getApiOrdersV1PurchaseOrdersApproveCreateMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for documents.
 */
export const apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate = (
    slug: string,
    documentPreSignedURLInput: BodyType<DocumentPreSignedURLInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentPreSignedURLOutput>(
      {url: `/api/orders/v1/purchase-orders/${slug}/documents/pre-signed-url/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentPreSignedURLInput, signal
    },
      options);
    }




export const getApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>, TError,{slug: string;data: BodyType<DocumentPreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>, TError,{slug: string;data: BodyType<DocumentPreSignedURLInput>}, TContext> => {

const mutationKey = ['apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>, {slug: string;data: BodyType<DocumentPreSignedURLInput>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>>
    export type ApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationBody = BodyType<DocumentPreSignedURLInput>
    export type ApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationError = ErrorType<ErrorResponse>

    export const useApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>, TError,{slug: string;data: BodyType<DocumentPreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreate>>,
        TError,
        {slug: string;data: BodyType<DocumentPreSignedURLInput>},
        TContext
      > => {
      return useMutation(getApiOrdersV1PurchaseOrdersDocumentsPreSignedUrlCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1PurchaseOrdersDocumentsUploadCreate = (
    slug: string,
    documentUpload: BodyType<DocumentUpload>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/orders/v1/purchase-orders/${slug}/documents/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentUpload, signal
    },
      options);
    }




export const getApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>, TError,{slug: string;data: BodyType<DocumentUpload>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>, TError,{slug: string;data: BodyType<DocumentUpload>}, TContext> => {

const mutationKey = ['apiOrdersV1PurchaseOrdersDocumentsUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>, {slug: string;data: BodyType<DocumentUpload>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiOrdersV1PurchaseOrdersDocumentsUploadCreate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>>
    export type ApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationBody = BodyType<DocumentUpload>
    export type ApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiOrdersV1PurchaseOrdersDocumentsUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>, TError,{slug: string;data: BodyType<DocumentUpload>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersDocumentsUploadCreate>>,
        TError,
        {slug: string;data: BodyType<DocumentUpload>},
        TContext
      > => {
      return useMutation(getApiOrdersV1PurchaseOrdersDocumentsUploadCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1PurchaseOrdersRejectCreate = (
    slug: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleResponse>(
      {url: `/api/orders/v1/purchase-orders/${slug}/reject/`, method: 'POST', signal
    },
      options);
    }




export const getApiOrdersV1PurchaseOrdersRejectCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>, TError,{slug: string}, TContext> => {

const mutationKey = ['apiOrdersV1PurchaseOrdersRejectCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  apiOrdersV1PurchaseOrdersRejectCreate(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1PurchaseOrdersRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>>

    export type ApiOrdersV1PurchaseOrdersRejectCreateMutationError = ErrorType<unknown>

    export const useApiOrdersV1PurchaseOrdersRejectCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersRejectCreate>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getApiOrdersV1PurchaseOrdersRejectCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1PurchaseOrdersUpdatePartialUpdate = (
    slug: string,
    patchedUpdatePurchaseOrderDTO?: BodyType<PatchedUpdatePurchaseOrderDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullPurchaseOrderInfo>(
      {url: `/api/orders/v1/purchase-orders/${slug}/update/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedUpdatePurchaseOrderDTO, signal
    },
      options);
    }




export const getApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationOptions = <TError = ErrorType<ApiOrdersV1PurchaseOrdersUpdatePartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedUpdatePurchaseOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedUpdatePurchaseOrderDTO>}, TContext> => {

const mutationKey = ['apiOrdersV1PurchaseOrdersUpdatePartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>, {slug: string;data?: BodyType<PatchedUpdatePurchaseOrderDTO>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiOrdersV1PurchaseOrdersUpdatePartialUpdate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>>
    export type ApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationBody = BodyType<PatchedUpdatePurchaseOrderDTO> | undefined
    export type ApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationError = ErrorType<ApiOrdersV1PurchaseOrdersUpdatePartialUpdate400 | ErrorResponse>

    export const useApiOrdersV1PurchaseOrdersUpdatePartialUpdate = <TError = ErrorType<ApiOrdersV1PurchaseOrdersUpdatePartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedUpdatePurchaseOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1PurchaseOrdersUpdatePartialUpdate>>,
        TError,
        {slug: string;data?: BodyType<PatchedUpdatePurchaseOrderDTO>},
        TContext
      > => {
      return useMutation(getApiOrdersV1PurchaseOrdersUpdatePartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const salesOrderList = (
    params?: SalesOrderListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedFullSalesOrderInfoList>(
      {url: `/api/orders/v1/sales-orders/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSalesOrderListQueryKey = (params?: SalesOrderListParams,) => {
    return [
    `/api/orders/v1/sales-orders/`, ...(params ? [params] : [])
    ] as const;
    }


export const getSalesOrderListQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(params?: SalesOrderListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderList>>> = ({ signal }) => salesOrderList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderListQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderList>>>
export type SalesOrderListQueryError = ErrorType<ErrorResponse>


export function useSalesOrderList<TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  SalesOrderListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderList>>,
          TError,
          Awaited<ReturnType<typeof salesOrderList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderList<TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(
 params?: SalesOrderListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesOrderList>>,
          TError,
          Awaited<ReturnType<typeof salesOrderList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderList<TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(
 params?: SalesOrderListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderList<TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(
 params?: SalesOrderListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSalesOrderListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(params?: SalesOrderListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesOrderListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesOrderList>>> = ({ signal }) => salesOrderList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesOrderListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof salesOrderList>>>
export type SalesOrderListSuspenseQueryError = ErrorType<ErrorResponse>


export function useSalesOrderListSuspense<TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  SalesOrderListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderListSuspense<TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(
 params?: SalesOrderListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesOrderListSuspense<TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(
 params?: SalesOrderListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSalesOrderListSuspense<TData = Awaited<ReturnType<typeof salesOrderList>>, TError = ErrorType<ErrorResponse>>(
 params?: SalesOrderListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof salesOrderList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesOrderListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiOrdersV1SalesOrdersCreate = (
    createSalesOrderDTO: BodyType<CreateSalesOrderDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullSalesOrderInfo>(
      {url: `/api/orders/v1/sales-orders/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSalesOrderDTO, signal
    },
      options);
    }




export const getApiOrdersV1SalesOrdersCreateMutationOptions = <TError = ErrorType<ApiOrdersV1SalesOrdersCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>, TError,{data: BodyType<CreateSalesOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>, TError,{data: BodyType<CreateSalesOrderDTO>}, TContext> => {

const mutationKey = ['apiOrdersV1SalesOrdersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>, {data: BodyType<CreateSalesOrderDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiOrdersV1SalesOrdersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1SalesOrdersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>>
    export type ApiOrdersV1SalesOrdersCreateMutationBody = BodyType<CreateSalesOrderDTO>
    export type ApiOrdersV1SalesOrdersCreateMutationError = ErrorType<ApiOrdersV1SalesOrdersCreate400>

    export const useApiOrdersV1SalesOrdersCreate = <TError = ErrorType<ApiOrdersV1SalesOrdersCreate400>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>, TError,{data: BodyType<CreateSalesOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCreate>>,
        TError,
        {data: BodyType<CreateSalesOrderDTO>},
        TContext
      > => {
      return useMutation(getApiOrdersV1SalesOrdersCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1SalesOrdersRetrieve = (
    slug: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullSalesOrderInfo>(
      {url: `/api/orders/v1/sales-orders/${slug}/`, method: 'GET', signal
    },
      options);
    }




export const getApiOrdersV1SalesOrdersRetrieveQueryKey = (slug: string,) => {
    return [
    `/api/orders/v1/sales-orders/${slug}/`
    ] as const;
    }


export const getApiOrdersV1SalesOrdersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiOrdersV1SalesOrdersRetrieveQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>> = ({ signal }) => apiOrdersV1SalesOrdersRetrieve(slug, requestOptions, signal);





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiOrdersV1SalesOrdersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>>
export type ApiOrdersV1SalesOrdersRetrieveQueryError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>


export function useApiOrdersV1SalesOrdersRetrieve<TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersV1SalesOrdersRetrieve<TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersV1SalesOrdersRetrieve<TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiOrdersV1SalesOrdersRetrieve<TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiOrdersV1SalesOrdersRetrieveQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiOrdersV1SalesOrdersRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiOrdersV1SalesOrdersRetrieveQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>> = ({ signal }) => apiOrdersV1SalesOrdersRetrieve(slug, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiOrdersV1SalesOrdersRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>>
export type ApiOrdersV1SalesOrdersRetrieveSuspenseQueryError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>


export function useApiOrdersV1SalesOrdersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(
 slug: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersV1SalesOrdersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersV1SalesOrdersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiOrdersV1SalesOrdersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError = ErrorType<ApiOrdersV1SalesOrdersRetrieve400 | ErrorResponse>>(
 slug: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiOrdersV1SalesOrdersRetrieveSuspenseQueryOptions(slug,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiOrdersV1SalesOrdersApproveCreate = (
    slug: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleResponse>(
      {url: `/api/orders/v1/sales-orders/${slug}/approve/`, method: 'POST', signal
    },
      options);
    }




export const getApiOrdersV1SalesOrdersApproveCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>, TError,{slug: string}, TContext> => {

const mutationKey = ['apiOrdersV1SalesOrdersApproveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  apiOrdersV1SalesOrdersApproveCreate(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1SalesOrdersApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>>

    export type ApiOrdersV1SalesOrdersApproveCreateMutationError = ErrorType<unknown>

    export const useApiOrdersV1SalesOrdersApproveCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1SalesOrdersApproveCreate>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getApiOrdersV1SalesOrdersApproveCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate = (
    slug: string,
    patchedCustomerUpdateSalesOrderDTO?: BodyType<PatchedCustomerUpdateSalesOrderDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleSalesOrder>(
      {url: `/api/orders/v1/sales-orders/${slug}/customer-update/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedCustomerUpdateSalesOrderDTO, signal
    },
      options);
    }




export const getApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationOptions = <TError = ErrorType<ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedCustomerUpdateSalesOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedCustomerUpdateSalesOrderDTO>}, TContext> => {

const mutationKey = ['apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>, {slug: string;data?: BodyType<PatchedCustomerUpdateSalesOrderDTO>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>>
    export type ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationBody = BodyType<PatchedCustomerUpdateSalesOrderDTO> | undefined
    export type ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationError = ErrorType<ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate400 | ErrorResponse>

    export const useApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate = <TError = ErrorType<ApiOrdersV1SalesOrdersCustomerUpdatePartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedCustomerUpdateSalesOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1SalesOrdersCustomerUpdatePartialUpdate>>,
        TError,
        {slug: string;data?: BodyType<PatchedCustomerUpdateSalesOrderDTO>},
        TContext
      > => {
      return useMutation(getApiOrdersV1SalesOrdersCustomerUpdatePartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for documents.
 */
export const apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate = (
    slug: string,
    documentPreSignedURLInput: BodyType<DocumentPreSignedURLInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentPreSignedURLOutput>(
      {url: `/api/orders/v1/sales-orders/${slug}/documents/pre-signed-url/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentPreSignedURLInput, signal
    },
      options);
    }




export const getApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>, TError,{slug: string;data: BodyType<DocumentPreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>, TError,{slug: string;data: BodyType<DocumentPreSignedURLInput>}, TContext> => {

const mutationKey = ['apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>, {slug: string;data: BodyType<DocumentPreSignedURLInput>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>>
    export type ApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationBody = BodyType<DocumentPreSignedURLInput>
    export type ApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationError = ErrorType<ErrorResponse>

    export const useApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>, TError,{slug: string;data: BodyType<DocumentPreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsPreSignedUrlCreate>>,
        TError,
        {slug: string;data: BodyType<DocumentPreSignedURLInput>},
        TContext
      > => {
      return useMutation(getApiOrdersV1SalesOrdersDocumentsPreSignedUrlCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1SalesOrdersDocumentsUploadCreate = (
    slug: string,
    documentUpload: BodyType<DocumentUpload>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/orders/v1/sales-orders/${slug}/documents/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentUpload, signal
    },
      options);
    }




export const getApiOrdersV1SalesOrdersDocumentsUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>, TError,{slug: string;data: BodyType<DocumentUpload>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>, TError,{slug: string;data: BodyType<DocumentUpload>}, TContext> => {

const mutationKey = ['apiOrdersV1SalesOrdersDocumentsUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>, {slug: string;data: BodyType<DocumentUpload>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiOrdersV1SalesOrdersDocumentsUploadCreate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1SalesOrdersDocumentsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>>
    export type ApiOrdersV1SalesOrdersDocumentsUploadCreateMutationBody = BodyType<DocumentUpload>
    export type ApiOrdersV1SalesOrdersDocumentsUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiOrdersV1SalesOrdersDocumentsUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>, TError,{slug: string;data: BodyType<DocumentUpload>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1SalesOrdersDocumentsUploadCreate>>,
        TError,
        {slug: string;data: BodyType<DocumentUpload>},
        TContext
      > => {
      return useMutation(getApiOrdersV1SalesOrdersDocumentsUploadCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1SalesOrdersRejectCreate = (
    slug: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleResponse>(
      {url: `/api/orders/v1/sales-orders/${slug}/reject/`, method: 'POST', signal
    },
      options);
    }




export const getApiOrdersV1SalesOrdersRejectCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>, TError,{slug: string}, TContext> => {

const mutationKey = ['apiOrdersV1SalesOrdersRejectCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  apiOrdersV1SalesOrdersRejectCreate(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1SalesOrdersRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>>

    export type ApiOrdersV1SalesOrdersRejectCreateMutationError = ErrorType<unknown>

    export const useApiOrdersV1SalesOrdersRejectCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1SalesOrdersRejectCreate>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getApiOrdersV1SalesOrdersRejectCreateMutationOptions(options), queryClient);
    }
    export const apiOrdersV1SalesOrdersUpdatePartialUpdate = (
    slug: string,
    patchedUpdateSalesOrderDTO?: BodyType<PatchedUpdateSalesOrderDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullSalesOrderInfo>(
      {url: `/api/orders/v1/sales-orders/${slug}/update/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedUpdateSalesOrderDTO, signal
    },
      options);
    }




export const getApiOrdersV1SalesOrdersUpdatePartialUpdateMutationOptions = <TError = ErrorType<ApiOrdersV1SalesOrdersUpdatePartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedUpdateSalesOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedUpdateSalesOrderDTO>}, TContext> => {

const mutationKey = ['apiOrdersV1SalesOrdersUpdatePartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>, {slug: string;data?: BodyType<PatchedUpdateSalesOrderDTO>}> = (props) => {
          const {slug,data} = props ?? {};

          return  apiOrdersV1SalesOrdersUpdatePartialUpdate(slug,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersV1SalesOrdersUpdatePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>>
    export type ApiOrdersV1SalesOrdersUpdatePartialUpdateMutationBody = BodyType<PatchedUpdateSalesOrderDTO> | undefined
    export type ApiOrdersV1SalesOrdersUpdatePartialUpdateMutationError = ErrorType<ApiOrdersV1SalesOrdersUpdatePartialUpdate400 | ErrorResponse>

    export const useApiOrdersV1SalesOrdersUpdatePartialUpdate = <TError = ErrorType<ApiOrdersV1SalesOrdersUpdatePartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>, TError,{slug: string;data?: BodyType<PatchedUpdateSalesOrderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersV1SalesOrdersUpdatePartialUpdate>>,
        TError,
        {slug: string;data?: BodyType<PatchedUpdateSalesOrderDTO>},
        TContext
      > => {
      return useMutation(getApiOrdersV1SalesOrdersUpdatePartialUpdateMutationOptions(options), queryClient);
    }
    export const apiPostDealTrackerV1CarriersRetrieve = (
    params?: ApiPostDealTrackerV1CarriersRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CarrierList>(
      {url: `/api/post-deal/tracker/v1/carriers/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiPostDealTrackerV1CarriersRetrieveQueryKey = (params?: ApiPostDealTrackerV1CarriersRetrieveParams,) => {
    return [
    `/api/post-deal/tracker/v1/carriers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiPostDealTrackerV1CarriersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiPostDealTrackerV1CarriersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiPostDealTrackerV1CarriersRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>> = ({ signal }) => apiPostDealTrackerV1CarriersRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiPostDealTrackerV1CarriersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>>
export type ApiPostDealTrackerV1CarriersRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiPostDealTrackerV1CarriersRetrieve<TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiPostDealTrackerV1CarriersRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiPostDealTrackerV1CarriersRetrieve<TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiPostDealTrackerV1CarriersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiPostDealTrackerV1CarriersRetrieve<TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiPostDealTrackerV1CarriersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiPostDealTrackerV1CarriersRetrieve<TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiPostDealTrackerV1CarriersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiPostDealTrackerV1CarriersRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiPostDealTrackerV1CarriersRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiPostDealTrackerV1CarriersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiPostDealTrackerV1CarriersRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>> = ({ signal }) => apiPostDealTrackerV1CarriersRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiPostDealTrackerV1CarriersRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>>
export type ApiPostDealTrackerV1CarriersRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiPostDealTrackerV1CarriersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiPostDealTrackerV1CarriersRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiPostDealTrackerV1CarriersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiPostDealTrackerV1CarriersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiPostDealTrackerV1CarriersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiPostDealTrackerV1CarriersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiPostDealTrackerV1CarriersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiPostDealTrackerV1CarriersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiPostDealTrackerV1CarriersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiPostDealTrackerV1CarriersRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Invalidate cached compositions for all, specific companies, or specific sessions
 * @summary Invalidate composition cache
 */
export const apiQualityReportV1AdminCompositionCacheInvalidateCreate = (
    invalidateCompositionCacheRequest?: BodyType<InvalidateCompositionCacheRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<InvalidateCompositionCacheResponse>(
      {url: `/api/quality-report/v1/admin/composition-cache/invalidate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invalidateCompositionCacheRequest, signal
    },
      options);
    }




export const getApiQualityReportV1AdminCompositionCacheInvalidateCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheInvalidateCreate>>, TError,{data?: BodyType<InvalidateCompositionCacheRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheInvalidateCreate>>, TError,{data?: BodyType<InvalidateCompositionCacheRequest>}, TContext> => {

const mutationKey = ['apiQualityReportV1AdminCompositionCacheInvalidateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheInvalidateCreate>>, {data?: BodyType<InvalidateCompositionCacheRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityReportV1AdminCompositionCacheInvalidateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityReportV1AdminCompositionCacheInvalidateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheInvalidateCreate>>>
    export type ApiQualityReportV1AdminCompositionCacheInvalidateCreateMutationBody = BodyType<InvalidateCompositionCacheRequest> | undefined
    export type ApiQualityReportV1AdminCompositionCacheInvalidateCreateMutationError = ErrorType<void>

    /**
 * @summary Invalidate composition cache
 */
export const useApiQualityReportV1AdminCompositionCacheInvalidateCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheInvalidateCreate>>, TError,{data?: BodyType<InvalidateCompositionCacheRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheInvalidateCreate>>,
        TError,
        {data?: BodyType<InvalidateCompositionCacheRequest>},
        TContext
      > => {
      return useMutation(getApiQualityReportV1AdminCompositionCacheInvalidateCreateMutationOptions(options), queryClient);
    }
    /**
 * Pre-populate cache by calculating compositions for specific companies or sessions
 * @summary Warm composition cache
 */
export const apiQualityReportV1AdminCompositionCacheWarmCreate = (
    warmCompositionCacheRequest?: BodyType<WarmCompositionCacheRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<WarmCompositionCacheResponse>(
      {url: `/api/quality-report/v1/admin/composition-cache/warm/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: warmCompositionCacheRequest, signal
    },
      options);
    }




export const getApiQualityReportV1AdminCompositionCacheWarmCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheWarmCreate>>, TError,{data?: BodyType<WarmCompositionCacheRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheWarmCreate>>, TError,{data?: BodyType<WarmCompositionCacheRequest>}, TContext> => {

const mutationKey = ['apiQualityReportV1AdminCompositionCacheWarmCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheWarmCreate>>, {data?: BodyType<WarmCompositionCacheRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityReportV1AdminCompositionCacheWarmCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityReportV1AdminCompositionCacheWarmCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheWarmCreate>>>
    export type ApiQualityReportV1AdminCompositionCacheWarmCreateMutationBody = BodyType<WarmCompositionCacheRequest> | undefined
    export type ApiQualityReportV1AdminCompositionCacheWarmCreateMutationError = ErrorType<void>

    /**
 * @summary Warm composition cache
 */
export const useApiQualityReportV1AdminCompositionCacheWarmCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheWarmCreate>>, TError,{data?: BodyType<WarmCompositionCacheRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityReportV1AdminCompositionCacheWarmCreate>>,
        TError,
        {data?: BodyType<WarmCompositionCacheRequest>},
        TContext
      > => {
      return useMutation(getApiQualityReportV1AdminCompositionCacheWarmCreateMutationOptions(options), queryClient);
    }
    /**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualityInstructionsV1SpecificationsList = (
    params?: ApiQualityInstructionsV1SpecificationsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedSpecificationListItemList>(
      {url: `/api/quality-specifications/v1/specifications/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityInstructionsV1SpecificationsListQueryKey = (params?: ApiQualityInstructionsV1SpecificationsListParams,) => {
    return [
    `/api/quality-specifications/v1/specifications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityInstructionsV1SpecificationsListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityInstructionsV1SpecificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityInstructionsV1SpecificationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>> = ({ signal }) => apiQualityInstructionsV1SpecificationsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityInstructionsV1SpecificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>>
export type ApiQualityInstructionsV1SpecificationsListQueryError = ErrorType<ErrorResponse>


export function useApiQualityInstructionsV1SpecificationsList<TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityInstructionsV1SpecificationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityInstructionsV1SpecificationsList<TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityInstructionsV1SpecificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityInstructionsV1SpecificationsList<TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityInstructionsV1SpecificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityInstructionsV1SpecificationsList<TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityInstructionsV1SpecificationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityInstructionsV1SpecificationsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityInstructionsV1SpecificationsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityInstructionsV1SpecificationsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityInstructionsV1SpecificationsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>> = ({ signal }) => apiQualityInstructionsV1SpecificationsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityInstructionsV1SpecificationsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>>
export type ApiQualityInstructionsV1SpecificationsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityInstructionsV1SpecificationsListSuspense<TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityInstructionsV1SpecificationsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityInstructionsV1SpecificationsListSuspense<TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityInstructionsV1SpecificationsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityInstructionsV1SpecificationsListSuspense<TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityInstructionsV1SpecificationsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityInstructionsV1SpecificationsListSuspense<TData = Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityInstructionsV1SpecificationsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityInstructionsV1SpecificationsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityInstructionsV1SpecificationsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualitySpecificationsV1SpecificationsCreate = (
    specificationCreateDTO: BodyType<SpecificationCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SpecificationCreateResponse>(
      {url: `/api/quality-specifications/v1/specifications/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: specificationCreateDTO, signal
    },
      options);
    }




export const getApiQualitySpecificationsV1SpecificationsCreateMutationOptions = <TError = ErrorType<ApiQualitySpecificationsV1SpecificationsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsCreate>>, TError,{data: BodyType<SpecificationCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsCreate>>, TError,{data: BodyType<SpecificationCreateDTO>}, TContext> => {

const mutationKey = ['apiQualitySpecificationsV1SpecificationsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsCreate>>, {data: BodyType<SpecificationCreateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualitySpecificationsV1SpecificationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySpecificationsV1SpecificationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsCreate>>>
    export type ApiQualitySpecificationsV1SpecificationsCreateMutationBody = BodyType<SpecificationCreateDTO>
    export type ApiQualitySpecificationsV1SpecificationsCreateMutationError = ErrorType<ApiQualitySpecificationsV1SpecificationsCreate400 | ErrorResponse>

    export const useApiQualitySpecificationsV1SpecificationsCreate = <TError = ErrorType<ApiQualitySpecificationsV1SpecificationsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsCreate>>, TError,{data: BodyType<SpecificationCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsCreate>>,
        TError,
        {data: BodyType<SpecificationCreateDTO>},
        TContext
      > => {
      return useMutation(getApiQualitySpecificationsV1SpecificationsCreateMutationOptions(options), queryClient);
    }
    export const apiQualitySpecificationsV1SpecificationsRetrieve = (
    specificationId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SpecificationDetail>(
      {url: `/api/quality-specifications/v1/specifications/${specificationId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualitySpecificationsV1SpecificationsRetrieveQueryKey = (specificationId: number,) => {
    return [
    `/api/quality-specifications/v1/specifications/${specificationId}/`
    ] as const;
    }


export const getApiQualitySpecificationsV1SpecificationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(specificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySpecificationsV1SpecificationsRetrieveQueryKey(specificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>> = ({ signal }) => apiQualitySpecificationsV1SpecificationsRetrieve(specificationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: specificationId !== null && specificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySpecificationsV1SpecificationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>>
export type ApiQualitySpecificationsV1SpecificationsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualitySpecificationsV1SpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 specificationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySpecificationsV1SpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 specificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySpecificationsV1SpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 specificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySpecificationsV1SpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 specificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySpecificationsV1SpecificationsRetrieveQueryOptions(specificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualitySpecificationsV1SpecificationsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(specificationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySpecificationsV1SpecificationsRetrieveQueryKey(specificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>> = ({ signal }) => apiQualitySpecificationsV1SpecificationsRetrieve(specificationId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySpecificationsV1SpecificationsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>>
export type ApiQualitySpecificationsV1SpecificationsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualitySpecificationsV1SpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 specificationId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySpecificationsV1SpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 specificationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySpecificationsV1SpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 specificationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySpecificationsV1SpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 specificationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySpecificationsV1SpecificationsRetrieveSuspenseQueryOptions(specificationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualitySpecificationsV1SpecificationsUpdate = (
    specificationId: number,
    specificationUpdateDTO?: BodyType<SpecificationUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SpecificationDetail>(
      {url: `/api/quality-specifications/v1/specifications/${specificationId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: specificationUpdateDTO, signal
    },
      options);
    }




export const getApiQualitySpecificationsV1SpecificationsUpdateMutationOptions = <TError = ErrorType<ApiQualitySpecificationsV1SpecificationsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsUpdate>>, TError,{specificationId: number;data?: BodyType<SpecificationUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsUpdate>>, TError,{specificationId: number;data?: BodyType<SpecificationUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualitySpecificationsV1SpecificationsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsUpdate>>, {specificationId: number;data?: BodyType<SpecificationUpdateDTO>}> = (props) => {
          const {specificationId,data} = props ?? {};

          return  apiQualitySpecificationsV1SpecificationsUpdate(specificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySpecificationsV1SpecificationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsUpdate>>>
    export type ApiQualitySpecificationsV1SpecificationsUpdateMutationBody = BodyType<SpecificationUpdateDTO> | undefined
    export type ApiQualitySpecificationsV1SpecificationsUpdateMutationError = ErrorType<ApiQualitySpecificationsV1SpecificationsUpdate400 | ErrorResponse>

    export const useApiQualitySpecificationsV1SpecificationsUpdate = <TError = ErrorType<ApiQualitySpecificationsV1SpecificationsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsUpdate>>, TError,{specificationId: number;data?: BodyType<SpecificationUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsUpdate>>,
        TError,
        {specificationId: number;data?: BodyType<SpecificationUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualitySpecificationsV1SpecificationsUpdateMutationOptions(options), queryClient);
    }
    export const apiQualitySpecificationsV1SpecificationsDestroy = (
    specificationId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality-specifications/v1/specifications/${specificationId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualitySpecificationsV1SpecificationsDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsDestroy>>, TError,{specificationId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsDestroy>>, TError,{specificationId: number}, TContext> => {

const mutationKey = ['apiQualitySpecificationsV1SpecificationsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsDestroy>>, {specificationId: number}> = (props) => {
          const {specificationId} = props ?? {};

          return  apiQualitySpecificationsV1SpecificationsDestroy(specificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySpecificationsV1SpecificationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsDestroy>>>

    export type ApiQualitySpecificationsV1SpecificationsDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualitySpecificationsV1SpecificationsDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsDestroy>>, TError,{specificationId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySpecificationsV1SpecificationsDestroy>>,
        TError,
        {specificationId: number},
        TContext
      > => {
      return useMutation(getApiQualitySpecificationsV1SpecificationsDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate = (
    resyncFeedbackToSuperviselyRequestDTO?: BodyType<ResyncFeedbackToSuperviselyRequestDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ResyncFeedbackToSuperviselyResponseDTO>(
      {url: `/api/quality/ai-feedback/v1/admin/resync-feedback-to-supervisely/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resyncFeedbackToSuperviselyRequestDTO, signal
    },
      options);
    }




export const getApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreateMutationOptions = <TError = ErrorType<ApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate>>, TError,{data?: BodyType<ResyncFeedbackToSuperviselyRequestDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate>>, TError,{data?: BodyType<ResyncFeedbackToSuperviselyRequestDTO>}, TContext> => {

const mutationKey = ['apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate>>, {data?: BodyType<ResyncFeedbackToSuperviselyRequestDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate>>>
    export type ApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreateMutationBody = BodyType<ResyncFeedbackToSuperviselyRequestDTO> | undefined
    export type ApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreateMutationError = ErrorType<ApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate400 | ErrorResponse>

    export const useApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate = <TError = ErrorType<ApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate>>, TError,{data?: BodyType<ResyncFeedbackToSuperviselyRequestDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreate>>,
        TError,
        {data?: BodyType<ResyncFeedbackToSuperviselyRequestDTO>},
        TContext
      > => {
      return useMutation(getApiQualityAiFeedbackV1AdminResyncFeedbackToSuperviselyCreateMutationOptions(options), queryClient);
    }
    export const apiQualityAiFeedbackV1EvidenceFeedbackRetrieve = (
    evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<AnnotationFeedbackListResponse>(
      {url: `/api/quality/ai-feedback/v1/evidence/${evidenceId}/feedback/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityAiFeedbackV1EvidenceFeedbackRetrieveQueryKey = (evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams,) => {
    return [
    `/api/quality/ai-feedback/v1/evidence/${evidenceId}/feedback/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityAiFeedbackV1EvidenceFeedbackRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAiFeedbackV1EvidenceFeedbackRetrieveQueryKey(evidenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>> = ({ signal }) => apiQualityAiFeedbackV1EvidenceFeedbackRetrieve(evidenceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: evidenceId !== null && evidenceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>>
export type ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityAiFeedbackV1EvidenceFeedbackRetrieve<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number,
    params: undefined |  ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAiFeedbackV1EvidenceFeedbackRetrieve<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAiFeedbackV1EvidenceFeedbackRetrieve<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAiFeedbackV1EvidenceFeedbackRetrieve<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAiFeedbackV1EvidenceFeedbackRetrieveQueryOptions(evidenceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityAiFeedbackV1EvidenceFeedbackRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAiFeedbackV1EvidenceFeedbackRetrieveQueryKey(evidenceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>> = ({ signal }) => apiQualityAiFeedbackV1EvidenceFeedbackRetrieve(evidenceId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>>
export type ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityAiFeedbackV1EvidenceFeedbackRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number,
    params: undefined |  ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAiFeedbackV1EvidenceFeedbackRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAiFeedbackV1EvidenceFeedbackRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAiFeedbackV1EvidenceFeedbackRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 evidenceId: number,
    params?: ApiQualityAiFeedbackV1EvidenceFeedbackRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAiFeedbackV1EvidenceFeedbackRetrieveSuspenseQueryOptions(evidenceId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityAiFeedbackV1EvidenceFeedbackCreate = (
    evidenceId: number,
    annotationFeedbackCreateRequest: BodyType<AnnotationFeedbackCreateRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<AnnotationFeedbackDetail>(
      {url: `/api/quality/ai-feedback/v1/evidence/${evidenceId}/feedback/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: annotationFeedbackCreateRequest, signal
    },
      options);
    }




export const getApiQualityAiFeedbackV1EvidenceFeedbackCreateMutationOptions = <TError = ErrorType<ApiQualityAiFeedbackV1EvidenceFeedbackCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackCreate>>, TError,{evidenceId: number;data: BodyType<AnnotationFeedbackCreateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackCreate>>, TError,{evidenceId: number;data: BodyType<AnnotationFeedbackCreateRequest>}, TContext> => {

const mutationKey = ['apiQualityAiFeedbackV1EvidenceFeedbackCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackCreate>>, {evidenceId: number;data: BodyType<AnnotationFeedbackCreateRequest>}> = (props) => {
          const {evidenceId,data} = props ?? {};

          return  apiQualityAiFeedbackV1EvidenceFeedbackCreate(evidenceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityAiFeedbackV1EvidenceFeedbackCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackCreate>>>
    export type ApiQualityAiFeedbackV1EvidenceFeedbackCreateMutationBody = BodyType<AnnotationFeedbackCreateRequest>
    export type ApiQualityAiFeedbackV1EvidenceFeedbackCreateMutationError = ErrorType<ApiQualityAiFeedbackV1EvidenceFeedbackCreate400 | ErrorResponse>

    export const useApiQualityAiFeedbackV1EvidenceFeedbackCreate = <TError = ErrorType<ApiQualityAiFeedbackV1EvidenceFeedbackCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackCreate>>, TError,{evidenceId: number;data: BodyType<AnnotationFeedbackCreateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityAiFeedbackV1EvidenceFeedbackCreate>>,
        TError,
        {evidenceId: number;data: BodyType<AnnotationFeedbackCreateRequest>},
        TContext
      > => {
      return useMutation(getApiQualityAiFeedbackV1EvidenceFeedbackCreateMutationOptions(options), queryClient);
    }
    export const apiQualityAiFeedbackV1FeedbackRetrieve = (
    feedbackId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<AnnotationFeedbackDetail>(
      {url: `/api/quality/ai-feedback/v1/feedback/${feedbackId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityAiFeedbackV1FeedbackRetrieveQueryKey = (feedbackId: number,) => {
    return [
    `/api/quality/ai-feedback/v1/feedback/${feedbackId}/`
    ] as const;
    }


export const getApiQualityAiFeedbackV1FeedbackRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(feedbackId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAiFeedbackV1FeedbackRetrieveQueryKey(feedbackId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>> = ({ signal }) => apiQualityAiFeedbackV1FeedbackRetrieve(feedbackId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: feedbackId !== null && feedbackId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAiFeedbackV1FeedbackRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>>
export type ApiQualityAiFeedbackV1FeedbackRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityAiFeedbackV1FeedbackRetrieve<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 feedbackId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAiFeedbackV1FeedbackRetrieve<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 feedbackId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAiFeedbackV1FeedbackRetrieve<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 feedbackId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAiFeedbackV1FeedbackRetrieve<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 feedbackId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAiFeedbackV1FeedbackRetrieveQueryOptions(feedbackId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityAiFeedbackV1FeedbackRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(feedbackId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAiFeedbackV1FeedbackRetrieveQueryKey(feedbackId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>> = ({ signal }) => apiQualityAiFeedbackV1FeedbackRetrieve(feedbackId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAiFeedbackV1FeedbackRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>>
export type ApiQualityAiFeedbackV1FeedbackRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityAiFeedbackV1FeedbackRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 feedbackId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAiFeedbackV1FeedbackRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 feedbackId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAiFeedbackV1FeedbackRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 feedbackId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAiFeedbackV1FeedbackRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError = ErrorType<ErrorResponse>>(
 feedbackId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAiFeedbackV1FeedbackRetrieveSuspenseQueryOptions(feedbackId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityAiFeedbackV1FeedbackUpdate = (
    feedbackId: number,
    annotationFeedbackUpdateRequest?: BodyType<AnnotationFeedbackUpdateRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<AnnotationFeedbackDetail>(
      {url: `/api/quality/ai-feedback/v1/feedback/${feedbackId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: annotationFeedbackUpdateRequest, signal
    },
      options);
    }




export const getApiQualityAiFeedbackV1FeedbackUpdateMutationOptions = <TError = ErrorType<ApiQualityAiFeedbackV1FeedbackUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackUpdate>>, TError,{feedbackId: number;data?: BodyType<AnnotationFeedbackUpdateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackUpdate>>, TError,{feedbackId: number;data?: BodyType<AnnotationFeedbackUpdateRequest>}, TContext> => {

const mutationKey = ['apiQualityAiFeedbackV1FeedbackUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackUpdate>>, {feedbackId: number;data?: BodyType<AnnotationFeedbackUpdateRequest>}> = (props) => {
          const {feedbackId,data} = props ?? {};

          return  apiQualityAiFeedbackV1FeedbackUpdate(feedbackId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityAiFeedbackV1FeedbackUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackUpdate>>>
    export type ApiQualityAiFeedbackV1FeedbackUpdateMutationBody = BodyType<AnnotationFeedbackUpdateRequest> | undefined
    export type ApiQualityAiFeedbackV1FeedbackUpdateMutationError = ErrorType<ApiQualityAiFeedbackV1FeedbackUpdate400 | ErrorResponse>

    export const useApiQualityAiFeedbackV1FeedbackUpdate = <TError = ErrorType<ApiQualityAiFeedbackV1FeedbackUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackUpdate>>, TError,{feedbackId: number;data?: BodyType<AnnotationFeedbackUpdateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackUpdate>>,
        TError,
        {feedbackId: number;data?: BodyType<AnnotationFeedbackUpdateRequest>},
        TContext
      > => {
      return useMutation(getApiQualityAiFeedbackV1FeedbackUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityAiFeedbackV1FeedbackDestroy = (
    feedbackId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/ai-feedback/v1/feedback/${feedbackId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityAiFeedbackV1FeedbackDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackDestroy>>, TError,{feedbackId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackDestroy>>, TError,{feedbackId: number}, TContext> => {

const mutationKey = ['apiQualityAiFeedbackV1FeedbackDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackDestroy>>, {feedbackId: number}> = (props) => {
          const {feedbackId} = props ?? {};

          return  apiQualityAiFeedbackV1FeedbackDestroy(feedbackId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityAiFeedbackV1FeedbackDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackDestroy>>>

    export type ApiQualityAiFeedbackV1FeedbackDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityAiFeedbackV1FeedbackDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackDestroy>>, TError,{feedbackId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityAiFeedbackV1FeedbackDestroy>>,
        TError,
        {feedbackId: number},
        TContext
      > => {
      return useMutation(getApiQualityAiFeedbackV1FeedbackDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityAnalyticsV1QualityKpisRetrieve = (
    params: ApiQualityAnalyticsV1QualityKpisRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<QualityKPIsResponse>(
      {url: `/api/quality/analytics/v1/quality-kpis/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityAnalyticsV1QualityKpisRetrieveQueryKey = (params?: ApiQualityAnalyticsV1QualityKpisRetrieveParams,) => {
    return [
    `/api/quality/analytics/v1/quality-kpis/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityAnalyticsV1QualityKpisRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAnalyticsV1QualityKpisRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>> = ({ signal }) => apiQualityAnalyticsV1QualityKpisRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAnalyticsV1QualityKpisRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>>
export type ApiQualityAnalyticsV1QualityKpisRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityAnalyticsV1QualityKpisRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityKpisRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityKpisRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAnalyticsV1QualityKpisRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAnalyticsV1QualityKpisRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityAnalyticsV1QualityKpisRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAnalyticsV1QualityKpisRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>> = ({ signal }) => apiQualityAnalyticsV1QualityKpisRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAnalyticsV1QualityKpisRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>>
export type ApiQualityAnalyticsV1QualityKpisRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityAnalyticsV1QualityKpisRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityKpisRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityKpisRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAnalyticsV1QualityKpisRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityKpisRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityKpisRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAnalyticsV1QualityKpisRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityAnalyticsV1QualityStatsRetrieve = (
    params: ApiQualityAnalyticsV1QualityStatsRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<QualityStatsResponse>(
      {url: `/api/quality/analytics/v1/quality-stats/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityAnalyticsV1QualityStatsRetrieveQueryKey = (params?: ApiQualityAnalyticsV1QualityStatsRetrieveParams,) => {
    return [
    `/api/quality/analytics/v1/quality-stats/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityAnalyticsV1QualityStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAnalyticsV1QualityStatsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>> = ({ signal }) => apiQualityAnalyticsV1QualityStatsRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAnalyticsV1QualityStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>>
export type ApiQualityAnalyticsV1QualityStatsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityAnalyticsV1QualityStatsRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityStatsRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityStatsRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAnalyticsV1QualityStatsRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAnalyticsV1QualityStatsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityAnalyticsV1QualityStatsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAnalyticsV1QualityStatsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>> = ({ signal }) => apiQualityAnalyticsV1QualityStatsRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAnalyticsV1QualityStatsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>>
export type ApiQualityAnalyticsV1QualityStatsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityAnalyticsV1QualityStatsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityStatsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityStatsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAnalyticsV1QualityStatsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAnalyticsV1QualityStatsRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityAnalyticsV1QualityStatsBulkRetrieve = (
    params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BulkQualityStatsResponse>(
      {url: `/api/quality/analytics/v1/quality-stats-bulk/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityAnalyticsV1QualityStatsBulkRetrieveQueryKey = (params?: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams,) => {
    return [
    `/api/quality/analytics/v1/quality-stats-bulk/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityAnalyticsV1QualityStatsBulkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAnalyticsV1QualityStatsBulkRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>> = ({ signal }) => apiQualityAnalyticsV1QualityStatsBulkRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAnalyticsV1QualityStatsBulkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>>
export type ApiQualityAnalyticsV1QualityStatsBulkRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityAnalyticsV1QualityStatsBulkRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityStatsBulkRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityStatsBulkRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAnalyticsV1QualityStatsBulkRetrieve<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAnalyticsV1QualityStatsBulkRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityAnalyticsV1QualityStatsBulkRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityAnalyticsV1QualityStatsBulkRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>> = ({ signal }) => apiQualityAnalyticsV1QualityStatsBulkRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityAnalyticsV1QualityStatsBulkRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>>
export type ApiQualityAnalyticsV1QualityStatsBulkRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityAnalyticsV1QualityStatsBulkRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityStatsBulkRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityAnalyticsV1QualityStatsBulkRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityAnalyticsV1QualityStatsBulkRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityAnalyticsV1QualityStatsBulkRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityAnalyticsV1QualityStatsBulkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityAnalyticsV1QualityStatsBulkRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList = (
    params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerEvidenceRequestDetailResponse[]>(
      {url: `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListQueryKey = (params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams,) => {
    return [
    `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>>
export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>>
export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate = (
    buyerEvidenceRequestCreateDTO: BodyType<BuyerEvidenceRequestCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerEvidenceRequestDetailResponse>(
      {url: `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: buyerEvidenceRequestCreateDTO, signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreateMutationOptions = <TError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate>>, TError,{data: BodyType<BuyerEvidenceRequestCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate>>, TError,{data: BodyType<BuyerEvidenceRequestCreateDTO>}, TContext> => {

const mutationKey = ['apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate>>, {data: BodyType<BuyerEvidenceRequestCreateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate>>>
    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreateMutationBody = BodyType<BuyerEvidenceRequestCreateDTO>
    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreateMutationError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate400 | ErrorResponse>

    export const useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate = <TError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate>>, TError,{data: BodyType<BuyerEvidenceRequestCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreate>>,
        TError,
        {data: BodyType<BuyerEvidenceRequestCreateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsCreateMutationOptions(options), queryClient);
    }
    export const apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve = (
    buyerEvidenceRequestId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerEvidenceRequestDetailResponse>(
      {url: `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/${buyerEvidenceRequestId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveQueryKey = (buyerEvidenceRequestId: number,) => {
    return [
    `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/${buyerEvidenceRequestId}/`
    ] as const;
    }


export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(buyerEvidenceRequestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveQueryKey(buyerEvidenceRequestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve(buyerEvidenceRequestId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: buyerEvidenceRequestId !== null && buyerEvidenceRequestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>>
export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveQueryOptions(buyerEvidenceRequestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(buyerEvidenceRequestId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveQueryKey(buyerEvidenceRequestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve(buyerEvidenceRequestId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>>
export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsRetrieveSuspenseQueryOptions(buyerEvidenceRequestId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate = (
    buyerEvidenceRequestId: number,
    buyerEvidenceRequestUpdateDTO?: BodyType<BuyerEvidenceRequestUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerEvidenceRequestDetailResponse>(
      {url: `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/${buyerEvidenceRequestId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: buyerEvidenceRequestUpdateDTO, signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdateMutationOptions = <TError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate>>, TError,{buyerEvidenceRequestId: number;data?: BodyType<BuyerEvidenceRequestUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate>>, TError,{buyerEvidenceRequestId: number;data?: BodyType<BuyerEvidenceRequestUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate>>, {buyerEvidenceRequestId: number;data?: BodyType<BuyerEvidenceRequestUpdateDTO>}> = (props) => {
          const {buyerEvidenceRequestId,data} = props ?? {};

          return  apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate(buyerEvidenceRequestId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate>>>
    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdateMutationBody = BodyType<BuyerEvidenceRequestUpdateDTO> | undefined
    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdateMutationError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate400 | ErrorResponse>

    export const useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate = <TError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate>>, TError,{buyerEvidenceRequestId: number;data?: BodyType<BuyerEvidenceRequestUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdate>>,
        TError,
        {buyerEvidenceRequestId: number;data?: BodyType<BuyerEvidenceRequestUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy = (
    buyerEvidenceRequestId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/${buyerEvidenceRequestId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy>>, TError,{buyerEvidenceRequestId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy>>, TError,{buyerEvidenceRequestId: number}, TContext> => {

const mutationKey = ['apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy>>, {buyerEvidenceRequestId: number}> = (props) => {
          const {buyerEvidenceRequestId} = props ?? {};

          return  apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy(buyerEvidenceRequestId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy>>>

    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy>>, TError,{buyerEvidenceRequestId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroy>>,
        TError,
        {buyerEvidenceRequestId: number},
        TContext
      > => {
      return useMutation(getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate = (
    buyerEvidenceRequestToken: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerEvidenceRequestDetailForSupplier>(
      {url: `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/${buyerEvidenceRequestToken}/accept/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreateMutationOptions = <TError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate>>, TError,{buyerEvidenceRequestToken: string}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate>>, TError,{buyerEvidenceRequestToken: string}, TContext> => {

const mutationKey = ['apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate>>, {buyerEvidenceRequestToken: string}> = (props) => {
          const {buyerEvidenceRequestToken} = props ?? {};

          return  apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate(buyerEvidenceRequestToken,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate>>>

    export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreateMutationError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate400 | ErrorResponse>

    export const useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate = <TError = ErrorType<ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate>>, TError,{buyerEvidenceRequestToken: string}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreate>>,
        TError,
        {buyerEvidenceRequestToken: string},
        TContext
      > => {
      return useMutation(getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsAcceptCreateMutationOptions(options), queryClient);
    }
    export const apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve = (
    params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerEvidenceRequestOrderReferenceOptionsResponse>(
      {url: `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/order-reference-options/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveQueryKey = (params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams,) => {
    return [
    `/api/quality/buyer-evidence-requests/v1/buyer-evidence-requests/order-reference-options/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>>
export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>>
export type ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1BuyerEvidenceRequestsOrderReferenceOptionsRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerEvidenceRequestDetailForSupplier[]>(
      {url: `/api/quality/buyer-evidence-requests/v1/seller/buyer-evidence-requests/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListQueryKey = () => {
    return [
    `/api/quality/buyer-evidence-requests/v1/seller/buyer-evidence-requests/`
    ] as const;
    }


export const getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>>
export type ApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>>
export type ApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve = (
    buyerEvidenceRequestToken: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerEvidenceRequestDetailForSupplier>(
      {url: `/api/quality/buyer-evidence-requests/v1/seller/buyer-evidence-requests/${buyerEvidenceRequestToken}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveQueryKey = (buyerEvidenceRequestToken: string,) => {
    return [
    `/api/quality/buyer-evidence-requests/v1/seller/buyer-evidence-requests/${buyerEvidenceRequestToken}/`
    ] as const;
    }


export const getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(buyerEvidenceRequestToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveQueryKey(buyerEvidenceRequestToken);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve(buyerEvidenceRequestToken, requestOptions, signal);





   return  { queryKey, queryFn, enabled: buyerEvidenceRequestToken !== null && buyerEvidenceRequestToken !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>>
export type ApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestToken: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveQueryOptions(buyerEvidenceRequestToken,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(buyerEvidenceRequestToken: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveQueryKey(buyerEvidenceRequestToken);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>> = ({ signal }) => apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve(buyerEvidenceRequestToken, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>>
export type ApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestToken: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestToken: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestToken: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerEvidenceRequestToken: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityBuyerEvidenceRequestsV1SellerBuyerEvidenceRequestsRetrieveSuspenseQueryOptions(buyerEvidenceRequestToken,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityCameraSettingsV1Retrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CameraAdvancedSettingsDTO>(
      {url: `/api/quality/camera-settings/v1/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityCameraSettingsV1RetrieveQueryKey = () => {
    return [
    `/api/quality/camera-settings/v1/`
    ] as const;
    }


export const getApiQualityCameraSettingsV1RetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityCameraSettingsV1RetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>> = ({ signal }) => apiQualityCameraSettingsV1Retrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityCameraSettingsV1RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>>
export type ApiQualityCameraSettingsV1RetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityCameraSettingsV1Retrieve<TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityCameraSettingsV1Retrieve<TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityCameraSettingsV1Retrieve<TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityCameraSettingsV1Retrieve<TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityCameraSettingsV1RetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityCameraSettingsV1RetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityCameraSettingsV1RetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>> = ({ signal }) => apiQualityCameraSettingsV1Retrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityCameraSettingsV1RetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>>
export type ApiQualityCameraSettingsV1RetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityCameraSettingsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityCameraSettingsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityCameraSettingsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityCameraSettingsV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityCameraSettingsV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityCameraSettingsV1RetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualityClaimsV1ClaimsList = (
    params?: ApiQualityClaimsV1ClaimsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedClaimListList>(
      {url: `/api/quality/claims/v1/claims/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityClaimsV1ClaimsListQueryKey = (params?: ApiQualityClaimsV1ClaimsListParams,) => {
    return [
    `/api/quality/claims/v1/claims/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityClaimsV1ClaimsListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityClaimsV1ClaimsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityClaimsV1ClaimsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>> = ({ signal }) => apiQualityClaimsV1ClaimsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityClaimsV1ClaimsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>>
export type ApiQualityClaimsV1ClaimsListQueryError = ErrorType<ErrorResponse>


export function useApiQualityClaimsV1ClaimsList<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityClaimsV1ClaimsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsList<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityClaimsV1ClaimsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsList<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityClaimsV1ClaimsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityClaimsV1ClaimsList<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityClaimsV1ClaimsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityClaimsV1ClaimsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityClaimsV1ClaimsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityClaimsV1ClaimsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityClaimsV1ClaimsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>> = ({ signal }) => apiQualityClaimsV1ClaimsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityClaimsV1ClaimsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>>
export type ApiQualityClaimsV1ClaimsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityClaimsV1ClaimsListSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityClaimsV1ClaimsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsListSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityClaimsV1ClaimsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsListSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityClaimsV1ClaimsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityClaimsV1ClaimsListSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityClaimsV1ClaimsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityClaimsV1ClaimsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualityClaimsV1ClaimsCreate = (
    createClaimDTO: BodyType<CreateClaimDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClaimCreateResponse>(
      {url: `/api/quality/claims/v1/claims/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClaimDTO, signal
    },
      options);
    }




export const getApiQualityClaimsV1ClaimsCreateMutationOptions = <TError = ErrorType<ApiQualityClaimsV1ClaimsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsCreate>>, TError,{data: BodyType<CreateClaimDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsCreate>>, TError,{data: BodyType<CreateClaimDTO>}, TContext> => {

const mutationKey = ['apiQualityClaimsV1ClaimsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsCreate>>, {data: BodyType<CreateClaimDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityClaimsV1ClaimsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityClaimsV1ClaimsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsCreate>>>
    export type ApiQualityClaimsV1ClaimsCreateMutationBody = BodyType<CreateClaimDTO>
    export type ApiQualityClaimsV1ClaimsCreateMutationError = ErrorType<ApiQualityClaimsV1ClaimsCreate400 | ErrorResponse>

    export const useApiQualityClaimsV1ClaimsCreate = <TError = ErrorType<ApiQualityClaimsV1ClaimsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsCreate>>, TError,{data: BodyType<CreateClaimDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsCreate>>,
        TError,
        {data: BodyType<CreateClaimDTO>},
        TContext
      > => {
      return useMutation(getApiQualityClaimsV1ClaimsCreateMutationOptions(options), queryClient);
    }
    export const apiQualityClaimsV1ClaimsRetrieve = (
    claimId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClaimDetailResponse>(
      {url: `/api/quality/claims/v1/claims/${claimId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityClaimsV1ClaimsRetrieveQueryKey = (claimId: number,) => {
    return [
    `/api/quality/claims/v1/claims/${claimId}/`
    ] as const;
    }


export const getApiQualityClaimsV1ClaimsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(claimId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityClaimsV1ClaimsRetrieveQueryKey(claimId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>> = ({ signal }) => apiQualityClaimsV1ClaimsRetrieve(claimId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: claimId !== null && claimId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityClaimsV1ClaimsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>>
export type ApiQualityClaimsV1ClaimsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityClaimsV1ClaimsRetrieve<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsRetrieve<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsRetrieve<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityClaimsV1ClaimsRetrieve<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityClaimsV1ClaimsRetrieveQueryOptions(claimId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityClaimsV1ClaimsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(claimId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityClaimsV1ClaimsRetrieveQueryKey(claimId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>> = ({ signal }) => apiQualityClaimsV1ClaimsRetrieve(claimId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityClaimsV1ClaimsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>>
export type ApiQualityClaimsV1ClaimsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityClaimsV1ClaimsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityClaimsV1ClaimsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityClaimsV1ClaimsRetrieveSuspenseQueryOptions(claimId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityClaimsV1ClaimsUpdate = (
    claimId: number,
    claimUpdateDTO?: BodyType<ClaimUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClaimDetailResponse>(
      {url: `/api/quality/claims/v1/claims/${claimId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: claimUpdateDTO, signal
    },
      options);
    }




export const getApiQualityClaimsV1ClaimsUpdateMutationOptions = <TError = ErrorType<ApiQualityClaimsV1ClaimsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsUpdate>>, TError,{claimId: number;data?: BodyType<ClaimUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsUpdate>>, TError,{claimId: number;data?: BodyType<ClaimUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityClaimsV1ClaimsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsUpdate>>, {claimId: number;data?: BodyType<ClaimUpdateDTO>}> = (props) => {
          const {claimId,data} = props ?? {};

          return  apiQualityClaimsV1ClaimsUpdate(claimId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityClaimsV1ClaimsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsUpdate>>>
    export type ApiQualityClaimsV1ClaimsUpdateMutationBody = BodyType<ClaimUpdateDTO> | undefined
    export type ApiQualityClaimsV1ClaimsUpdateMutationError = ErrorType<ApiQualityClaimsV1ClaimsUpdate400 | ErrorResponse>

    export const useApiQualityClaimsV1ClaimsUpdate = <TError = ErrorType<ApiQualityClaimsV1ClaimsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsUpdate>>, TError,{claimId: number;data?: BodyType<ClaimUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsUpdate>>,
        TError,
        {claimId: number;data?: BodyType<ClaimUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityClaimsV1ClaimsUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityClaimsV1ClaimsDestroy = (
    claimId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/claims/v1/claims/${claimId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityClaimsV1ClaimsDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsDestroy>>, TError,{claimId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsDestroy>>, TError,{claimId: number}, TContext> => {

const mutationKey = ['apiQualityClaimsV1ClaimsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsDestroy>>, {claimId: number}> = (props) => {
          const {claimId} = props ?? {};

          return  apiQualityClaimsV1ClaimsDestroy(claimId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityClaimsV1ClaimsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsDestroy>>>

    export type ApiQualityClaimsV1ClaimsDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityClaimsV1ClaimsDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsDestroy>>, TError,{claimId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsDestroy>>,
        TError,
        {claimId: number},
        TContext
      > => {
      return useMutation(getApiQualityClaimsV1ClaimsDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve = (
    claimId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClaimPDFStatusResponse>(
      {url: `/api/quality/claims/v1/claims/${claimId}/pdf-generation-status/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveQueryKey = (claimId: number,) => {
    return [
    `/api/quality/claims/v1/claims/${claimId}/pdf-generation-status/`
    ] as const;
    }


export const getApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(claimId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveQueryKey(claimId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>> = ({ signal }) => apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve(claimId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: claimId !== null && claimId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>>
export type ApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveQueryOptions(claimId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(claimId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveQueryKey(claimId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>> = ({ signal }) => apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve(claimId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>>
export type ApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 claimId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityClaimsV1ClaimsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityClaimsV1ClaimsPdfGenerationStatusRetrieveSuspenseQueryOptions(claimId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityClaimsV2ClaimsGeneratePdfCreate = (
    claimId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/claims/v2/claims/${claimId}/generate-pdf/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualityClaimsV2ClaimsGeneratePdfCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV2ClaimsGeneratePdfCreate>>, TError,{claimId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV2ClaimsGeneratePdfCreate>>, TError,{claimId: number}, TContext> => {

const mutationKey = ['apiQualityClaimsV2ClaimsGeneratePdfCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityClaimsV2ClaimsGeneratePdfCreate>>, {claimId: number}> = (props) => {
          const {claimId} = props ?? {};

          return  apiQualityClaimsV2ClaimsGeneratePdfCreate(claimId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityClaimsV2ClaimsGeneratePdfCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityClaimsV2ClaimsGeneratePdfCreate>>>

    export type ApiQualityClaimsV2ClaimsGeneratePdfCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityClaimsV2ClaimsGeneratePdfCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityClaimsV2ClaimsGeneratePdfCreate>>, TError,{claimId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityClaimsV2ClaimsGeneratePdfCreate>>,
        TError,
        {claimId: number},
        TContext
      > => {
      return useMutation(getApiQualityClaimsV2ClaimsGeneratePdfCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalLoadPreferencesDTO>(
      {url: `/api/quality/external-loads/v1/external-load-preferences/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveQueryKey = () => {
    return [
    `/api/quality/external-loads/v1/external-load-preferences/`
    ] as const;
    }


export const getApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveQueryError = ErrorType<unknown>


export function useApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveSuspenseQueryError = ErrorType<unknown>


export function useApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadPreferencesRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate = (
    externalLoadPreferencesDTO: BodyType<ExternalLoadPreferencesDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalLoadPreferencesDTO>(
      {url: `/api/quality/external-loads/v1/external-load-preferences/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: externalLoadPreferencesDTO, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadPreferencesUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate>>, TError,{data: BodyType<ExternalLoadPreferencesDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate>>, TError,{data: BodyType<ExternalLoadPreferencesDTO>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate>>, {data: BodyType<ExternalLoadPreferencesDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadPreferencesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadPreferencesUpdateMutationBody = BodyType<ExternalLoadPreferencesDTO>
    export type ApiQualityExternalLoadsV1ExternalLoadPreferencesUpdateMutationError = ErrorType<unknown>

    export const useApiQualityExternalLoadsV1ExternalLoadPreferencesUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate>>, TError,{data: BodyType<ExternalLoadPreferencesDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadPreferencesUpdate>>,
        TError,
        {data: BodyType<ExternalLoadPreferencesDTO>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadPreferencesUpdateMutationOptions(options), queryClient);
    }
    /**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualityExternalLoadsV1ExternalLoadsRetrieveList = (
    params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedExternalLoadListItemList>(
      {url: `/api/quality/external-loads/v1/external-loads/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsRetrieveListQueryKey = (params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams,) => {
    return [
    `/api/quality/external-loads/v1/external-loads/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityExternalLoadsV1ExternalLoadsRetrieveListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsRetrieveListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsRetrieveList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsRetrieveListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>>
export type ApiQualityExternalLoadsV1ExternalLoadsRetrieveListQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveList<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveList<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveList<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveList<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsRetrieveListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1ExternalLoadsRetrieveListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsRetrieveListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsRetrieveList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsRetrieveListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>>
export type ApiQualityExternalLoadsV1ExternalLoadsRetrieveListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1ExternalLoadsRetrieveListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieveList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsRetrieveListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualityExternalLoadsV1ExternalLoadsCreate = (
    externalLoadCreateDTO: BodyType<ExternalLoadCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalLoadCreateResponse>(
      {url: `/api/quality/external-loads/v1/external-loads/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: externalLoadCreateDTO, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsCreateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCreate>>, TError,{data: BodyType<ExternalLoadCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCreate>>, TError,{data: BodyType<ExternalLoadCreateDTO>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCreate>>, {data: BodyType<ExternalLoadCreateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCreate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsCreateMutationBody = BodyType<ExternalLoadCreateDTO>
    export type ApiQualityExternalLoadsV1ExternalLoadsCreateMutationError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsCreate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsCreate = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCreate>>, TError,{data: BodyType<ExternalLoadCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCreate>>,
        TError,
        {data: BodyType<ExternalLoadCreateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsRetrieve = (
    externalLoadId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalLoadDetails>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsRetrieveQueryKey = (externalLoadId: number,) => {
    return [
    `/api/quality/external-loads/v1/external-loads/${externalLoadId}/`
    ] as const;
    }


export const getApiQualityExternalLoadsV1ExternalLoadsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsRetrieveQueryKey(externalLoadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsRetrieve(externalLoadId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: externalLoadId !== null && externalLoadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsRetrieveQueryOptions(externalLoadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1ExternalLoadsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsRetrieveQueryKey(externalLoadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsRetrieve(externalLoadId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsRetrieveSuspenseQueryOptions(externalLoadId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1ExternalLoadsUpdate = (
    externalLoadId: number,
    externalLoadUpdateDTO?: BodyType<ExternalLoadUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalLoadDetails>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: externalLoadUpdateDTO, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsUpdateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsUpdate>>, TError,{externalLoadId: number;data?: BodyType<ExternalLoadUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsUpdate>>, TError,{externalLoadId: number;data?: BodyType<ExternalLoadUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsUpdate>>, {externalLoadId: number;data?: BodyType<ExternalLoadUpdateDTO>}> = (props) => {
          const {externalLoadId,data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsUpdate(externalLoadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsUpdate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsUpdateMutationBody = BodyType<ExternalLoadUpdateDTO> | undefined
    export type ApiQualityExternalLoadsV1ExternalLoadsUpdateMutationError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsUpdate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsUpdate = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsUpdate>>, TError,{externalLoadId: number;data?: BodyType<ExternalLoadUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsUpdate>>,
        TError,
        {externalLoadId: number;data?: BodyType<ExternalLoadUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsDestroy = (
    externalLoadId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsDestroy>>, TError,{externalLoadId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsDestroy>>, TError,{externalLoadId: number}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsDestroy>>, {externalLoadId: number}> = (props) => {
          const {externalLoadId} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsDestroy(externalLoadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsDestroy>>>

    export type ApiQualityExternalLoadsV1ExternalLoadsDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsDestroy>>, TError,{externalLoadId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsDestroy>>,
        TError,
        {externalLoadId: number},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsEvidenceList = (
    externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedEvidenceList>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/evidence/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceListQueryKey = (externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams,) => {
    return [
    `/api/quality/external-loads/v1/external-loads/${externalLoadId}/evidence/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsEvidenceListQueryKey(externalLoadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsEvidenceList(externalLoadId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: externalLoadId !== null && externalLoadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>>
export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceListQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceList<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    params: undefined |  ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceList<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceList<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceList<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsEvidenceListQueryOptions(externalLoadId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsEvidenceListQueryKey(externalLoadId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsEvidenceList(externalLoadId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>>
export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    params: undefined |  ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    params?: ApiQualityExternalLoadsV1ExternalLoadsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsEvidenceListSuspenseQueryOptions(externalLoadId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve = (
    externalLoadId: number,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Evidence>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/evidence/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveQueryKey = (externalLoadId: number,
    id: number,) => {
    return [
    `/api/quality/external-loads/v1/external-loads/${externalLoadId}/evidence/${id}/`
    ] as const;
    }


export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveQueryKey(externalLoadId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve(externalLoadId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: externalLoadId !== null && externalLoadId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveQueryOptions(externalLoadId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveQueryKey(externalLoadId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve(externalLoadId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsEvidenceRetrieveSuspenseQueryOptions(externalLoadId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate = (
    externalLoadId: number,
    bulkDeleteRequest: BodyType<BulkDeleteRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/evidence/bulk-delete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteRequest, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate>>, TError,{externalLoadId: number;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate>>, TError,{externalLoadId: number;data: BodyType<BulkDeleteRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate>>, {externalLoadId: number;data: BodyType<BulkDeleteRequest>}> = (props) => {
          const {externalLoadId,data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate(externalLoadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreateMutationBody = BodyType<BulkDeleteRequest>
    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreateMutationError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate>>, TError,{externalLoadId: number;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreate>>,
        TError,
        {externalLoadId: number;data: BodyType<BulkDeleteRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsEvidenceBulkDeleteCreateMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for large files.
 */
export const apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate = (
    externalLoadId: number,
    generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GenerateUploadUrlResponse>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/evidence/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateUploadUrlRequest, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate>>, TError,{externalLoadId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate>>, TError,{externalLoadId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate>>, {externalLoadId: number;data: BodyType<GenerateUploadUrlRequest>}> = (props) => {
          const {externalLoadId,data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate(externalLoadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>
    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate>>, TError,{externalLoadId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreate>>,
        TError,
        {externalLoadId: number;data: BodyType<GenerateUploadUrlRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadCreateMutationOptions(options), queryClient);
    }
    /**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate = (
    externalLoadId: number,
    processUploadRequest: BodyType<ProcessUploadRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessUploadResponse>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/evidence/upload/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: processUploadRequest, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate>>, TError,{externalLoadId: number;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate>>, TError,{externalLoadId: number;data: BodyType<ProcessUploadRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate>>, {externalLoadId: number;data: BodyType<ProcessUploadRequest>}> = (props) => {
          const {externalLoadId,data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate(externalLoadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>
    export type ApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdateMutationError = ErrorType<unknown>

    export const useApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate>>, TError,{externalLoadId: number;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdate>>,
        TError,
        {externalLoadId: number;data: BodyType<ProcessUploadRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsEvidenceUploadUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate = (
    externalLoadId: number,
    externalLoadGeneratePDFRequest?: BodyType<ExternalLoadGeneratePDFRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/generate-pdf/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: externalLoadGeneratePDFRequest, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate>>, TError,{externalLoadId: number;data?: BodyType<ExternalLoadGeneratePDFRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate>>, TError,{externalLoadId: number;data?: BodyType<ExternalLoadGeneratePDFRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate>>, {externalLoadId: number;data?: BodyType<ExternalLoadGeneratePDFRequest>}> = (props) => {
          const {externalLoadId,data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate(externalLoadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreateMutationBody = BodyType<ExternalLoadGeneratePDFRequest> | undefined
    export type ApiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate>>, TError,{externalLoadId: number;data?: BodyType<ExternalLoadGeneratePDFRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreate>>,
        TError,
        {externalLoadId: number;data?: BodyType<ExternalLoadGeneratePDFRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsGeneratePdfCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve = (
    externalLoadId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalLoadPDFStatusResponse>(
      {url: `/api/quality/external-loads/v1/external-loads/${externalLoadId}/pdf-generation-status/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveQueryKey = (externalLoadId: number,) => {
    return [
    `/api/quality/external-loads/v1/external-loads/${externalLoadId}/pdf-generation-status/`
    ] as const;
    }


export const getApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveQueryKey(externalLoadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve(externalLoadId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: externalLoadId !== null && externalLoadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveQueryOptions(externalLoadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveQueryKey(externalLoadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve(externalLoadId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsPdfGenerationStatusRetrieveSuspenseQueryOptions(externalLoadId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate = (
    externalLoadBulkCombinedCompositionsRequest: BodyType<ExternalLoadBulkCombinedCompositionsRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalLoadBulkCombinedCompositionsResponse>(
      {url: `/api/quality/external-loads/v1/external-loads/bulk-combined-compositions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: externalLoadBulkCombinedCompositionsRequest, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate>>, TError,{data: BodyType<ExternalLoadBulkCombinedCompositionsRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate>>, TError,{data: BodyType<ExternalLoadBulkCombinedCompositionsRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate>>, {data: BodyType<ExternalLoadBulkCombinedCompositionsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreateMutationBody = BodyType<ExternalLoadBulkCombinedCompositionsRequest>
    export type ApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreateMutationError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate>>, TError,{data: BodyType<ExternalLoadBulkCombinedCompositionsRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreate>>,
        TError,
        {data: BodyType<ExternalLoadBulkCombinedCompositionsRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsBulkCombinedCompositionsCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate = (
    externalLoadBulkDeleteRequest: BodyType<ExternalLoadBulkDeleteRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/external-loads/v1/external-loads/bulk-delete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: externalLoadBulkDeleteRequest, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate>>, TError,{data: BodyType<ExternalLoadBulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate>>, TError,{data: BodyType<ExternalLoadBulkDeleteRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate>>, {data: BodyType<ExternalLoadBulkDeleteRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreateMutationBody = BodyType<ExternalLoadBulkDeleteRequest>
    export type ApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreateMutationError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate>>, TError,{data: BodyType<ExternalLoadBulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreate>>,
        TError,
        {data: BodyType<ExternalLoadBulkDeleteRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsBulkDeleteCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate = (
    externalLoadBulkAssignCategoryRequest: BodyType<ExternalLoadBulkAssignCategoryRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/external-loads/v1/external-loads/category/bulk-assign/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: externalLoadBulkAssignCategoryRequest, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate>>, TError,{data: BodyType<ExternalLoadBulkAssignCategoryRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate>>, TError,{data: BodyType<ExternalLoadBulkAssignCategoryRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate>>, {data: BodyType<ExternalLoadBulkAssignCategoryRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreateMutationBody = BodyType<ExternalLoadBulkAssignCategoryRequest>
    export type ApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreateMutationError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate>>, TError,{data: BodyType<ExternalLoadBulkAssignCategoryRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreate>>,
        TError,
        {data: BodyType<ExternalLoadBulkAssignCategoryRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsCategoryBulkAssignCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsImportCreate = (
    externalLoadImportRequest: BodyType<ExternalLoadImportRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, externalLoadImportRequest.file);
if(externalLoadImportRequest.import_mapping_override !== undefined) {
 formData.append(`import_mapping_override`, externalLoadImportRequest.import_mapping_override);
 }
if(externalLoadImportRequest.timezone_name !== undefined && externalLoadImportRequest.timezone_name !== null) {
 formData.append(`timezone_name`, externalLoadImportRequest.timezone_name);
 }

      return customAxios<ExternalLoadImportResponse>(
      {url: `/api/quality/external-loads/v1/external-loads/import/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsImportCreateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportCreate>>, TError,{data: BodyType<ExternalLoadImportRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportCreate>>, TError,{data: BodyType<ExternalLoadImportRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ExternalLoadsImportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportCreate>>, {data: BodyType<ExternalLoadImportRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalLoadsV1ExternalLoadsImportCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ExternalLoadsImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportCreate>>>
    export type ApiQualityExternalLoadsV1ExternalLoadsImportCreateMutationBody = BodyType<ExternalLoadImportRequest>
    export type ApiQualityExternalLoadsV1ExternalLoadsImportCreateMutationError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportCreate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ExternalLoadsImportCreate = <TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportCreate>>, TError,{data: BodyType<ExternalLoadImportRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportCreate>>,
        TError,
        {data: BodyType<ExternalLoadImportRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ExternalLoadsImportCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve = (
    params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Blob>(
      {url: `/api/quality/external-loads/v1/external-loads/import/template/`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveQueryKey = (params?: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams,) => {
    return [
    `/api/quality/external-loads/v1/external-loads/import/template/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveQueryError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(
 params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(
 params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(
 params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(
 params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>>
export type ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveSuspenseQueryError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>


export function useApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(
 params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(
 params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(
 params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError = ErrorType<ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve400 | ErrorResponse>>(
 params: ApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ExternalLoadsImportTemplateRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1LoadSuppliersRetrieve = (
    params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<LoadSuppliersResponse>(
      {url: `/api/quality/external-loads/v1/load-suppliers/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1LoadSuppliersRetrieveQueryKey = (params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams,) => {
    return [
    `/api/quality/external-loads/v1/load-suppliers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityExternalLoadsV1LoadSuppliersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1LoadSuppliersRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1LoadSuppliersRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1LoadSuppliersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>>
export type ApiQualityExternalLoadsV1LoadSuppliersRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1LoadSuppliersRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1LoadSuppliersRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1LoadSuppliersRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1LoadSuppliersRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1LoadSuppliersRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1LoadSuppliersRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1LoadSuppliersRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1LoadSuppliersRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1LoadSuppliersRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>>
export type ApiQualityExternalLoadsV1LoadSuppliersRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1LoadSuppliersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1LoadSuppliersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1LoadSuppliersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1LoadSuppliersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityExternalLoadsV1LoadSuppliersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1LoadSuppliersRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve = (
    supplierId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<LoadSupplierProductCodeResponse>(
      {url: `/api/quality/external-loads/v1/load-suppliers/${supplierId}/product-code/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveQueryKey = (supplierId: number,) => {
    return [
    `/api/quality/external-loads/v1/load-suppliers/${supplierId}/product-code/`
    ] as const;
    }


export const getApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(supplierId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveQueryKey(supplierId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve(supplierId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: supplierId !== null && supplierId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>>
export type ApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveQueryOptions(supplierId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(supplierId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveQueryKey(supplierId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve(supplierId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>>
export type ApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1LoadSuppliersProductCodeRetrieveSuspenseQueryOptions(supplierId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityMaterialQualityCategoriesV1List = (
    params?: ApiQualityMaterialQualityCategoriesV1ListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialQualityCategoryListResponse>(
      {url: `/api/quality/external-loads/v1/material-quality-categories/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityMaterialQualityCategoriesV1ListQueryKey = (params?: ApiQualityMaterialQualityCategoriesV1ListParams,) => {
    return [
    `/api/quality/external-loads/v1/material-quality-categories/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityMaterialQualityCategoriesV1ListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityMaterialQualityCategoriesV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityMaterialQualityCategoriesV1ListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>> = ({ signal }) => apiQualityMaterialQualityCategoriesV1List(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityMaterialQualityCategoriesV1ListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>>
export type ApiQualityMaterialQualityCategoriesV1ListQueryError = ErrorType<ErrorResponse>


export function useApiQualityMaterialQualityCategoriesV1List<TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityMaterialQualityCategoriesV1ListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>,
          TError,
          Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityMaterialQualityCategoriesV1List<TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityMaterialQualityCategoriesV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>,
          TError,
          Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityMaterialQualityCategoriesV1List<TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityMaterialQualityCategoriesV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityMaterialQualityCategoriesV1List<TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityMaterialQualityCategoriesV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityMaterialQualityCategoriesV1ListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityMaterialQualityCategoriesV1ListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityMaterialQualityCategoriesV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityMaterialQualityCategoriesV1ListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>> = ({ signal }) => apiQualityMaterialQualityCategoriesV1List(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityMaterialQualityCategoriesV1ListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>>
export type ApiQualityMaterialQualityCategoriesV1ListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityMaterialQualityCategoriesV1ListSuspense<TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityMaterialQualityCategoriesV1ListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityMaterialQualityCategoriesV1ListSuspense<TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityMaterialQualityCategoriesV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityMaterialQualityCategoriesV1ListSuspense<TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityMaterialQualityCategoriesV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityMaterialQualityCategoriesV1ListSuspense<TData = Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityMaterialQualityCategoriesV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityMaterialQualityCategoriesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityMaterialQualityCategoriesV1ListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1MaterialQualityCategoriesCreate = (
    materialQualityCategoryCreateDTO: BodyType<MaterialQualityCategoryCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialQualityCategoryCreateResponse>(
      {url: `/api/quality/external-loads/v1/material-quality-categories/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: materialQualityCategoryCreateDTO, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1MaterialQualityCategoriesCreateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesCreate>>, TError,{data: BodyType<MaterialQualityCategoryCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesCreate>>, TError,{data: BodyType<MaterialQualityCategoryCreateDTO>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1MaterialQualityCategoriesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesCreate>>, {data: BodyType<MaterialQualityCategoryCreateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalLoadsV1MaterialQualityCategoriesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesCreate>>>
    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesCreateMutationBody = BodyType<MaterialQualityCategoryCreateDTO>
    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesCreateMutationError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesCreate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1MaterialQualityCategoriesCreate = <TError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesCreate>>, TError,{data: BodyType<MaterialQualityCategoryCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesCreate>>,
        TError,
        {data: BodyType<MaterialQualityCategoryCreateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1MaterialQualityCategoriesCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve = (
    materialQualityCategoryId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialQualityCategoryDetail>(
      {url: `/api/quality/external-loads/v1/material-quality-categories/${materialQualityCategoryId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveQueryKey = (materialQualityCategoryId: number,) => {
    return [
    `/api/quality/external-loads/v1/material-quality-categories/${materialQualityCategoryId}/`
    ] as const;
    }


export const getApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(materialQualityCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveQueryKey(materialQualityCategoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve(materialQualityCategoryId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: materialQualityCategoryId !== null && materialQualityCategoryId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>>
export type ApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 materialQualityCategoryId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 materialQualityCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 materialQualityCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 materialQualityCategoryId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveQueryOptions(materialQualityCategoryId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(materialQualityCategoryId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveQueryKey(materialQualityCategoryId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve(materialQualityCategoryId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>>
export type ApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 materialQualityCategoryId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 materialQualityCategoryId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 materialQualityCategoryId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 materialQualityCategoryId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1MaterialQualityCategoriesRetrieveSuspenseQueryOptions(materialQualityCategoryId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate = (
    materialQualityCategoryId: number,
    materialQualityCategoryUpdateDTO?: BodyType<MaterialQualityCategoryUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MaterialQualityCategoryDetail>(
      {url: `/api/quality/external-loads/v1/material-quality-categories/${materialQualityCategoryId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: materialQualityCategoryUpdateDTO, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1MaterialQualityCategoriesUpdateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate>>, TError,{materialQualityCategoryId: number;data?: BodyType<MaterialQualityCategoryUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate>>, TError,{materialQualityCategoryId: number;data?: BodyType<MaterialQualityCategoryUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate>>, {materialQualityCategoryId: number;data?: BodyType<MaterialQualityCategoryUpdateDTO>}> = (props) => {
          const {materialQualityCategoryId,data} = props ?? {};

          return  apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate(materialQualityCategoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate>>>
    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesUpdateMutationBody = BodyType<MaterialQualityCategoryUpdateDTO> | undefined
    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesUpdateMutationError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesUpdate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1MaterialQualityCategoriesUpdate = <TError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate>>, TError,{materialQualityCategoryId: number;data?: BodyType<MaterialQualityCategoryUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesUpdate>>,
        TError,
        {materialQualityCategoryId: number;data?: BodyType<MaterialQualityCategoryUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1MaterialQualityCategoriesUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy = (
    materialQualityCategoryId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/external-loads/v1/material-quality-categories/${materialQualityCategoryId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1MaterialQualityCategoriesDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy>>, TError,{materialQualityCategoryId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy>>, TError,{materialQualityCategoryId: number}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy>>, {materialQualityCategoryId: number}> = (props) => {
          const {materialQualityCategoryId} = props ?? {};

          return  apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy(materialQualityCategoryId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy>>>

    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityExternalLoadsV1MaterialQualityCategoriesDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy>>, TError,{materialQualityCategoryId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesDestroy>>,
        TError,
        {materialQualityCategoryId: number},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1MaterialQualityCategoriesDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate = (
    materialQualityCategoryId: number,
    categoryTargetSpecSetRequest: BodyType<CategoryTargetSpecSetRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CategoryTargetSpecSetResponse>(
      {url: `/api/quality/external-loads/v1/material-quality-categories/${materialQualityCategoryId}/target-spec/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: categoryTargetSpecSetRequest, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate>>, TError,{materialQualityCategoryId: number;data: BodyType<CategoryTargetSpecSetRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate>>, TError,{materialQualityCategoryId: number;data: BodyType<CategoryTargetSpecSetRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate>>, {materialQualityCategoryId: number;data: BodyType<CategoryTargetSpecSetRequest>}> = (props) => {
          const {materialQualityCategoryId,data} = props ?? {};

          return  apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate(materialQualityCategoryId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate>>>
    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdateMutationBody = BodyType<CategoryTargetSpecSetRequest>
    export type ApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdateMutationError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate = <TError = ErrorType<ApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate>>, TError,{materialQualityCategoryId: number;data: BodyType<CategoryTargetSpecSetRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdate>>,
        TError,
        {materialQualityCategoryId: number;data: BodyType<CategoryTargetSpecSetRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1MaterialQualityCategoriesTargetSpecUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityProductCodesV1List = (
    params?: ApiQualityProductCodesV1ListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductCodeListResponse>(
      {url: `/api/quality/external-loads/v1/product-codes/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductCodesV1ListQueryKey = (params?: ApiQualityProductCodesV1ListParams,) => {
    return [
    `/api/quality/external-loads/v1/product-codes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductCodesV1ListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductCodesV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductCodesV1ListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>> = ({ signal }) => apiQualityProductCodesV1List(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductCodesV1ListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>>
export type ApiQualityProductCodesV1ListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductCodesV1List<TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductCodesV1ListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductCodesV1List>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductCodesV1List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductCodesV1List<TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductCodesV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductCodesV1List>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductCodesV1List>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductCodesV1List<TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductCodesV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductCodesV1List<TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductCodesV1ListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductCodesV1ListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductCodesV1ListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductCodesV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductCodesV1ListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>> = ({ signal }) => apiQualityProductCodesV1List(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductCodesV1ListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>>
export type ApiQualityProductCodesV1ListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductCodesV1ListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductCodesV1ListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductCodesV1ListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductCodesV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductCodesV1ListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductCodesV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductCodesV1ListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductCodesV1ListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductCodesV1List>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductCodesV1ListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1ProductCodesCreate = (
    productCodeCreateDTO: BodyType<ProductCodeCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductCodeCreateResponse>(
      {url: `/api/quality/external-loads/v1/product-codes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productCodeCreateDTO, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ProductCodesCreateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ProductCodesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesCreate>>, TError,{data: BodyType<ProductCodeCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesCreate>>, TError,{data: BodyType<ProductCodeCreateDTO>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ProductCodesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesCreate>>, {data: BodyType<ProductCodeCreateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalLoadsV1ProductCodesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ProductCodesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesCreate>>>
    export type ApiQualityExternalLoadsV1ProductCodesCreateMutationBody = BodyType<ProductCodeCreateDTO>
    export type ApiQualityExternalLoadsV1ProductCodesCreateMutationError = ErrorType<ApiQualityExternalLoadsV1ProductCodesCreate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ProductCodesCreate = <TError = ErrorType<ApiQualityExternalLoadsV1ProductCodesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesCreate>>, TError,{data: BodyType<ProductCodeCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesCreate>>,
        TError,
        {data: BodyType<ProductCodeCreateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ProductCodesCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ProductCodesRetrieve = (
    productCodeId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductCodeDetail>(
      {url: `/api/quality/external-loads/v1/product-codes/${productCodeId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ProductCodesRetrieveQueryKey = (productCodeId: number,) => {
    return [
    `/api/quality/external-loads/v1/product-codes/${productCodeId}/`
    ] as const;
    }


export const getApiQualityExternalLoadsV1ProductCodesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(productCodeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ProductCodesRetrieveQueryKey(productCodeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ProductCodesRetrieve(productCodeId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: productCodeId !== null && productCodeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ProductCodesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>>
export type ApiQualityExternalLoadsV1ProductCodesRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ProductCodesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 productCodeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ProductCodesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 productCodeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ProductCodesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 productCodeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ProductCodesRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 productCodeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ProductCodesRetrieveQueryOptions(productCodeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1ProductCodesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(productCodeId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1ProductCodesRetrieveQueryKey(productCodeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1ProductCodesRetrieve(productCodeId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1ProductCodesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>>
export type ApiQualityExternalLoadsV1ProductCodesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1ProductCodesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 productCodeId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ProductCodesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 productCodeId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1ProductCodesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 productCodeId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1ProductCodesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 productCodeId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1ProductCodesRetrieveSuspenseQueryOptions(productCodeId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalLoadsV1ProductCodesUpdate = (
    productCodeId: number,
    productCodeUpdateDTO?: BodyType<ProductCodeUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductCodeDetail>(
      {url: `/api/quality/external-loads/v1/product-codes/${productCodeId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productCodeUpdateDTO, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ProductCodesUpdateMutationOptions = <TError = ErrorType<ApiQualityExternalLoadsV1ProductCodesUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesUpdate>>, TError,{productCodeId: number;data?: BodyType<ProductCodeUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesUpdate>>, TError,{productCodeId: number;data?: BodyType<ProductCodeUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ProductCodesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesUpdate>>, {productCodeId: number;data?: BodyType<ProductCodeUpdateDTO>}> = (props) => {
          const {productCodeId,data} = props ?? {};

          return  apiQualityExternalLoadsV1ProductCodesUpdate(productCodeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ProductCodesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesUpdate>>>
    export type ApiQualityExternalLoadsV1ProductCodesUpdateMutationBody = BodyType<ProductCodeUpdateDTO> | undefined
    export type ApiQualityExternalLoadsV1ProductCodesUpdateMutationError = ErrorType<ApiQualityExternalLoadsV1ProductCodesUpdate400 | ErrorResponse>

    export const useApiQualityExternalLoadsV1ProductCodesUpdate = <TError = ErrorType<ApiQualityExternalLoadsV1ProductCodesUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesUpdate>>, TError,{productCodeId: number;data?: BodyType<ProductCodeUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesUpdate>>,
        TError,
        {productCodeId: number;data?: BodyType<ProductCodeUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ProductCodesUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1ProductCodesDestroy = (
    productCodeId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/external-loads/v1/product-codes/${productCodeId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1ProductCodesDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesDestroy>>, TError,{productCodeId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesDestroy>>, TError,{productCodeId: number}, TContext> => {

const mutationKey = ['apiQualityExternalLoadsV1ProductCodesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesDestroy>>, {productCodeId: number}> = (props) => {
          const {productCodeId} = props ?? {};

          return  apiQualityExternalLoadsV1ProductCodesDestroy(productCodeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalLoadsV1ProductCodesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesDestroy>>>

    export type ApiQualityExternalLoadsV1ProductCodesDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityExternalLoadsV1ProductCodesDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesDestroy>>, TError,{productCodeId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalLoadsV1ProductCodesDestroy>>,
        TError,
        {productCodeId: number},
        TContext
      > => {
      return useMutation(getApiQualityExternalLoadsV1ProductCodesDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve = (
    tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalLoadFieldOptionsResponse>(
      {url: `/api/quality/external-loads/v1/trade-companies/${tradeCompanyId}/load-field-options/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveQueryKey = (tradeCompanyId: number,
    params?: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams,) => {
    return [
    `/api/quality/external-loads/v1/trade-companies/${tradeCompanyId}/load-field-options/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>>
export type ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveQueryOptions(tradeCompanyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>> = ({ signal }) => apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>>
export type ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: ApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalLoadsV1TradeCompaniesLoadFieldOptionsRetrieveSuspenseQueryOptions(tradeCompanyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalUploadV1Create = (
    createExternalUpload: BodyType<CreateExternalUpload>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleExternalUploadDTO>(
      {url: `/api/quality/external-upload/v1/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createExternalUpload, signal
    },
      options);
    }




export const getApiQualityExternalUploadV1CreateMutationOptions = <TError = ErrorType<ApiQualityExternalUploadV1Create400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>, TError,{data: BodyType<CreateExternalUpload>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>, TError,{data: BodyType<CreateExternalUpload>}, TContext> => {

const mutationKey = ['apiQualityExternalUploadV1Create'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>, {data: BodyType<CreateExternalUpload>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityExternalUploadV1Create(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalUploadV1CreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>>
    export type ApiQualityExternalUploadV1CreateMutationBody = BodyType<CreateExternalUpload>
    export type ApiQualityExternalUploadV1CreateMutationError = ErrorType<ApiQualityExternalUploadV1Create400 | ErrorResponse>

    export const useApiQualityExternalUploadV1Create = <TError = ErrorType<ApiQualityExternalUploadV1Create400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>, TError,{data: BodyType<CreateExternalUpload>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalUploadV1Create>>,
        TError,
        {data: BodyType<CreateExternalUpload>},
        TContext
      > => {
      return useMutation(getApiQualityExternalUploadV1CreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalUploadV1Retrieve = (
    externalUploadUuid: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ExternalUploadWithUser>(
      {url: `/api/quality/external-upload/v1/${externalUploadUuid}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalUploadV1RetrieveQueryKey = (externalUploadUuid: string,) => {
    return [
    `/api/quality/external-upload/v1/${externalUploadUuid}/`
    ] as const;
    }


export const getApiQualityExternalUploadV1RetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(externalUploadUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalUploadV1RetrieveQueryKey(externalUploadUuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>> = ({ signal }) => apiQualityExternalUploadV1Retrieve(externalUploadUuid, requestOptions, signal);





   return  { queryKey, queryFn, enabled: externalUploadUuid !== null && externalUploadUuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalUploadV1RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>>
export type ApiQualityExternalUploadV1RetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalUploadV1Retrieve<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 externalUploadUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1Retrieve<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 externalUploadUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1Retrieve<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 externalUploadUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalUploadV1Retrieve<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 externalUploadUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalUploadV1RetrieveQueryOptions(externalUploadUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalUploadV1RetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(externalUploadUuid: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalUploadV1RetrieveQueryKey(externalUploadUuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>> = ({ signal }) => apiQualityExternalUploadV1Retrieve(externalUploadUuid, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalUploadV1RetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>>
export type ApiQualityExternalUploadV1RetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalUploadV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 externalUploadUuid: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 externalUploadUuid: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 externalUploadUuid: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalUploadV1RetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError = ErrorType<ErrorResponse>>(
 externalUploadUuid: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1Retrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalUploadV1RetrieveSuspenseQueryOptions(externalUploadUuid,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalUploadV1EvidenceList = (
    uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedEvidenceList>(
      {url: `/api/quality/external-upload/v1/${uuid}/evidence/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityExternalUploadV1EvidenceListQueryKey = (uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams,) => {
    return [
    `/api/quality/external-upload/v1/${uuid}/evidence/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityExternalUploadV1EvidenceListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalUploadV1EvidenceListQueryKey(uuid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>> = ({ signal }) => apiQualityExternalUploadV1EvidenceList(uuid,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: uuid !== null && uuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalUploadV1EvidenceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>>
export type ApiQualityExternalUploadV1EvidenceListQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalUploadV1EvidenceList<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    params: undefined |  ApiQualityExternalUploadV1EvidenceListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1EvidenceList<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1EvidenceList<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalUploadV1EvidenceList<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalUploadV1EvidenceListQueryOptions(uuid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalUploadV1EvidenceListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalUploadV1EvidenceListQueryKey(uuid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>> = ({ signal }) => apiQualityExternalUploadV1EvidenceList(uuid,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalUploadV1EvidenceListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>>
export type ApiQualityExternalUploadV1EvidenceListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalUploadV1EvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    params: undefined |  ApiQualityExternalUploadV1EvidenceListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1EvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1EvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalUploadV1EvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    params?: ApiQualityExternalUploadV1EvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalUploadV1EvidenceListSuspenseQueryOptions(uuid,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalUploadV1EvidenceRetrieve = (
    uuid: string,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Evidence>(
      {url: `/api/quality/external-upload/v1/${uuid}/evidence/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityExternalUploadV1EvidenceRetrieveQueryKey = (uuid: string,
    id: number,) => {
    return [
    `/api/quality/external-upload/v1/${uuid}/evidence/${id}/`
    ] as const;
    }


export const getApiQualityExternalUploadV1EvidenceRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(uuid: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalUploadV1EvidenceRetrieveQueryKey(uuid,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>> = ({ signal }) => apiQualityExternalUploadV1EvidenceRetrieve(uuid,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: uuid !== null && uuid !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalUploadV1EvidenceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>>
export type ApiQualityExternalUploadV1EvidenceRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalUploadV1EvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1EvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1EvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalUploadV1EvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalUploadV1EvidenceRetrieveQueryOptions(uuid,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityExternalUploadV1EvidenceRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(uuid: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityExternalUploadV1EvidenceRetrieveQueryKey(uuid,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>> = ({ signal }) => apiQualityExternalUploadV1EvidenceRetrieve(uuid,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityExternalUploadV1EvidenceRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>>
export type ApiQualityExternalUploadV1EvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityExternalUploadV1EvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1EvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityExternalUploadV1EvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityExternalUploadV1EvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 uuid: string,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityExternalUploadV1EvidenceRetrieveSuspenseQueryOptions(uuid,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityExternalUploadV1EvidenceBulkDeleteCreate = (
    uuid: string,
    bulkDeleteRequest: BodyType<BulkDeleteRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/external-upload/v1/${uuid}/evidence/bulk-delete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteRequest, signal
    },
      options);
    }




export const getApiQualityExternalUploadV1EvidenceBulkDeleteCreateMutationOptions = <TError = ErrorType<ApiQualityExternalUploadV1EvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceBulkDeleteCreate>>, TError,{uuid: string;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceBulkDeleteCreate>>, TError,{uuid: string;data: BodyType<BulkDeleteRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalUploadV1EvidenceBulkDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceBulkDeleteCreate>>, {uuid: string;data: BodyType<BulkDeleteRequest>}> = (props) => {
          const {uuid,data} = props ?? {};

          return  apiQualityExternalUploadV1EvidenceBulkDeleteCreate(uuid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalUploadV1EvidenceBulkDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceBulkDeleteCreate>>>
    export type ApiQualityExternalUploadV1EvidenceBulkDeleteCreateMutationBody = BodyType<BulkDeleteRequest>
    export type ApiQualityExternalUploadV1EvidenceBulkDeleteCreateMutationError = ErrorType<ApiQualityExternalUploadV1EvidenceBulkDeleteCreate400 | ErrorResponse>

    export const useApiQualityExternalUploadV1EvidenceBulkDeleteCreate = <TError = ErrorType<ApiQualityExternalUploadV1EvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceBulkDeleteCreate>>, TError,{uuid: string;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceBulkDeleteCreate>>,
        TError,
        {uuid: string;data: BodyType<BulkDeleteRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalUploadV1EvidenceBulkDeleteCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalUploadV1EvidenceUploadCreate = (
    uuid: string,
    generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GenerateUploadUrlResponse>(
      {url: `/api/quality/external-upload/v1/${uuid}/evidence/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateUploadUrlRequest, signal
    },
      options);
    }




export const getApiQualityExternalUploadV1EvidenceUploadCreateMutationOptions = <TError = ErrorType<ApiQualityExternalUploadV1EvidenceUploadCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>, TError,{uuid: string;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>, TError,{uuid: string;data: BodyType<GenerateUploadUrlRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalUploadV1EvidenceUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>, {uuid: string;data: BodyType<GenerateUploadUrlRequest>}> = (props) => {
          const {uuid,data} = props ?? {};

          return  apiQualityExternalUploadV1EvidenceUploadCreate(uuid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalUploadV1EvidenceUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>>
    export type ApiQualityExternalUploadV1EvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>
    export type ApiQualityExternalUploadV1EvidenceUploadCreateMutationError = ErrorType<ApiQualityExternalUploadV1EvidenceUploadCreate400 | ErrorResponse>

    export const useApiQualityExternalUploadV1EvidenceUploadCreate = <TError = ErrorType<ApiQualityExternalUploadV1EvidenceUploadCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>, TError,{uuid: string;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadCreate>>,
        TError,
        {uuid: string;data: BodyType<GenerateUploadUrlRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalUploadV1EvidenceUploadCreateMutationOptions(options), queryClient);
    }
    export const apiQualityExternalUploadV1EvidenceUploadUpdate = (
    uuid: string,
    processUploadRequest: BodyType<ProcessUploadRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessUploadResponse>(
      {url: `/api/quality/external-upload/v1/${uuid}/evidence/upload/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: processUploadRequest, signal
    },
      options);
    }




export const getApiQualityExternalUploadV1EvidenceUploadUpdateMutationOptions = <TError = ErrorType<ApiQualityExternalUploadV1EvidenceUploadUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>, TError,{uuid: string;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>, TError,{uuid: string;data: BodyType<ProcessUploadRequest>}, TContext> => {

const mutationKey = ['apiQualityExternalUploadV1EvidenceUploadUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>, {uuid: string;data: BodyType<ProcessUploadRequest>}> = (props) => {
          const {uuid,data} = props ?? {};

          return  apiQualityExternalUploadV1EvidenceUploadUpdate(uuid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityExternalUploadV1EvidenceUploadUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>>
    export type ApiQualityExternalUploadV1EvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>
    export type ApiQualityExternalUploadV1EvidenceUploadUpdateMutationError = ErrorType<ApiQualityExternalUploadV1EvidenceUploadUpdate400 | ErrorResponse>

    export const useApiQualityExternalUploadV1EvidenceUploadUpdate = <TError = ErrorType<ApiQualityExternalUploadV1EvidenceUploadUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>, TError,{uuid: string;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityExternalUploadV1EvidenceUploadUpdate>>,
        TError,
        {uuid: string;data: BodyType<ProcessUploadRequest>},
        TContext
      > => {
      return useMutation(getApiQualityExternalUploadV1EvidenceUploadUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1AcceptLoadCreate = (
    acceptLoadRequest: BodyType<AcceptLoadRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<AcceptLoadResponse>(
      {url: `/api/quality/production/v1/accept-load/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptLoadRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1AcceptLoadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1AcceptLoadCreate>>, TError,{data: BodyType<AcceptLoadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1AcceptLoadCreate>>, TError,{data: BodyType<AcceptLoadRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1AcceptLoadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1AcceptLoadCreate>>, {data: BodyType<AcceptLoadRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityProductionV1AcceptLoadCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1AcceptLoadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1AcceptLoadCreate>>>
    export type ApiQualityProductionV1AcceptLoadCreateMutationBody = BodyType<AcceptLoadRequest>
    export type ApiQualityProductionV1AcceptLoadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1AcceptLoadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1AcceptLoadCreate>>, TError,{data: BodyType<AcceptLoadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1AcceptLoadCreate>>,
        TError,
        {data: BodyType<AcceptLoadRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1AcceptLoadCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BatchesList = (
    params?: ApiQualityProductionV1BatchesListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BatchListResponse>(
      {url: `/api/quality/production/v1/batches/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1BatchesListQueryKey = (params?: ApiQualityProductionV1BatchesListParams,) => {
    return [
    `/api/quality/production/v1/batches/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1BatchesListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1BatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1BatchesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>> = ({ signal }) => apiQualityProductionV1BatchesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1BatchesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>>
export type ApiQualityProductionV1BatchesListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1BatchesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1BatchesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BatchesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BatchesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1BatchesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BatchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1BatchesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1BatchesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1BatchesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1BatchesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>> = ({ signal }) => apiQualityProductionV1BatchesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1BatchesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>>
export type ApiQualityProductionV1BatchesListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1BatchesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1BatchesListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BatchesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BatchesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BatchesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BatchesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1BatchesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BatchesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1BatchesListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1BatchesMoveCreate = (
    batchId: number,
    moveBatchRequest: BodyType<MoveBatchRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MoveBatchResponse>(
      {url: `/api/quality/production/v1/batches/${batchId}/move/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moveBatchRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1BatchesMoveCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesMoveCreate>>, TError,{batchId: number;data: BodyType<MoveBatchRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesMoveCreate>>, TError,{batchId: number;data: BodyType<MoveBatchRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1BatchesMoveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BatchesMoveCreate>>, {batchId: number;data: BodyType<MoveBatchRequest>}> = (props) => {
          const {batchId,data} = props ?? {};

          return  apiQualityProductionV1BatchesMoveCreate(batchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BatchesMoveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BatchesMoveCreate>>>
    export type ApiQualityProductionV1BatchesMoveCreateMutationBody = BodyType<MoveBatchRequest>
    export type ApiQualityProductionV1BatchesMoveCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1BatchesMoveCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BatchesMoveCreate>>, TError,{batchId: number;data: BodyType<MoveBatchRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BatchesMoveCreate>>,
        TError,
        {batchId: number;data: BodyType<MoveBatchRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BatchesMoveCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BaysList = (
    params?: ApiQualityProductionV1BaysListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BayListResponse>(
      {url: `/api/quality/production/v1/bays/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1BaysListQueryKey = (params?: ApiQualityProductionV1BaysListParams,) => {
    return [
    `/api/quality/production/v1/bays/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1BaysListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1BaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1BaysListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>> = ({ signal }) => apiQualityProductionV1BaysList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1BaysListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>>
export type ApiQualityProductionV1BaysListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1BaysList<TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1BaysListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BaysList<TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BaysList<TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1BaysList<TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BaysListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1BaysListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1BaysListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1BaysListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1BaysListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>> = ({ signal }) => apiQualityProductionV1BaysList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1BaysListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>>
export type ApiQualityProductionV1BaysListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1BaysListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1BaysListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BaysListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BaysListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BaysListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BaysListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1BaysListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1BaysListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1BaysListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1BaysCreate = (
    bayCreateDTO: BodyType<BayCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BayListItem>(
      {url: `/api/quality/production/v1/bays/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bayCreateDTO, signal
    },
      options);
    }




export const getApiQualityProductionV1BaysCreateMutationOptions = <TError = ErrorType<ApiQualityProductionV1BaysCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysCreate>>, TError,{data: BodyType<BayCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysCreate>>, TError,{data: BodyType<BayCreateDTO>}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysCreate>>, {data: BodyType<BayCreateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityProductionV1BaysCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysCreate>>>
    export type ApiQualityProductionV1BaysCreateMutationBody = BodyType<BayCreateDTO>
    export type ApiQualityProductionV1BaysCreateMutationError = ErrorType<ApiQualityProductionV1BaysCreate400 | ErrorResponse>

    export const useApiQualityProductionV1BaysCreate = <TError = ErrorType<ApiQualityProductionV1BaysCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysCreate>>, TError,{data: BodyType<BayCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysCreate>>,
        TError,
        {data: BodyType<BayCreateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BayRetrieve = (
    bayId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BayListItem>(
      {url: `/api/quality/production/v1/bays/${bayId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1BayRetrieveQueryKey = (bayId: number,) => {
    return [
    `/api/quality/production/v1/bays/${bayId}/`
    ] as const;
    }


export const getApiQualityProductionV1BayRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(bayId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1BayRetrieveQueryKey(bayId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>> = ({ signal }) => apiQualityProductionV1BayRetrieve(bayId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: bayId !== null && bayId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1BayRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>>
export type ApiQualityProductionV1BayRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1BayRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bayId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BayRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bayId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BayRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bayId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1BayRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bayId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1BayRetrieveQueryOptions(bayId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1BayRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(bayId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1BayRetrieveQueryKey(bayId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>> = ({ signal }) => apiQualityProductionV1BayRetrieve(bayId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1BayRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>>
export type ApiQualityProductionV1BayRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1BayRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bayId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BayRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bayId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1BayRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bayId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1BayRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError = ErrorType<ErrorResponse>>(
 bayId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1BayRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1BayRetrieveSuspenseQueryOptions(bayId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1BaysUpdate = (
    bayId: number,
    bayUpdateDTO?: BodyType<BayUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BayListItem>(
      {url: `/api/quality/production/v1/bays/${bayId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bayUpdateDTO, signal
    },
      options);
    }




export const getApiQualityProductionV1BaysUpdateMutationOptions = <TError = ErrorType<ApiQualityProductionV1BaysUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysUpdate>>, TError,{bayId: number;data?: BodyType<BayUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysUpdate>>, TError,{bayId: number;data?: BodyType<BayUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysUpdate>>, {bayId: number;data?: BodyType<BayUpdateDTO>}> = (props) => {
          const {bayId,data} = props ?? {};

          return  apiQualityProductionV1BaysUpdate(bayId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysUpdate>>>
    export type ApiQualityProductionV1BaysUpdateMutationBody = BodyType<BayUpdateDTO> | undefined
    export type ApiQualityProductionV1BaysUpdateMutationError = ErrorType<ApiQualityProductionV1BaysUpdate400 | ErrorResponse>

    export const useApiQualityProductionV1BaysUpdate = <TError = ErrorType<ApiQualityProductionV1BaysUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysUpdate>>, TError,{bayId: number;data?: BodyType<BayUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysUpdate>>,
        TError,
        {bayId: number;data?: BodyType<BayUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BaysDestroy = (
    bayId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/production/v1/bays/${bayId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityProductionV1BaysDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysDestroy>>, TError,{bayId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysDestroy>>, TError,{bayId: number}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysDestroy>>, {bayId: number}> = (props) => {
          const {bayId} = props ?? {};

          return  apiQualityProductionV1BaysDestroy(bayId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysDestroy>>>

    export type ApiQualityProductionV1BaysDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1BaysDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysDestroy>>, TError,{bayId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysDestroy>>,
        TError,
        {bayId: number},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BaysProcessBalesCreate = (
    bayId: number,
    processBalesRequest: BodyType<ProcessBalesRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessBalesResponse>(
      {url: `/api/quality/production/v1/bays/${bayId}/process-bales/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processBalesRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1BaysProcessBalesCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysProcessBalesCreate>>, TError,{bayId: number;data: BodyType<ProcessBalesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysProcessBalesCreate>>, TError,{bayId: number;data: BodyType<ProcessBalesRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysProcessBalesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysProcessBalesCreate>>, {bayId: number;data: BodyType<ProcessBalesRequest>}> = (props) => {
          const {bayId,data} = props ?? {};

          return  apiQualityProductionV1BaysProcessBalesCreate(bayId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysProcessBalesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysProcessBalesCreate>>>
    export type ApiQualityProductionV1BaysProcessBalesCreateMutationBody = BodyType<ProcessBalesRequest>
    export type ApiQualityProductionV1BaysProcessBalesCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1BaysProcessBalesCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysProcessBalesCreate>>, TError,{bayId: number;data: BodyType<ProcessBalesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysProcessBalesCreate>>,
        TError,
        {bayId: number;data: BodyType<ProcessBalesRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysProcessBalesCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BaysRejectBalesCreate = (
    bayId: number,
    rejectBalesRequest: BodyType<RejectBalesRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RejectBalesResponse>(
      {url: `/api/quality/production/v1/bays/${bayId}/reject-bales/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectBalesRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1BaysRejectBalesCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysRejectBalesCreate>>, TError,{bayId: number;data: BodyType<RejectBalesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysRejectBalesCreate>>, TError,{bayId: number;data: BodyType<RejectBalesRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysRejectBalesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysRejectBalesCreate>>, {bayId: number;data: BodyType<RejectBalesRequest>}> = (props) => {
          const {bayId,data} = props ?? {};

          return  apiQualityProductionV1BaysRejectBalesCreate(bayId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysRejectBalesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysRejectBalesCreate>>>
    export type ApiQualityProductionV1BaysRejectBalesCreateMutationBody = BodyType<RejectBalesRequest>
    export type ApiQualityProductionV1BaysRejectBalesCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1BaysRejectBalesCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysRejectBalesCreate>>, TError,{bayId: number;data: BodyType<RejectBalesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysRejectBalesCreate>>,
        TError,
        {bayId: number;data: BodyType<RejectBalesRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysRejectBalesCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BaysReorderBatchesCreate = (
    bayId: number,
    batchReorderDTO: BodyType<BatchReorderDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BayWithBatches>(
      {url: `/api/quality/production/v1/bays/${bayId}/reorder-batches/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: batchReorderDTO, signal
    },
      options);
    }




export const getApiQualityProductionV1BaysReorderBatchesCreateMutationOptions = <TError = ErrorType<ApiQualityProductionV1BaysReorderBatchesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysReorderBatchesCreate>>, TError,{bayId: number;data: BodyType<BatchReorderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysReorderBatchesCreate>>, TError,{bayId: number;data: BodyType<BatchReorderDTO>}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysReorderBatchesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysReorderBatchesCreate>>, {bayId: number;data: BodyType<BatchReorderDTO>}> = (props) => {
          const {bayId,data} = props ?? {};

          return  apiQualityProductionV1BaysReorderBatchesCreate(bayId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysReorderBatchesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysReorderBatchesCreate>>>
    export type ApiQualityProductionV1BaysReorderBatchesCreateMutationBody = BodyType<BatchReorderDTO>
    export type ApiQualityProductionV1BaysReorderBatchesCreateMutationError = ErrorType<ApiQualityProductionV1BaysReorderBatchesCreate400 | ErrorResponse>

    export const useApiQualityProductionV1BaysReorderBatchesCreate = <TError = ErrorType<ApiQualityProductionV1BaysReorderBatchesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysReorderBatchesCreate>>, TError,{bayId: number;data: BodyType<BatchReorderDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysReorderBatchesCreate>>,
        TError,
        {bayId: number;data: BodyType<BatchReorderDTO>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysReorderBatchesCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BaysStageBaleCreate = (
    bayId: number,
    stageBaleRequest?: BodyType<StageBaleRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<StageBaleResponse>(
      {url: `/api/quality/production/v1/bays/${bayId}/stage-bale/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stageBaleRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1BaysStageBaleCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBaleCreate>>, TError,{bayId: number;data?: BodyType<StageBaleRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBaleCreate>>, TError,{bayId: number;data?: BodyType<StageBaleRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysStageBaleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBaleCreate>>, {bayId: number;data?: BodyType<StageBaleRequest>}> = (props) => {
          const {bayId,data} = props ?? {};

          return  apiQualityProductionV1BaysStageBaleCreate(bayId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysStageBaleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBaleCreate>>>
    export type ApiQualityProductionV1BaysStageBaleCreateMutationBody = BodyType<StageBaleRequest> | undefined
    export type ApiQualityProductionV1BaysStageBaleCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1BaysStageBaleCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBaleCreate>>, TError,{bayId: number;data?: BodyType<StageBaleRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBaleCreate>>,
        TError,
        {bayId: number;data?: BodyType<StageBaleRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysStageBaleCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BaysStageBalesCreate = (
    bayId: number,
    stageBalesRequest: BodyType<StageBalesRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<StageBalesResponse>(
      {url: `/api/quality/production/v1/bays/${bayId}/stage-bales/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stageBalesRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1BaysStageBalesCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBalesCreate>>, TError,{bayId: number;data: BodyType<StageBalesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBalesCreate>>, TError,{bayId: number;data: BodyType<StageBalesRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysStageBalesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBalesCreate>>, {bayId: number;data: BodyType<StageBalesRequest>}> = (props) => {
          const {bayId,data} = props ?? {};

          return  apiQualityProductionV1BaysStageBalesCreate(bayId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysStageBalesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBalesCreate>>>
    export type ApiQualityProductionV1BaysStageBalesCreateMutationBody = BodyType<StageBalesRequest>
    export type ApiQualityProductionV1BaysStageBalesCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1BaysStageBalesCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBalesCreate>>, TError,{bayId: number;data: BodyType<StageBalesRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysStageBalesCreate>>,
        TError,
        {bayId: number;data: BodyType<StageBalesRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysStageBalesCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1BaysTakeBaleCreate = (
    bayId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<TakeBaleResponse>(
      {url: `/api/quality/production/v1/bays/${bayId}/take-bale/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualityProductionV1BaysTakeBaleCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysTakeBaleCreate>>, TError,{bayId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysTakeBaleCreate>>, TError,{bayId: number}, TContext> => {

const mutationKey = ['apiQualityProductionV1BaysTakeBaleCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1BaysTakeBaleCreate>>, {bayId: number}> = (props) => {
          const {bayId} = props ?? {};

          return  apiQualityProductionV1BaysTakeBaleCreate(bayId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1BaysTakeBaleCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1BaysTakeBaleCreate>>>

    export type ApiQualityProductionV1BaysTakeBaleCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1BaysTakeBaleCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1BaysTakeBaleCreate>>, TError,{bayId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1BaysTakeBaleCreate>>,
        TError,
        {bayId: number},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1BaysTakeBaleCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ConfigurationRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductionConfiguration>(
      {url: `/api/quality/production/v1/configuration/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1ConfigurationRetrieveQueryKey = () => {
    return [
    `/api/quality/production/v1/configuration/`
    ] as const;
    }


export const getApiQualityProductionV1ConfigurationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ConfigurationRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>> = ({ signal }) => apiQualityProductionV1ConfigurationRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ConfigurationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>>
export type ApiQualityProductionV1ConfigurationRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ConfigurationRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ConfigurationRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ConfigurationRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ConfigurationRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ConfigurationRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ConfigurationRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ConfigurationRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>> = ({ signal }) => apiQualityProductionV1ConfigurationRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ConfigurationRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>>
export type ApiQualityProductionV1ConfigurationRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ConfigurationRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ConfigurationRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ConfigurationRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ConfigurationRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ConfigurationRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ConfigurationPartialUpdate = (
    patchedProductionConfigurationUpdateDTO?: BodyType<PatchedProductionConfigurationUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductionConfiguration>(
      {url: `/api/quality/production/v1/configuration/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProductionConfigurationUpdateDTO, signal
    },
      options);
    }




export const getApiQualityProductionV1ConfigurationPartialUpdateMutationOptions = <TError = ErrorType<ApiQualityProductionV1ConfigurationPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationPartialUpdate>>, TError,{data?: BodyType<PatchedProductionConfigurationUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationPartialUpdate>>, TError,{data?: BodyType<PatchedProductionConfigurationUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityProductionV1ConfigurationPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationPartialUpdate>>, {data?: BodyType<PatchedProductionConfigurationUpdateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityProductionV1ConfigurationPartialUpdate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ConfigurationPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationPartialUpdate>>>
    export type ApiQualityProductionV1ConfigurationPartialUpdateMutationBody = BodyType<PatchedProductionConfigurationUpdateDTO> | undefined
    export type ApiQualityProductionV1ConfigurationPartialUpdateMutationError = ErrorType<ApiQualityProductionV1ConfigurationPartialUpdate400 | ErrorResponse>

    export const useApiQualityProductionV1ConfigurationPartialUpdate = <TError = ErrorType<ApiQualityProductionV1ConfigurationPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationPartialUpdate>>, TError,{data?: BodyType<PatchedProductionConfigurationUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ConfigurationPartialUpdate>>,
        TError,
        {data?: BodyType<PatchedProductionConfigurationUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ConfigurationPartialUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate = (
    externalLoadId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/production/v1/external-loads/${externalLoadId}/remove-from-production-management/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate>>, TError,{externalLoadId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate>>, TError,{externalLoadId: number}, TContext> => {

const mutationKey = ['apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate>>, {externalLoadId: number}> = (props) => {
          const {externalLoadId} = props ?? {};

          return  apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate(externalLoadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate>>>

    export type ApiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate>>, TError,{externalLoadId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreate>>,
        TError,
        {externalLoadId: number},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ExternalLoadsRemoveFromProductionManagementCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate = (
    externalLoadId: number,
    recordStorageRecommendationOutcomeRequest: BodyType<RecordStorageRecommendationOutcomeRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RecordStorageRecommendationOutcomeResponse>(
      {url: `/api/quality/production/v1/external-loads/${externalLoadId}/storage-recommendation-outcomes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordStorageRecommendationOutcomeRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate>>, TError,{externalLoadId: number;data: BodyType<RecordStorageRecommendationOutcomeRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate>>, TError,{externalLoadId: number;data: BodyType<RecordStorageRecommendationOutcomeRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate>>, {externalLoadId: number;data: BodyType<RecordStorageRecommendationOutcomeRequest>}> = (props) => {
          const {externalLoadId,data} = props ?? {};

          return  apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate(externalLoadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate>>>
    export type ApiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreateMutationBody = BodyType<RecordStorageRecommendationOutcomeRequest>
    export type ApiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate>>, TError,{externalLoadId: number;data: BodyType<RecordStorageRecommendationOutcomeRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreate>>,
        TError,
        {externalLoadId: number;data: BodyType<RecordStorageRecommendationOutcomeRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ExternalLoadStorageRecommendationOutcomesCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ExternalLoadStorageRecommendations = (
    externalLoadId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<StorageRecommendationsResponse>(
      {url: `/api/quality/production/v1/external-loads/${externalLoadId}/storage-recommendations/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1ExternalLoadStorageRecommendationsQueryKey = (externalLoadId: number,) => {
    return [
    `/api/quality/production/v1/external-loads/${externalLoadId}/storage-recommendations/`
    ] as const;
    }


export const getApiQualityProductionV1ExternalLoadStorageRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ExternalLoadStorageRecommendationsQueryKey(externalLoadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>> = ({ signal }) => apiQualityProductionV1ExternalLoadStorageRecommendations(externalLoadId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: externalLoadId !== null && externalLoadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ExternalLoadStorageRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>>
export type ApiQualityProductionV1ExternalLoadStorageRecommendationsQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ExternalLoadStorageRecommendations<TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ExternalLoadStorageRecommendations<TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ExternalLoadStorageRecommendations<TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ExternalLoadStorageRecommendations<TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ExternalLoadStorageRecommendationsQueryOptions(externalLoadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ExternalLoadStorageRecommendationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ExternalLoadStorageRecommendationsQueryKey(externalLoadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>> = ({ signal }) => apiQualityProductionV1ExternalLoadStorageRecommendations(externalLoadId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ExternalLoadStorageRecommendationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>>
export type ApiQualityProductionV1ExternalLoadStorageRecommendationsSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ExternalLoadStorageRecommendationsSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ExternalLoadStorageRecommendationsSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ExternalLoadStorageRecommendationsSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ExternalLoadStorageRecommendationsSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError = ErrorType<ErrorResponse>>(
 externalLoadId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ExternalLoadStorageRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ExternalLoadStorageRecommendationsSuspenseQueryOptions(externalLoadId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1PickingListsList = (
    params?: ApiQualityProductionV1PickingListsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PickingListResponse>(
      {url: `/api/quality/production/v1/picking-lists/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1PickingListsListQueryKey = (params?: ApiQualityProductionV1PickingListsListParams,) => {
    return [
    `/api/quality/production/v1/picking-lists/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1PickingListsListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1PickingListsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1PickingListsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>> = ({ signal }) => apiQualityProductionV1PickingListsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1PickingListsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>>
export type ApiQualityProductionV1PickingListsListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1PickingListsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1PickingListsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1PickingListsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1PickingListsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1PickingListsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1PickingListsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1PickingListsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1PickingListsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1PickingListsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1PickingListsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>> = ({ signal }) => apiQualityProductionV1PickingListsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1PickingListsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>>
export type ApiQualityProductionV1PickingListsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1PickingListsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1PickingListsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1PickingListsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1PickingListsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1PickingListsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1PickingListsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1PickingListsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1PickingListsCreate = (
    pickingListCreateRequest: BodyType<PickingListCreateRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimplePickingList>(
      {url: `/api/quality/production/v1/picking-lists/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pickingListCreateRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1PickingListsCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsCreate>>, TError,{data: BodyType<PickingListCreateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsCreate>>, TError,{data: BodyType<PickingListCreateRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1PickingListsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsCreate>>, {data: BodyType<PickingListCreateRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityProductionV1PickingListsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1PickingListsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsCreate>>>
    export type ApiQualityProductionV1PickingListsCreateMutationBody = BodyType<PickingListCreateRequest>
    export type ApiQualityProductionV1PickingListsCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1PickingListsCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsCreate>>, TError,{data: BodyType<PickingListCreateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1PickingListsCreate>>,
        TError,
        {data: BodyType<PickingListCreateRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1PickingListsCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1PickingListsRetrieve = (
    pickingListId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PickingListWithItems>(
      {url: `/api/quality/production/v1/picking-lists/${pickingListId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1PickingListsRetrieveQueryKey = (pickingListId: number,) => {
    return [
    `/api/quality/production/v1/picking-lists/${pickingListId}/`
    ] as const;
    }


export const getApiQualityProductionV1PickingListsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(pickingListId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1PickingListsRetrieveQueryKey(pickingListId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>> = ({ signal }) => apiQualityProductionV1PickingListsRetrieve(pickingListId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: pickingListId !== null && pickingListId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1PickingListsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>>
export type ApiQualityProductionV1PickingListsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1PickingListsRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 pickingListId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 pickingListId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 pickingListId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1PickingListsRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 pickingListId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1PickingListsRetrieveQueryOptions(pickingListId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1PickingListsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(pickingListId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1PickingListsRetrieveQueryKey(pickingListId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>> = ({ signal }) => apiQualityProductionV1PickingListsRetrieve(pickingListId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1PickingListsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>>
export type ApiQualityProductionV1PickingListsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1PickingListsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 pickingListId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 pickingListId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 pickingListId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1PickingListsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 pickingListId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1PickingListsRetrieveSuspenseQueryOptions(pickingListId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1PickingListsPartialUpdate = (
    pickingListId: number,
    patchedPickingListPatchRequest?: BodyType<PatchedPickingListPatchRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PickingListPatchResult>(
      {url: `/api/quality/production/v1/picking-lists/${pickingListId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedPickingListPatchRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1PickingListsPartialUpdateMutationOptions = <TError = ErrorType<ErrorResponse | PickingListConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPartialUpdate>>, TError,{pickingListId: number;data?: BodyType<PatchedPickingListPatchRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPartialUpdate>>, TError,{pickingListId: number;data?: BodyType<PatchedPickingListPatchRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1PickingListsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPartialUpdate>>, {pickingListId: number;data?: BodyType<PatchedPickingListPatchRequest>}> = (props) => {
          const {pickingListId,data} = props ?? {};

          return  apiQualityProductionV1PickingListsPartialUpdate(pickingListId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1PickingListsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPartialUpdate>>>
    export type ApiQualityProductionV1PickingListsPartialUpdateMutationBody = BodyType<PatchedPickingListPatchRequest> | undefined
    export type ApiQualityProductionV1PickingListsPartialUpdateMutationError = ErrorType<ErrorResponse | PickingListConflict>

    export const useApiQualityProductionV1PickingListsPartialUpdate = <TError = ErrorType<ErrorResponse | PickingListConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPartialUpdate>>, TError,{pickingListId: number;data?: BodyType<PatchedPickingListPatchRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPartialUpdate>>,
        TError,
        {pickingListId: number;data?: BodyType<PatchedPickingListPatchRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1PickingListsPartialUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1PickingListsItemsDestroy = (
    pickingListId: number,
    itemId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/production/v1/picking-lists/${pickingListId}/items/${itemId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityProductionV1PickingListsItemsDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsItemsDestroy>>, TError,{pickingListId: number;itemId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsItemsDestroy>>, TError,{pickingListId: number;itemId: number}, TContext> => {

const mutationKey = ['apiQualityProductionV1PickingListsItemsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsItemsDestroy>>, {pickingListId: number;itemId: number}> = (props) => {
          const {pickingListId,itemId} = props ?? {};

          return  apiQualityProductionV1PickingListsItemsDestroy(pickingListId,itemId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1PickingListsItemsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsItemsDestroy>>>

    export type ApiQualityProductionV1PickingListsItemsDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1PickingListsItemsDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsItemsDestroy>>, TError,{pickingListId: number;itemId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1PickingListsItemsDestroy>>,
        TError,
        {pickingListId: number;itemId: number},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1PickingListsItemsDestroyMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1PickingListsGeneratePdfCreate = (
    pickingListGeneratePDFRequest?: BodyType<PickingListGeneratePDFRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PickingListGeneratePDFResponse>(
      {url: `/api/quality/production/v1/picking-lists/generate-pdf/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pickingListGeneratePDFRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1PickingListsGeneratePdfCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsGeneratePdfCreate>>, TError,{data?: BodyType<PickingListGeneratePDFRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsGeneratePdfCreate>>, TError,{data?: BodyType<PickingListGeneratePDFRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1PickingListsGeneratePdfCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsGeneratePdfCreate>>, {data?: BodyType<PickingListGeneratePDFRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityProductionV1PickingListsGeneratePdfCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1PickingListsGeneratePdfCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsGeneratePdfCreate>>>
    export type ApiQualityProductionV1PickingListsGeneratePdfCreateMutationBody = BodyType<PickingListGeneratePDFRequest> | undefined
    export type ApiQualityProductionV1PickingListsGeneratePdfCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1PickingListsGeneratePdfCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsGeneratePdfCreate>>, TError,{data?: BodyType<PickingListGeneratePDFRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1PickingListsGeneratePdfCreate>>,
        TError,
        {data?: BodyType<PickingListGeneratePDFRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1PickingListsGeneratePdfCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve = (
    params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PickingListPDFStatusResponse>(
      {url: `/api/quality/production/v1/picking-lists/pdf-generation-status/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveQueryKey = (params?: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams,) => {
    return [
    `/api/quality/production/v1/picking-lists/pdf-generation-status/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>> = ({ signal }) => apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>>
export type ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1PickingListsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1PickingListsPdfGenerationStatusRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>> = ({ signal }) => apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>>
export type ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError = ErrorType<ErrorResponse>>(
 params: ApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1PickingListsPdfGenerationStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1PickingListsPdfGenerationStatusRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualityProductionV1ProcessedBalesList = (
    params?: ApiQualityProductionV1ProcessedBalesListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedProcessedBaleWithLoadInfoList>(
      {url: `/api/quality/production/v1/processed-bales/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ProcessedBalesListQueryKey = (params?: ApiQualityProductionV1ProcessedBalesListParams,) => {
    return [
    `/api/quality/production/v1/processed-bales/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ProcessedBalesListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProcessedBalesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProcessedBalesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>> = ({ signal }) => apiQualityProductionV1ProcessedBalesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProcessedBalesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>>
export type ApiQualityProductionV1ProcessedBalesListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProcessedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProcessedBalesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProcessedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessedBalesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProcessedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessedBalesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProcessedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessedBalesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProcessedBalesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProcessedBalesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProcessedBalesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProcessedBalesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>> = ({ signal }) => apiQualityProductionV1ProcessedBalesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProcessedBalesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>>
export type ApiQualityProductionV1ProcessedBalesListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProcessedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProcessedBalesListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProcessedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessedBalesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProcessedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessedBalesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProcessedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessedBalesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProcessedBalesListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProcessedBalesPartialUpdate = (
    processedBaleId: number,
    patchedProcessedBaleUpdateDTO?: BodyType<PatchedProcessedBaleUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessedBaleWithLoadInfo>(
      {url: `/api/quality/production/v1/processed-bales/${processedBaleId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedProcessedBaleUpdateDTO, signal
    },
      options);
    }




export const getApiQualityProductionV1ProcessedBalesPartialUpdateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesPartialUpdate>>, TError,{processedBaleId: number;data?: BodyType<PatchedProcessedBaleUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesPartialUpdate>>, TError,{processedBaleId: number;data?: BodyType<PatchedProcessedBaleUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityProductionV1ProcessedBalesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesPartialUpdate>>, {processedBaleId: number;data?: BodyType<PatchedProcessedBaleUpdateDTO>}> = (props) => {
          const {processedBaleId,data} = props ?? {};

          return  apiQualityProductionV1ProcessedBalesPartialUpdate(processedBaleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ProcessedBalesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesPartialUpdate>>>
    export type ApiQualityProductionV1ProcessedBalesPartialUpdateMutationBody = BodyType<PatchedProcessedBaleUpdateDTO> | undefined
    export type ApiQualityProductionV1ProcessedBalesPartialUpdateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ProcessedBalesPartialUpdate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesPartialUpdate>>, TError,{processedBaleId: number;data?: BodyType<PatchedProcessedBaleUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesPartialUpdate>>,
        TError,
        {processedBaleId: number;data?: BodyType<PatchedProcessedBaleUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ProcessedBalesPartialUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ProcessedBalesUndoCreate = (
    processedBaleId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/production/v1/processed-bales/${processedBaleId}/undo/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualityProductionV1ProcessedBalesUndoCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesUndoCreate>>, TError,{processedBaleId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesUndoCreate>>, TError,{processedBaleId: number}, TContext> => {

const mutationKey = ['apiQualityProductionV1ProcessedBalesUndoCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesUndoCreate>>, {processedBaleId: number}> = (props) => {
          const {processedBaleId} = props ?? {};

          return  apiQualityProductionV1ProcessedBalesUndoCreate(processedBaleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ProcessedBalesUndoCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesUndoCreate>>>

    export type ApiQualityProductionV1ProcessedBalesUndoCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ProcessedBalesUndoCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesUndoCreate>>, TError,{processedBaleId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ProcessedBalesUndoCreate>>,
        TError,
        {processedBaleId: number},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ProcessedBalesUndoCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ProcessingSummary = (
    params?: ApiQualityProductionV1ProcessingSummaryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessingSummary>(
      {url: `/api/quality/production/v1/processing-summary/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ProcessingSummaryQueryKey = (params?: ApiQualityProductionV1ProcessingSummaryParams,) => {
    return [
    `/api/quality/production/v1/processing-summary/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ProcessingSummaryQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProcessingSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProcessingSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>> = ({ signal }) => apiQualityProductionV1ProcessingSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProcessingSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>>
export type ApiQualityProductionV1ProcessingSummaryQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProcessingSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProcessingSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProcessingSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessingSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProcessingSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessingSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProcessingSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessingSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProcessingSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProcessingSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProcessingSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProcessingSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>> = ({ signal }) => apiQualityProductionV1ProcessingSummary(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProcessingSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>>
export type ApiQualityProductionV1ProcessingSummarySuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProcessingSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProcessingSummaryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProcessingSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessingSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProcessingSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessingSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProcessingSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProcessingSummaryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProcessingSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProcessingSummarySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProductionHistory = (
    params?: ApiQualityProductionV1ProductionHistoryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductionHistory>(
      {url: `/api/quality/production/v1/production-history/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionHistoryQueryKey = (params?: ApiQualityProductionV1ProductionHistoryParams,) => {
    return [
    `/api/quality/production/v1/production-history/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ProductionHistoryQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProductionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>> = ({ signal }) => apiQualityProductionV1ProductionHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>>
export type ApiQualityProductionV1ProductionHistoryQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProductionHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionHistorySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProductionHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>> = ({ signal }) => apiQualityProductionV1ProductionHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>>
export type ApiQualityProductionV1ProductionHistorySuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProductionHistoryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionHistorySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Individual processed bales behind the history, for the drill-in drawers.
 *
 * Bales are attributed to shift-anchored production days exactly as the grid
 * aggregates them, so ``production_day`` scopes a per-day drawer while omitting it
 * lists the whole selected range. Optional ``production_line_id`` / ``category_id``
 * / ``origin_bay_id`` narrow to a specific line/material/bay; ``unassigned=true``
 * scopes to bales with no production line (the catch-all bucket the grid shows).
 */
export const apiQualityProductionV1ProductionHistoryBales = (
    params?: ApiQualityProductionV1ProductionHistoryBalesParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedProcessedBaleWithLoadInfoList>(
      {url: `/api/quality/production/v1/production-history/bales/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionHistoryBalesQueryKey = (params?: ApiQualityProductionV1ProductionHistoryBalesParams,) => {
    return [
    `/api/quality/production/v1/production-history/bales/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ProductionHistoryBalesQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProductionHistoryBalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionHistoryBalesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>> = ({ signal }) => apiQualityProductionV1ProductionHistoryBales(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionHistoryBalesQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>>
export type ApiQualityProductionV1ProductionHistoryBalesQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionHistoryBales<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProductionHistoryBalesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistoryBales<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryBalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistoryBales<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryBalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionHistoryBales<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryBalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionHistoryBalesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionHistoryBalesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProductionHistoryBalesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionHistoryBalesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>> = ({ signal }) => apiQualityProductionV1ProductionHistoryBales(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionHistoryBalesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>>
export type ApiQualityProductionV1ProductionHistoryBalesSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionHistoryBalesSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProductionHistoryBalesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistoryBalesSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryBalesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistoryBalesSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryBalesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionHistoryBalesSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryBalesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryBales>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionHistoryBalesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Weighted-average material composition for the history scope.
 *
 * Mirrors the window-scoped composition breakdown but scopes by the bales the
 * grid attributes to a line/range (or a single ``production_day``), so the drawer
 * can show the composition of exactly the material it lists.
 */
export const apiQualityProductionV1ProductionHistoryComposition = (
    params?: ApiQualityProductionV1ProductionHistoryCompositionParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessedCompositionBreakdown[]>(
      {url: `/api/quality/production/v1/production-history/composition/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionHistoryCompositionQueryKey = (params?: ApiQualityProductionV1ProductionHistoryCompositionParams,) => {
    return [
    `/api/quality/production/v1/production-history/composition/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ProductionHistoryCompositionQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProductionHistoryCompositionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionHistoryCompositionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>> = ({ signal }) => apiQualityProductionV1ProductionHistoryComposition(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionHistoryCompositionQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>>
export type ApiQualityProductionV1ProductionHistoryCompositionQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionHistoryComposition<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProductionHistoryCompositionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistoryComposition<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryCompositionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistoryComposition<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryCompositionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionHistoryComposition<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryCompositionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionHistoryCompositionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionHistoryCompositionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProductionHistoryCompositionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionHistoryCompositionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>> = ({ signal }) => apiQualityProductionV1ProductionHistoryComposition(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionHistoryCompositionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>>
export type ApiQualityProductionV1ProductionHistoryCompositionSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionHistoryCompositionSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProductionHistoryCompositionParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistoryCompositionSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryCompositionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionHistoryCompositionSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryCompositionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionHistoryCompositionSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionHistoryCompositionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionHistoryComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionHistoryCompositionSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProductionLinesList = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductionLineListResponse>(
      {url: `/api/quality/production/v1/production-lines/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionLinesListQueryKey = () => {
    return [
    `/api/quality/production/v1/production-lines/`
    ] as const;
    }


export const getApiQualityProductionV1ProductionLinesListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionLinesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>> = ({ signal }) => apiQualityProductionV1ProductionLinesList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionLinesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>>
export type ApiQualityProductionV1ProductionLinesListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionLinesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionLinesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionLinesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionLinesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionLinesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionLinesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionLinesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>> = ({ signal }) => apiQualityProductionV1ProductionLinesList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionLinesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>>
export type ApiQualityProductionV1ProductionLinesListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionLinesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionLinesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionLinesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionLinesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLinesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionLinesListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProductionLineCurrentShiftSummary = (
    lineId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CurrentShiftSummary>(
      {url: `/api/quality/production/v1/production-lines/${lineId}/current-shift-summary/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionLineCurrentShiftSummaryQueryKey = (lineId: number,) => {
    return [
    `/api/quality/production/v1/production-lines/${lineId}/current-shift-summary/`
    ] as const;
    }


export const getApiQualityProductionV1ProductionLineCurrentShiftSummaryQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(lineId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionLineCurrentShiftSummaryQueryKey(lineId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>> = ({ signal }) => apiQualityProductionV1ProductionLineCurrentShiftSummary(lineId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: lineId !== null && lineId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionLineCurrentShiftSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>>
export type ApiQualityProductionV1ProductionLineCurrentShiftSummaryQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionLineCurrentShiftSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(
 lineId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionLineCurrentShiftSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(
 lineId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionLineCurrentShiftSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(
 lineId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionLineCurrentShiftSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(
 lineId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionLineCurrentShiftSummaryQueryOptions(lineId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionLineCurrentShiftSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(lineId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionLineCurrentShiftSummaryQueryKey(lineId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>> = ({ signal }) => apiQualityProductionV1ProductionLineCurrentShiftSummary(lineId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionLineCurrentShiftSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>>
export type ApiQualityProductionV1ProductionLineCurrentShiftSummarySuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionLineCurrentShiftSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(
 lineId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionLineCurrentShiftSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(
 lineId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionLineCurrentShiftSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(
 lineId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionLineCurrentShiftSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError = ErrorType<ErrorResponse>>(
 lineId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionLineCurrentShiftSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionLineCurrentShiftSummarySuspenseQueryOptions(lineId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProductionShiftsList = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductionShiftListResponse>(
      {url: `/api/quality/production/v1/production-shifts/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionShiftsListQueryKey = () => {
    return [
    `/api/quality/production/v1/production-shifts/`
    ] as const;
    }


export const getApiQualityProductionV1ProductionShiftsListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionShiftsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>> = ({ signal }) => apiQualityProductionV1ProductionShiftsList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionShiftsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>>
export type ApiQualityProductionV1ProductionShiftsListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionShiftsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionShiftsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionShiftsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionShiftsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionShiftsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionShiftsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionShiftsListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>> = ({ signal }) => apiQualityProductionV1ProductionShiftsList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionShiftsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>>
export type ApiQualityProductionV1ProductionShiftsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionShiftsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionShiftsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionShiftsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionShiftsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionShiftsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionShiftsListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProductionWindowsList = (
    params?: ApiQualityProductionV1ProductionWindowsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ListResponse>(
      {url: `/api/quality/production/v1/production-windows/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionWindowsListQueryKey = (params?: ApiQualityProductionV1ProductionWindowsListParams,) => {
    return [
    `/api/quality/production/v1/production-windows/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ProductionWindowsListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProductionWindowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionWindowsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>> = ({ signal }) => apiQualityProductionV1ProductionWindowsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionWindowsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>>
export type ApiQualityProductionV1ProductionWindowsListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionWindowsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProductionWindowsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionWindowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionWindowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionWindowsList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionWindowsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionWindowsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionWindowsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ProductionWindowsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionWindowsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>> = ({ signal }) => apiQualityProductionV1ProductionWindowsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionWindowsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>>
export type ApiQualityProductionV1ProductionWindowsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionWindowsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ProductionWindowsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionWindowsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionWindowsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionWindowsListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ProductionWindowsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionWindowsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProductionWindowsCreate = (
    createRequest: BodyType<CreateRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductionWindowDetail>(
      {url: `/api/quality/production/v1/production-windows/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionWindowsCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCreate>>, TError,{data: BodyType<CreateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCreate>>, TError,{data: BodyType<CreateRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1ProductionWindowsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCreate>>, {data: BodyType<CreateRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityProductionV1ProductionWindowsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ProductionWindowsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCreate>>>
    export type ApiQualityProductionV1ProductionWindowsCreateMutationBody = BodyType<CreateRequest>
    export type ApiQualityProductionV1ProductionWindowsCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ProductionWindowsCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCreate>>, TError,{data: BodyType<CreateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCreate>>,
        TError,
        {data: BodyType<CreateRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ProductionWindowsCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ProductionWindowsPartialUpdate = (
    windowId: number,
    patchedUpdateRequest?: BodyType<PatchedUpdateRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductionWindowDetail>(
      {url: `/api/quality/production/v1/production-windows/${windowId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedUpdateRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionWindowsPartialUpdateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsPartialUpdate>>, TError,{windowId: number;data?: BodyType<PatchedUpdateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsPartialUpdate>>, TError,{windowId: number;data?: BodyType<PatchedUpdateRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1ProductionWindowsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsPartialUpdate>>, {windowId: number;data?: BodyType<PatchedUpdateRequest>}> = (props) => {
          const {windowId,data} = props ?? {};

          return  apiQualityProductionV1ProductionWindowsPartialUpdate(windowId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ProductionWindowsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsPartialUpdate>>>
    export type ApiQualityProductionV1ProductionWindowsPartialUpdateMutationBody = BodyType<PatchedUpdateRequest> | undefined
    export type ApiQualityProductionV1ProductionWindowsPartialUpdateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ProductionWindowsPartialUpdate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsPartialUpdate>>, TError,{windowId: number;data?: BodyType<PatchedUpdateRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsPartialUpdate>>,
        TError,
        {windowId: number;data?: BodyType<PatchedUpdateRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ProductionWindowsPartialUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ProductionWindowsCloseCreate = (
    windowId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProductionWindowDetail>(
      {url: `/api/quality/production/v1/production-windows/${windowId}/close/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionWindowsCloseCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCloseCreate>>, TError,{windowId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCloseCreate>>, TError,{windowId: number}, TContext> => {

const mutationKey = ['apiQualityProductionV1ProductionWindowsCloseCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCloseCreate>>, {windowId: number}> = (props) => {
          const {windowId} = props ?? {};

          return  apiQualityProductionV1ProductionWindowsCloseCreate(windowId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ProductionWindowsCloseCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCloseCreate>>>

    export type ApiQualityProductionV1ProductionWindowsCloseCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ProductionWindowsCloseCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCloseCreate>>, TError,{windowId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowsCloseCreate>>,
        TError,
        {windowId: number},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ProductionWindowsCloseCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ProductionWindowPickRecommendations = (
    windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PickRecommendationsResponse>(
      {url: `/api/quality/production/v1/production-windows/${windowId}/pick-recommendations/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionWindowPickRecommendationsQueryKey = (windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams,) => {
    return [
    `/api/quality/production/v1/production-windows/${windowId}/pick-recommendations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ProductionWindowPickRecommendationsQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionWindowPickRecommendationsQueryKey(windowId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>> = ({ signal }) => apiQualityProductionV1ProductionWindowPickRecommendations(windowId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: windowId !== null && windowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionWindowPickRecommendationsQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>>
export type ApiQualityProductionV1ProductionWindowPickRecommendationsQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionWindowPickRecommendations<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params: undefined |  ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowPickRecommendations<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowPickRecommendations<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionWindowPickRecommendations<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionWindowPickRecommendationsQueryOptions(windowId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionWindowPickRecommendationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionWindowPickRecommendationsQueryKey(windowId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>> = ({ signal }) => apiQualityProductionV1ProductionWindowPickRecommendations(windowId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionWindowPickRecommendationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>>
export type ApiQualityProductionV1ProductionWindowPickRecommendationsSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionWindowPickRecommendationsSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params: undefined |  ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowPickRecommendationsSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowPickRecommendationsSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionWindowPickRecommendationsSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowPickRecommendationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowPickRecommendations>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionWindowPickRecommendationsSuspenseQueryOptions(windowId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProductionWindowProcessedComposition = (
    windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessedCompositionBreakdown[]>(
      {url: `/api/quality/production/v1/production-windows/${windowId}/processed-composition/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionWindowProcessedCompositionQueryKey = (windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams,) => {
    return [
    `/api/quality/production/v1/production-windows/${windowId}/processed-composition/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ProductionWindowProcessedCompositionQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionWindowProcessedCompositionQueryKey(windowId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>> = ({ signal }) => apiQualityProductionV1ProductionWindowProcessedComposition(windowId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: windowId !== null && windowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionWindowProcessedCompositionQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>>
export type ApiQualityProductionV1ProductionWindowProcessedCompositionQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionWindowProcessedComposition<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params: undefined |  ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowProcessedComposition<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowProcessedComposition<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionWindowProcessedComposition<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionWindowProcessedCompositionQueryOptions(windowId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionWindowProcessedCompositionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionWindowProcessedCompositionQueryKey(windowId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>> = ({ signal }) => apiQualityProductionV1ProductionWindowProcessedComposition(windowId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionWindowProcessedCompositionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>>
export type ApiQualityProductionV1ProductionWindowProcessedCompositionSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionWindowProcessedCompositionSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params: undefined |  ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowProcessedCompositionSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowProcessedCompositionSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionWindowProcessedCompositionSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError = ErrorType<ErrorResponse>>(
 windowId: number,
    params?: ApiQualityProductionV1ProductionWindowProcessedCompositionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowProcessedComposition>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionWindowProcessedCompositionSuspenseQueryOptions(windowId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ProductionWindowSkippedPicksCreate = (
    windowId: number,
    recordSkippedPickRequest: BodyType<RecordSkippedPickRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RecordSkippedPickResponse>(
      {url: `/api/quality/production/v1/production-windows/${windowId}/skipped-picks/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recordSkippedPickRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionWindowSkippedPicksCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSkippedPicksCreate>>, TError,{windowId: number;data: BodyType<RecordSkippedPickRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSkippedPicksCreate>>, TError,{windowId: number;data: BodyType<RecordSkippedPickRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1ProductionWindowSkippedPicksCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSkippedPicksCreate>>, {windowId: number;data: BodyType<RecordSkippedPickRequest>}> = (props) => {
          const {windowId,data} = props ?? {};

          return  apiQualityProductionV1ProductionWindowSkippedPicksCreate(windowId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ProductionWindowSkippedPicksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSkippedPicksCreate>>>
    export type ApiQualityProductionV1ProductionWindowSkippedPicksCreateMutationBody = BodyType<RecordSkippedPickRequest>
    export type ApiQualityProductionV1ProductionWindowSkippedPicksCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ProductionWindowSkippedPicksCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSkippedPicksCreate>>, TError,{windowId: number;data: BodyType<RecordSkippedPickRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSkippedPicksCreate>>,
        TError,
        {windowId: number;data: BodyType<RecordSkippedPickRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ProductionWindowSkippedPicksCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ProductionWindowSummary = (
    windowId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessingSummary>(
      {url: `/api/quality/production/v1/production-windows/${windowId}/summary/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1ProductionWindowSummaryQueryKey = (windowId: number,) => {
    return [
    `/api/quality/production/v1/production-windows/${windowId}/summary/`
    ] as const;
    }


export const getApiQualityProductionV1ProductionWindowSummaryQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(windowId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionWindowSummaryQueryKey(windowId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>> = ({ signal }) => apiQualityProductionV1ProductionWindowSummary(windowId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: windowId !== null && windowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionWindowSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>>
export type ApiQualityProductionV1ProductionWindowSummaryQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionWindowSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(
 windowId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(
 windowId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(
 windowId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionWindowSummary<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(
 windowId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionWindowSummaryQueryOptions(windowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ProductionWindowSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(windowId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ProductionWindowSummaryQueryKey(windowId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>> = ({ signal }) => apiQualityProductionV1ProductionWindowSummary(windowId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ProductionWindowSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>>
export type ApiQualityProductionV1ProductionWindowSummarySuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ProductionWindowSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(
 windowId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(
 windowId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ProductionWindowSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(
 windowId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ProductionWindowSummarySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError = ErrorType<ErrorResponse>>(
 windowId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ProductionWindowSummary>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ProductionWindowSummarySuspenseQueryOptions(windowId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualityProductionV1RejectedBalesList = (
    params?: ApiQualityProductionV1RejectedBalesListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedRejectedBaleListItemList>(
      {url: `/api/quality/production/v1/rejected-bales/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1RejectedBalesListQueryKey = (params?: ApiQualityProductionV1RejectedBalesListParams,) => {
    return [
    `/api/quality/production/v1/rejected-bales/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1RejectedBalesListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1RejectedBalesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1RejectedBalesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>> = ({ signal }) => apiQualityProductionV1RejectedBalesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1RejectedBalesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>>
export type ApiQualityProductionV1RejectedBalesListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1RejectedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1RejectedBalesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1RejectedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1RejectedBalesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1RejectedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1RejectedBalesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1RejectedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1RejectedBalesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1RejectedBalesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1RejectedBalesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1RejectedBalesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1RejectedBalesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>> = ({ signal }) => apiQualityProductionV1RejectedBalesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1RejectedBalesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>>
export type ApiQualityProductionV1RejectedBalesListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1RejectedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1RejectedBalesListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1RejectedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1RejectedBalesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1RejectedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1RejectedBalesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1RejectedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1RejectedBalesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1RejectedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1RejectedBalesListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ScheduleRetrieve = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<_ShiftSchedule>(
      {url: `/api/quality/production/v1/schedule/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1ScheduleRetrieveQueryKey = () => {
    return [
    `/api/quality/production/v1/schedule/`
    ] as const;
    }


export const getApiQualityProductionV1ScheduleRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ScheduleRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>> = ({ signal }) => apiQualityProductionV1ScheduleRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ScheduleRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>>
export type ApiQualityProductionV1ScheduleRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ScheduleRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ScheduleRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ScheduleRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ScheduleRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ScheduleRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ScheduleRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ScheduleRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>> = ({ signal }) => apiQualityProductionV1ScheduleRetrieve(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ScheduleRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>>
export type ApiQualityProductionV1ScheduleRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ScheduleRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ScheduleRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ScheduleRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ScheduleRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ScheduleRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ScheduleRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Skipped pick recommendations grouped by production day and shift.
 *
 * Mirrors the processing-history endpoint: an optional ``[date_from, date_to]``
 * range (defaulted and capped identically) scopes the skips, which are then
 * bucketed into shift-anchored production days with a per-shift breakdown.
 */
export const apiQualityProductionV1SkippedPicksHistory = (
    params?: ApiQualityProductionV1SkippedPicksHistoryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SkippedPickHistory>(
      {url: `/api/quality/production/v1/skipped-picks/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1SkippedPicksHistoryQueryKey = (params?: ApiQualityProductionV1SkippedPicksHistoryParams,) => {
    return [
    `/api/quality/production/v1/skipped-picks/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1SkippedPicksHistoryQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1SkippedPicksHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1SkippedPicksHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>> = ({ signal }) => apiQualityProductionV1SkippedPicksHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1SkippedPicksHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>>
export type ApiQualityProductionV1SkippedPicksHistoryQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1SkippedPicksHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1SkippedPicksHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1SkippedPicksHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1SkippedPicksHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1SkippedPicksHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1SkippedPicksHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1SkippedPicksHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1SkippedPicksHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1SkippedPicksHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1SkippedPicksHistorySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1SkippedPicksHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1SkippedPicksHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>> = ({ signal }) => apiQualityProductionV1SkippedPicksHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1SkippedPicksHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>>
export type ApiQualityProductionV1SkippedPicksHistorySuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1SkippedPicksHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1SkippedPicksHistoryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1SkippedPicksHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1SkippedPicksHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1SkippedPicksHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1SkippedPicksHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1SkippedPicksHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1SkippedPicksHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1SkippedPicksHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1SkippedPicksHistorySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1StagedBalesList = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<StagedBaleListItem[]>(
      {url: `/api/quality/production/v1/staged-bales/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1StagedBalesListQueryKey = () => {
    return [
    `/api/quality/production/v1/staged-bales/`
    ] as const;
    }


export const getApiQualityProductionV1StagedBalesListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1StagedBalesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>> = ({ signal }) => apiQualityProductionV1StagedBalesList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1StagedBalesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>>
export type ApiQualityProductionV1StagedBalesListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1StagedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1StagedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1StagedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1StagedBalesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1StagedBalesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1StagedBalesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1StagedBalesListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>> = ({ signal }) => apiQualityProductionV1StagedBalesList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1StagedBalesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>>
export type ApiQualityProductionV1StagedBalesListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1StagedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1StagedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1StagedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1StagedBalesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1StagedBalesListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1StagedBalesProcessCreate = (
    stagedBaleId: number,
    processStagedBaleRequest?: BodyType<ProcessStagedBaleRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessStagedBaleResponse>(
      {url: `/api/quality/production/v1/staged-bales/${stagedBaleId}/process/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: processStagedBaleRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1StagedBalesProcessCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesProcessCreate>>, TError,{stagedBaleId: number;data?: BodyType<ProcessStagedBaleRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesProcessCreate>>, TError,{stagedBaleId: number;data?: BodyType<ProcessStagedBaleRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1StagedBalesProcessCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesProcessCreate>>, {stagedBaleId: number;data?: BodyType<ProcessStagedBaleRequest>}> = (props) => {
          const {stagedBaleId,data} = props ?? {};

          return  apiQualityProductionV1StagedBalesProcessCreate(stagedBaleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1StagedBalesProcessCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesProcessCreate>>>
    export type ApiQualityProductionV1StagedBalesProcessCreateMutationBody = BodyType<ProcessStagedBaleRequest> | undefined
    export type ApiQualityProductionV1StagedBalesProcessCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1StagedBalesProcessCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesProcessCreate>>, TError,{stagedBaleId: number;data?: BodyType<ProcessStagedBaleRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesProcessCreate>>,
        TError,
        {stagedBaleId: number;data?: BodyType<ProcessStagedBaleRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1StagedBalesProcessCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1StagedBalesRejectCreate = (
    stagedBaleId: number,
    rejectStagedBaleRequest: BodyType<RejectStagedBaleRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RejectStagedBaleResponse>(
      {url: `/api/quality/production/v1/staged-bales/${stagedBaleId}/reject/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectStagedBaleRequest, signal
    },
      options);
    }




export const getApiQualityProductionV1StagedBalesRejectCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesRejectCreate>>, TError,{stagedBaleId: number;data: BodyType<RejectStagedBaleRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesRejectCreate>>, TError,{stagedBaleId: number;data: BodyType<RejectStagedBaleRequest>}, TContext> => {

const mutationKey = ['apiQualityProductionV1StagedBalesRejectCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesRejectCreate>>, {stagedBaleId: number;data: BodyType<RejectStagedBaleRequest>}> = (props) => {
          const {stagedBaleId,data} = props ?? {};

          return  apiQualityProductionV1StagedBalesRejectCreate(stagedBaleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1StagedBalesRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesRejectCreate>>>
    export type ApiQualityProductionV1StagedBalesRejectCreateMutationBody = BodyType<RejectStagedBaleRequest>
    export type ApiQualityProductionV1StagedBalesRejectCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1StagedBalesRejectCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesRejectCreate>>, TError,{stagedBaleId: number;data: BodyType<RejectStagedBaleRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesRejectCreate>>,
        TError,
        {stagedBaleId: number;data: BodyType<RejectStagedBaleRequest>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1StagedBalesRejectCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1StagedBalesUnstageCreate = (
    stagedBaleId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/production/v1/staged-bales/${stagedBaleId}/unstage/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualityProductionV1StagedBalesUnstageCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesUnstageCreate>>, TError,{stagedBaleId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesUnstageCreate>>, TError,{stagedBaleId: number}, TContext> => {

const mutationKey = ['apiQualityProductionV1StagedBalesUnstageCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesUnstageCreate>>, {stagedBaleId: number}> = (props) => {
          const {stagedBaleId} = props ?? {};

          return  apiQualityProductionV1StagedBalesUnstageCreate(stagedBaleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1StagedBalesUnstageCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesUnstageCreate>>>

    export type ApiQualityProductionV1StagedBalesUnstageCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1StagedBalesUnstageCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesUnstageCreate>>, TError,{stagedBaleId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1StagedBalesUnstageCreate>>,
        TError,
        {stagedBaleId: number},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1StagedBalesUnstageCreateMutationOptions(options), queryClient);
    }
    /**
 * Storage-recommendation outcomes grouped by production day and adherence.
 *
 * Mirrors the skipped-picks history endpoint: an optional ``[date_from, date_to]``
 * range (defaulted and capped identically) scopes the outcomes, which are then
 * bucketed into shift-anchored production days with a per-adherence breakdown.
 */
export const apiQualityProductionV1StorageRecommendationOutcomesHistory = (
    params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<StorageRecommendationOutcomeHistory>(
      {url: `/api/quality/production/v1/storage-recommendation-outcomes/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1StorageRecommendationOutcomesHistoryQueryKey = (params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams,) => {
    return [
    `/api/quality/production/v1/storage-recommendation-outcomes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1StorageRecommendationOutcomesHistoryQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1StorageRecommendationOutcomesHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>> = ({ signal }) => apiQualityProductionV1StorageRecommendationOutcomesHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1StorageRecommendationOutcomesHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>>
export type ApiQualityProductionV1StorageRecommendationOutcomesHistoryQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1StorageRecommendationOutcomesHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1StorageRecommendationOutcomesHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1StorageRecommendationOutcomesHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1StorageRecommendationOutcomesHistory<TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1StorageRecommendationOutcomesHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1StorageRecommendationOutcomesHistorySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1StorageRecommendationOutcomesHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>> = ({ signal }) => apiQualityProductionV1StorageRecommendationOutcomesHistory(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1StorageRecommendationOutcomesHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>>
export type ApiQualityProductionV1StorageRecommendationOutcomesHistorySuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1StorageRecommendationOutcomesHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1StorageRecommendationOutcomesHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1StorageRecommendationOutcomesHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1StorageRecommendationOutcomesHistorySuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1StorageRecommendationOutcomesHistoryParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1StorageRecommendationOutcomesHistory>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1StorageRecommendationOutcomesHistorySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1WarehouseOverview = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<WarehouseOverviewResponse>(
      {url: `/api/quality/production/v1/warehouse/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1WarehouseOverviewQueryKey = () => {
    return [
    `/api/quality/production/v1/warehouse/`
    ] as const;
    }


export const getApiQualityProductionV1WarehouseOverviewQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1WarehouseOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>> = ({ signal }) => apiQualityProductionV1WarehouseOverview(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1WarehouseOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>>
export type ApiQualityProductionV1WarehouseOverviewQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1WarehouseOverview<TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1WarehouseOverview<TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1WarehouseOverview<TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1WarehouseOverview<TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1WarehouseOverviewQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1WarehouseOverviewSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1WarehouseOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>> = ({ signal }) => apiQualityProductionV1WarehouseOverview(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1WarehouseOverviewSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>>
export type ApiQualityProductionV1WarehouseOverviewSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1WarehouseOverviewSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1WarehouseOverviewSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1WarehouseOverviewSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1WarehouseOverviewSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1WarehouseOverview>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1WarehouseOverviewSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ZonesList = (
    params?: ApiQualityProductionV1ZonesListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ZoneListResponse>(
      {url: `/api/quality/production/v1/zones/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualityProductionV1ZonesListQueryKey = (params?: ApiQualityProductionV1ZonesListParams,) => {
    return [
    `/api/quality/production/v1/zones/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualityProductionV1ZonesListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ZonesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ZonesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>> = ({ signal }) => apiQualityProductionV1ZonesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ZonesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>>
export type ApiQualityProductionV1ZonesListQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ZonesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ZonesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ZonesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ZonesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ZonesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ZonesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ZonesList<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ZonesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ZonesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ZonesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualityProductionV1ZonesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ZonesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>> = ({ signal }) => apiQualityProductionV1ZonesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ZonesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>>
export type ApiQualityProductionV1ZonesListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ZonesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualityProductionV1ZonesListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ZonesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ZonesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ZonesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ZonesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ZonesListSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualityProductionV1ZonesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ZonesListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ZonesCreate = (
    zoneCreateDTO: BodyType<ZoneCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ZoneListItem>(
      {url: `/api/quality/production/v1/zones/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: zoneCreateDTO, signal
    },
      options);
    }




export const getApiQualityProductionV1ZonesCreateMutationOptions = <TError = ErrorType<ApiQualityProductionV1ZonesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesCreate>>, TError,{data: BodyType<ZoneCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesCreate>>, TError,{data: BodyType<ZoneCreateDTO>}, TContext> => {

const mutationKey = ['apiQualityProductionV1ZonesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ZonesCreate>>, {data: BodyType<ZoneCreateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualityProductionV1ZonesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ZonesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ZonesCreate>>>
    export type ApiQualityProductionV1ZonesCreateMutationBody = BodyType<ZoneCreateDTO>
    export type ApiQualityProductionV1ZonesCreateMutationError = ErrorType<ApiQualityProductionV1ZonesCreate400 | ErrorResponse>

    export const useApiQualityProductionV1ZonesCreate = <TError = ErrorType<ApiQualityProductionV1ZonesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesCreate>>, TError,{data: BodyType<ZoneCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ZonesCreate>>,
        TError,
        {data: BodyType<ZoneCreateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ZonesCreateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ZoneRetrieve = (
    zoneId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ZoneListItem>(
      {url: `/api/quality/production/v1/zones/${zoneId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualityProductionV1ZoneRetrieveQueryKey = (zoneId: number,) => {
    return [
    `/api/quality/production/v1/zones/${zoneId}/`
    ] as const;
    }


export const getApiQualityProductionV1ZoneRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ZoneRetrieveQueryKey(zoneId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>> = ({ signal }) => apiQualityProductionV1ZoneRetrieve(zoneId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: zoneId !== null && zoneId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ZoneRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>>
export type ApiQualityProductionV1ZoneRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ZoneRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(
 zoneId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ZoneRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ZoneRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ZoneRetrieve<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(
 zoneId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ZoneRetrieveQueryOptions(zoneId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualityProductionV1ZoneRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(zoneId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualityProductionV1ZoneRetrieveQueryKey(zoneId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>> = ({ signal }) => apiQualityProductionV1ZoneRetrieve(zoneId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualityProductionV1ZoneRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>>
export type ApiQualityProductionV1ZoneRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualityProductionV1ZoneRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(
 zoneId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ZoneRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(
 zoneId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualityProductionV1ZoneRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(
 zoneId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualityProductionV1ZoneRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError = ErrorType<ErrorResponse>>(
 zoneId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZoneRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualityProductionV1ZoneRetrieveSuspenseQueryOptions(zoneId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualityProductionV1ZonesPartialUpdate = (
    zoneId: number,
    patchedZoneUpdateDTO?: BodyType<PatchedZoneUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ZoneListItem>(
      {url: `/api/quality/production/v1/zones/${zoneId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedZoneUpdateDTO, signal
    },
      options);
    }




export const getApiQualityProductionV1ZonesPartialUpdateMutationOptions = <TError = ErrorType<ApiQualityProductionV1ZonesPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesPartialUpdate>>, TError,{zoneId: number;data?: BodyType<PatchedZoneUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesPartialUpdate>>, TError,{zoneId: number;data?: BodyType<PatchedZoneUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualityProductionV1ZonesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ZonesPartialUpdate>>, {zoneId: number;data?: BodyType<PatchedZoneUpdateDTO>}> = (props) => {
          const {zoneId,data} = props ?? {};

          return  apiQualityProductionV1ZonesPartialUpdate(zoneId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ZonesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ZonesPartialUpdate>>>
    export type ApiQualityProductionV1ZonesPartialUpdateMutationBody = BodyType<PatchedZoneUpdateDTO> | undefined
    export type ApiQualityProductionV1ZonesPartialUpdateMutationError = ErrorType<ApiQualityProductionV1ZonesPartialUpdate400 | ErrorResponse>

    export const useApiQualityProductionV1ZonesPartialUpdate = <TError = ErrorType<ApiQualityProductionV1ZonesPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesPartialUpdate>>, TError,{zoneId: number;data?: BodyType<PatchedZoneUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ZonesPartialUpdate>>,
        TError,
        {zoneId: number;data?: BodyType<PatchedZoneUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ZonesPartialUpdateMutationOptions(options), queryClient);
    }
    export const apiQualityProductionV1ZonesDestroy = (
    zoneId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/production/v1/zones/${zoneId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualityProductionV1ZonesDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesDestroy>>, TError,{zoneId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesDestroy>>, TError,{zoneId: number}, TContext> => {

const mutationKey = ['apiQualityProductionV1ZonesDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualityProductionV1ZonesDestroy>>, {zoneId: number}> = (props) => {
          const {zoneId} = props ?? {};

          return  apiQualityProductionV1ZonesDestroy(zoneId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualityProductionV1ZonesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualityProductionV1ZonesDestroy>>>

    export type ApiQualityProductionV1ZonesDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualityProductionV1ZonesDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualityProductionV1ZonesDestroy>>, TError,{zoneId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualityProductionV1ZonesDestroy>>,
        TError,
        {zoneId: number},
        TContext
      > => {
      return useMutation(getApiQualityProductionV1ZonesDestroyMutationOptions(options), queryClient);
    }
    export const apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate = (
    copyEvidenceToTestCompanyRequest: BodyType<CopyEvidenceToTestCompanyRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`csv_file`, copyEvidenceToTestCompanyRequest.csv_file);
if(copyEvidenceToTestCompanyRequest.override_existing_sessions !== undefined) {
 formData.append(`override_existing_sessions`, copyEvidenceToTestCompanyRequest.override_existing_sessions.toString())
 }

      return customAxios<StartCopyEvidenceToTestCompanyJobResponseDTO>(
      {url: `/api/quality/sessions/v1/start-copy-evidence-to-test-company-job/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreateMutationOptions = <TError = ErrorType<ApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate>>, TError,{data: BodyType<CopyEvidenceToTestCompanyRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate>>, TError,{data: BodyType<CopyEvidenceToTestCompanyRequest>}, TContext> => {

const mutationKey = ['apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate>>, {data: BodyType<CopyEvidenceToTestCompanyRequest>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate>>>
    export type ApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreateMutationBody = BodyType<CopyEvidenceToTestCompanyRequest>
    export type ApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreateMutationError = ErrorType<ApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate400 | ErrorResponse>

    export const useApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate = <TError = ErrorType<ApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate>>, TError,{data: BodyType<CopyEvidenceToTestCompanyRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreate>>,
        TError,
        {data: BodyType<CopyEvidenceToTestCompanyRequest>},
        TContext
      > => {
      return useMutation(getApiQualitySessionsV1StartCopyEvidenceToTestCompanyJobCreateMutationOptions(options), queryClient);
    }
    export const apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve = (
    tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<TradeCompanySessionCreatorsResponse>(
      {url: `/api/quality/sessions/v1/trade-companies/${tradeCompanyId}/session-creators/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveQueryKey = (tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams,) => {
    return [
    `/api/quality/sessions/v1/trade-companies/${tradeCompanyId}/session-creators/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>> = ({ signal }) => apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>>
export type ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveQueryOptions(tradeCompanyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>> = ({ signal }) => apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>>
export type ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySessionsV1TradeCompaniesSessionCreatorsRetrieveSuspenseQueryOptions(tradeCompanyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualitySessionsV1TradeCompanySessionsRetrieve = (
    tradeCompanySessionId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullTradeCompanySession>(
      {url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryKey = (tradeCompanySessionId: number,) => {
    return [
    `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/`
    ] as const;
    }


export const getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanySessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryKey(tradeCompanySessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>> = ({ signal }) => apiQualitySessionsV1TradeCompanySessionsRetrieve(tradeCompanySessionId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanySessionId !== null && tradeCompanySessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySessionsV1TradeCompanySessionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>>
export type ApiQualitySessionsV1TradeCompanySessionsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualitySessionsV1TradeCompanySessionsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV1TradeCompanySessionsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV1TradeCompanySessionsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySessionsV1TradeCompanySessionsRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryOptions(tradeCompanySessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualitySessionsV1TradeCompanySessionsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanySessionId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySessionsV1TradeCompanySessionsRetrieveQueryKey(tradeCompanySessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>> = ({ signal }) => apiQualitySessionsV1TradeCompanySessionsRetrieve(tradeCompanySessionId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySessionsV1TradeCompanySessionsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>>
export type ApiQualitySessionsV1TradeCompanySessionsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualitySessionsV1TradeCompanySessionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV1TradeCompanySessionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV1TradeCompanySessionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySessionsV1TradeCompanySessionsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySessionsV1TradeCompanySessionsRetrieveSuspenseQueryOptions(tradeCompanySessionId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualitySessionsV1TradeCompanySessionsPartialUpdate = (
    tradeCompanySessionId: number,
    patchedTradeCompanySessionUpdateDTO?: BodyType<PatchedTradeCompanySessionUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedTradeCompanySessionUpdateDTO, signal
    },
      options);
    }




export const getApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationOptions = <TError = ErrorType<ApiQualitySessionsV1TradeCompanySessionsPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>, TError,{tradeCompanySessionId: number;data?: BodyType<PatchedTradeCompanySessionUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>, TError,{tradeCompanySessionId: number;data?: BodyType<PatchedTradeCompanySessionUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualitySessionsV1TradeCompanySessionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>, {tradeCompanySessionId: number;data?: BodyType<PatchedTradeCompanySessionUpdateDTO>}> = (props) => {
          const {tradeCompanySessionId,data} = props ?? {};

          return  apiQualitySessionsV1TradeCompanySessionsPartialUpdate(tradeCompanySessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>>
    export type ApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationBody = BodyType<PatchedTradeCompanySessionUpdateDTO> | undefined
    export type ApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationError = ErrorType<ApiQualitySessionsV1TradeCompanySessionsPartialUpdate400 | ErrorResponse>

    export const useApiQualitySessionsV1TradeCompanySessionsPartialUpdate = <TError = ErrorType<ApiQualitySessionsV1TradeCompanySessionsPartialUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>, TError,{tradeCompanySessionId: number;data?: BodyType<PatchedTradeCompanySessionUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsPartialUpdate>>,
        TError,
        {tradeCompanySessionId: number;data?: BodyType<PatchedTradeCompanySessionUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualitySessionsV1TradeCompanySessionsPartialUpdateMutationOptions(options), queryClient);
    }
    export const apiQualitySessionsV1TradeCompanySessionsDestroy = (
    tradeCompanySessionId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualitySessionsV1TradeCompanySessionsDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>, TError,{tradeCompanySessionId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>, TError,{tradeCompanySessionId: number}, TContext> => {

const mutationKey = ['apiQualitySessionsV1TradeCompanySessionsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>, {tradeCompanySessionId: number}> = (props) => {
          const {tradeCompanySessionId} = props ?? {};

          return  apiQualitySessionsV1TradeCompanySessionsDestroy(tradeCompanySessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySessionsV1TradeCompanySessionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>>

    export type ApiQualitySessionsV1TradeCompanySessionsDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualitySessionsV1TradeCompanySessionsDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>, TError,{tradeCompanySessionId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsDestroy>>,
        TError,
        {tradeCompanySessionId: number},
        TContext
      > => {
      return useMutation(getApiQualitySessionsV1TradeCompanySessionsDestroyMutationOptions(options), queryClient);
    }
    export const apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate = (
    tradeCompanySessionId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GeneratePDFResponse>(
      {url: `/api/quality/sessions/v1/trade-company-sessions/${tradeCompanySessionId}/generate-pdf/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>, TError,{tradeCompanySessionId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>, TError,{tradeCompanySessionId: number}, TContext> => {

const mutationKey = ['apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>, {tradeCompanySessionId: number}> = (props) => {
          const {tradeCompanySessionId} = props ?? {};

          return  apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate(tradeCompanySessionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>>

    export type ApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>, TError,{tradeCompanySessionId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsGeneratePdfCreate>>,
        TError,
        {tradeCompanySessionId: number},
        TContext
      > => {
      return useMutation(getApiQualitySessionsV1TradeCompanySessionsGeneratePdfCreateMutationOptions(options), queryClient);
    }
    export const apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<UpdateDemoCompanyDataResponse>(
      {url: `/api/quality/sessions/v1/trade-company-sessions/update-demo-company-data/`, method: 'POST', signal
    },
      options);
    }




export const getApiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate>>, TError,void, TContext> => {

const mutationKey = ['apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate>>, void> = () => {


          return  apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate>>>

    export type ApiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreateMutationError = ErrorType<unknown>

    export const useApiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getApiQualitySessionsV1TradeCompanySessionsUpdateDemoCompanyDataCreateMutationOptions(options), queryClient);
    }
    /**
 * This will return either session's own evidence or its
 * sample's evidence if sample exists.
 */
export const apiQualitySessionsV2TradeCompanySessionEvidenceList = (
    tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedEvidenceList>(
      {url: `/api/quality/sessions/v2/trade-company-session/${tradeCompanySessionId}/evidence/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualitySessionsV2TradeCompanySessionEvidenceListQueryKey = (tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams,) => {
    return [
    `/api/quality/sessions/v2/trade-company-session/${tradeCompanySessionId}/evidence/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualitySessionsV2TradeCompanySessionEvidenceListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySessionsV2TradeCompanySessionEvidenceListQueryKey(tradeCompanySessionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>> = ({ signal }) => apiQualitySessionsV2TradeCompanySessionEvidenceList(tradeCompanySessionId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanySessionId !== null && tradeCompanySessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySessionsV2TradeCompanySessionEvidenceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>>
export type ApiQualitySessionsV2TradeCompanySessionEvidenceListQueryError = ErrorType<ErrorResponse>


export function useApiQualitySessionsV2TradeCompanySessionEvidenceList<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    params: undefined |  ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV2TradeCompanySessionEvidenceList<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV2TradeCompanySessionEvidenceList<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySessionsV2TradeCompanySessionEvidenceList<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySessionsV2TradeCompanySessionEvidenceListQueryOptions(tradeCompanySessionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualitySessionsV2TradeCompanySessionEvidenceListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySessionsV2TradeCompanySessionEvidenceListQueryKey(tradeCompanySessionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>> = ({ signal }) => apiQualitySessionsV2TradeCompanySessionEvidenceList(tradeCompanySessionId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySessionsV2TradeCompanySessionEvidenceListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>>
export type ApiQualitySessionsV2TradeCompanySessionEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualitySessionsV2TradeCompanySessionEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    params: undefined |  ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV2TradeCompanySessionEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV2TradeCompanySessionEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySessionsV2TradeCompanySessionEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    params?: ApiQualitySessionsV2TradeCompanySessionEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySessionsV2TradeCompanySessionEvidenceListSuspenseQueryOptions(tradeCompanySessionId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * This will return either session's own evidence or its
 * sample's evidence if sample exists.
 */
export const apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve = (
    tradeCompanySessionId: number,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Evidence>(
      {url: `/api/quality/sessions/v2/trade-company-session/${tradeCompanySessionId}/evidence/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveQueryKey = (tradeCompanySessionId: number,
    id: number,) => {
    return [
    `/api/quality/sessions/v2/trade-company-session/${tradeCompanySessionId}/evidence/${id}/`
    ] as const;
    }


export const getApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanySessionId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveQueryKey(tradeCompanySessionId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>> = ({ signal }) => apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve(tradeCompanySessionId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanySessionId !== null && tradeCompanySessionId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>>
export type ApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualitySessionsV2TradeCompanySessionEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV2TradeCompanySessionEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV2TradeCompanySessionEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySessionsV2TradeCompanySessionEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveQueryOptions(tradeCompanySessionId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanySessionId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveQueryKey(tradeCompanySessionId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>> = ({ signal }) => apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve(tradeCompanySessionId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>>
export type ApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanySessionId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySessionsV2TradeCompanySessionEvidenceRetrieveSuspenseQueryOptions(tradeCompanySessionId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * This will return either session's own evidence or its
 * sample's evidence if sample exists.
 */
export const apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate = (
    tradeCompanySessionId: number,
    bulkDeleteRequest: BodyType<BulkDeleteRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/sessions/v2/trade-company-session/${tradeCompanySessionId}/evidence/bulk-delete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteRequest, signal
    },
      options);
    }




export const getApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreateMutationOptions = <TError = ErrorType<ApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate>>, TError,{tradeCompanySessionId: number;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate>>, TError,{tradeCompanySessionId: number;data: BodyType<BulkDeleteRequest>}, TContext> => {

const mutationKey = ['apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate>>, {tradeCompanySessionId: number;data: BodyType<BulkDeleteRequest>}> = (props) => {
          const {tradeCompanySessionId,data} = props ?? {};

          return  apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate(tradeCompanySessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate>>>
    export type ApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreateMutationBody = BodyType<BulkDeleteRequest>
    export type ApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreateMutationError = ErrorType<ApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate400 | ErrorResponse>

    export const useApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate = <TError = ErrorType<ApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate>>, TError,{tradeCompanySessionId: number;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreate>>,
        TError,
        {tradeCompanySessionId: number;data: BodyType<BulkDeleteRequest>},
        TContext
      > => {
      return useMutation(getApiQualitySessionsV2TradeCompanySessionEvidenceBulkDeleteCreateMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for large files.
 */
export const apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate = (
    tradeCompanySessionId: number,
    generateUploadUrlRequest: BodyType<GenerateUploadUrlRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GenerateUploadUrlResponse>(
      {url: `/api/quality/sessions/v2/trade-company-sessions/${tradeCompanySessionId}/evidence/upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateUploadUrlRequest, signal
    },
      options);
    }




export const getApiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate>>, TError,{tradeCompanySessionId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate>>, TError,{tradeCompanySessionId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext> => {

const mutationKey = ['apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate>>, {tradeCompanySessionId: number;data: BodyType<GenerateUploadUrlRequest>}> = (props) => {
          const {tradeCompanySessionId,data} = props ?? {};

          return  apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate(tradeCompanySessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate>>>
    export type ApiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreateMutationBody = BodyType<GenerateUploadUrlRequest>
    export type ApiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreateMutationError = ErrorType<ErrorResponse>

    export const useApiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate>>, TError,{tradeCompanySessionId: number;data: BodyType<GenerateUploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreate>>,
        TError,
        {tradeCompanySessionId: number;data: BodyType<GenerateUploadUrlRequest>},
        TContext
      > => {
      return useMutation(getApiQualitySessionsV2TradeCompanySessionsEvidenceUploadCreateMutationOptions(options), queryClient);
    }
    /**
 * Saves evidence as bale photo and returns inference results.
 */
export const apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate = (
    tradeCompanySessionId: number,
    processUploadRequest: BodyType<ProcessUploadRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ProcessUploadResponse>(
      {url: `/api/quality/sessions/v2/trade-company-sessions/${tradeCompanySessionId}/evidence/upload`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: processUploadRequest, signal
    },
      options);
    }




export const getApiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate>>, TError,{tradeCompanySessionId: number;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate>>, TError,{tradeCompanySessionId: number;data: BodyType<ProcessUploadRequest>}, TContext> => {

const mutationKey = ['apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate>>, {tradeCompanySessionId: number;data: BodyType<ProcessUploadRequest>}> = (props) => {
          const {tradeCompanySessionId,data} = props ?? {};

          return  apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate(tradeCompanySessionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate>>>
    export type ApiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdateMutationBody = BodyType<ProcessUploadRequest>
    export type ApiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdateMutationError = ErrorType<unknown>

    export const useApiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate>>, TError,{tradeCompanySessionId: number;data: BodyType<ProcessUploadRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdate>>,
        TError,
        {tradeCompanySessionId: number;data: BodyType<ProcessUploadRequest>},
        TContext
      > => {
      return useMutation(getApiQualitySessionsV2TradeCompanySessionsEvidenceUploadUpdateMutationOptions(options), queryClient);
    }
    /**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualitySuppliersV1SuppliersList = (
    params?: ApiQualitySuppliersV1SuppliersListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedSupplierListItemList>(
      {url: `/api/quality/suppliers/v1/suppliers/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiQualitySuppliersV1SuppliersListQueryKey = (params?: ApiQualitySuppliersV1SuppliersListParams,) => {
    return [
    `/api/quality/suppliers/v1/suppliers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiQualitySuppliersV1SuppliersListQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualitySuppliersV1SuppliersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySuppliersV1SuppliersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>> = ({ signal }) => apiQualitySuppliersV1SuppliersList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySuppliersV1SuppliersListQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>>
export type ApiQualitySuppliersV1SuppliersListQueryError = ErrorType<ErrorResponse>


export function useApiQualitySuppliersV1SuppliersList<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualitySuppliersV1SuppliersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySuppliersV1SuppliersList<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualitySuppliersV1SuppliersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySuppliersV1SuppliersList<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualitySuppliersV1SuppliersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySuppliersV1SuppliersList<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualitySuppliersV1SuppliersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySuppliersV1SuppliersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualitySuppliersV1SuppliersListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(params?: ApiQualitySuppliersV1SuppliersListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySuppliersV1SuppliersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>> = ({ signal }) => apiQualitySuppliersV1SuppliersList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySuppliersV1SuppliersListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>>
export type ApiQualitySuppliersV1SuppliersListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualitySuppliersV1SuppliersListSuspense<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiQualitySuppliersV1SuppliersListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySuppliersV1SuppliersListSuspense<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualitySuppliersV1SuppliersListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySuppliersV1SuppliersListSuspense<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualitySuppliersV1SuppliersListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySuppliersV1SuppliersListSuspense<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiQualitySuppliersV1SuppliersListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySuppliersV1SuppliersListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiQualitySuppliersV1SuppliersCreate = (
    supplierCreateDTO: BodyType<SupplierCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SupplierCreateResponse>(
      {url: `/api/quality/suppliers/v1/suppliers/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: supplierCreateDTO, signal
    },
      options);
    }




export const getApiQualitySuppliersV1SuppliersCreateMutationOptions = <TError = ErrorType<ApiQualitySuppliersV1SuppliersCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersCreate>>, TError,{data: BodyType<SupplierCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersCreate>>, TError,{data: BodyType<SupplierCreateDTO>}, TContext> => {

const mutationKey = ['apiQualitySuppliersV1SuppliersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersCreate>>, {data: BodyType<SupplierCreateDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiQualitySuppliersV1SuppliersCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySuppliersV1SuppliersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersCreate>>>
    export type ApiQualitySuppliersV1SuppliersCreateMutationBody = BodyType<SupplierCreateDTO>
    export type ApiQualitySuppliersV1SuppliersCreateMutationError = ErrorType<ApiQualitySuppliersV1SuppliersCreate400 | ErrorResponse>

    export const useApiQualitySuppliersV1SuppliersCreate = <TError = ErrorType<ApiQualitySuppliersV1SuppliersCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersCreate>>, TError,{data: BodyType<SupplierCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersCreate>>,
        TError,
        {data: BodyType<SupplierCreateDTO>},
        TContext
      > => {
      return useMutation(getApiQualitySuppliersV1SuppliersCreateMutationOptions(options), queryClient);
    }
    export const apiQualitySuppliersV1SupplierRetrieve = (
    supplierId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SupplierListItem>(
      {url: `/api/quality/suppliers/v1/suppliers/${supplierId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiQualitySuppliersV1SupplierRetrieveQueryKey = (supplierId: number,) => {
    return [
    `/api/quality/suppliers/v1/suppliers/${supplierId}/`
    ] as const;
    }


export const getApiQualitySuppliersV1SupplierRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(supplierId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySuppliersV1SupplierRetrieveQueryKey(supplierId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>> = ({ signal }) => apiQualitySuppliersV1SupplierRetrieve(supplierId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: supplierId !== null && supplierId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySuppliersV1SupplierRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>>
export type ApiQualitySuppliersV1SupplierRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiQualitySuppliersV1SupplierRetrieve<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySuppliersV1SupplierRetrieve<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySuppliersV1SupplierRetrieve<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySuppliersV1SupplierRetrieve<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySuppliersV1SupplierRetrieveQueryOptions(supplierId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiQualitySuppliersV1SupplierRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(supplierId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiQualitySuppliersV1SupplierRetrieveQueryKey(supplierId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>> = ({ signal }) => apiQualitySuppliersV1SupplierRetrieve(supplierId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiQualitySuppliersV1SupplierRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>>
export type ApiQualitySuppliersV1SupplierRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiQualitySuppliersV1SupplierRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySuppliersV1SupplierRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiQualitySuppliersV1SupplierRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiQualitySuppliersV1SupplierRetrieveSuspense<TData = Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError = ErrorType<ErrorResponse>>(
 supplierId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SupplierRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiQualitySuppliersV1SupplierRetrieveSuspenseQueryOptions(supplierId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiQualitySuppliersV1SuppliersUpdate = (
    supplierId: number,
    supplierUpdateDTO?: BodyType<SupplierUpdateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SupplierListItem>(
      {url: `/api/quality/suppliers/v1/suppliers/${supplierId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: supplierUpdateDTO, signal
    },
      options);
    }




export const getApiQualitySuppliersV1SuppliersUpdateMutationOptions = <TError = ErrorType<ApiQualitySuppliersV1SuppliersUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersUpdate>>, TError,{supplierId: number;data?: BodyType<SupplierUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersUpdate>>, TError,{supplierId: number;data?: BodyType<SupplierUpdateDTO>}, TContext> => {

const mutationKey = ['apiQualitySuppliersV1SuppliersUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersUpdate>>, {supplierId: number;data?: BodyType<SupplierUpdateDTO>}> = (props) => {
          const {supplierId,data} = props ?? {};

          return  apiQualitySuppliersV1SuppliersUpdate(supplierId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySuppliersV1SuppliersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersUpdate>>>
    export type ApiQualitySuppliersV1SuppliersUpdateMutationBody = BodyType<SupplierUpdateDTO> | undefined
    export type ApiQualitySuppliersV1SuppliersUpdateMutationError = ErrorType<ApiQualitySuppliersV1SuppliersUpdate400 | ErrorResponse>

    export const useApiQualitySuppliersV1SuppliersUpdate = <TError = ErrorType<ApiQualitySuppliersV1SuppliersUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersUpdate>>, TError,{supplierId: number;data?: BodyType<SupplierUpdateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersUpdate>>,
        TError,
        {supplierId: number;data?: BodyType<SupplierUpdateDTO>},
        TContext
      > => {
      return useMutation(getApiQualitySuppliersV1SuppliersUpdateMutationOptions(options), queryClient);
    }
    export const apiQualitySuppliersV1SuppliersDestroy = (
    supplierId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/quality/suppliers/v1/suppliers/${supplierId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiQualitySuppliersV1SuppliersDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersDestroy>>, TError,{supplierId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersDestroy>>, TError,{supplierId: number}, TContext> => {

const mutationKey = ['apiQualitySuppliersV1SuppliersDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersDestroy>>, {supplierId: number}> = (props) => {
          const {supplierId} = props ?? {};

          return  apiQualitySuppliersV1SuppliersDestroy(supplierId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiQualitySuppliersV1SuppliersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersDestroy>>>

    export type ApiQualitySuppliersV1SuppliersDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiQualitySuppliersV1SuppliersDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersDestroy>>, TError,{supplierId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiQualitySuppliersV1SuppliersDestroy>>,
        TError,
        {supplierId: number},
        TContext
      > => {
      return useMutation(getApiQualitySuppliersV1SuppliersDestroyMutationOptions(options), queryClient);
    }
    export const apiSpecificationsV1SiteMaterialSpecificationsEvidenceList = (
    objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedEvidenceList>(
      {url: `/api/specifications/v1/site-material-specifications/${objectId}/evidence/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryKey = (objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams,) => {
    return [
    `/api/specifications/v1/site-material-specifications/${objectId}/evidence/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryOptions = <TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryKey(objectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>> = ({ signal }) => apiSpecificationsV1SiteMaterialSpecificationsEvidenceList(objectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: objectId !== null && objectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryResult = NonNullable<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>>
export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryError = ErrorType<ErrorResponse>


export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceList<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    params: undefined |  ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceList<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>,
          TError,
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceList<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceList<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryOptions(objectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListQueryKey(objectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>> = ({ signal }) => apiSpecificationsV1SiteMaterialSpecificationsEvidenceList(objectId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>>
export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    params: undefined |  ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspense<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    params?: ApiSpecificationsV1SiteMaterialSpecificationsEvidenceListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiSpecificationsV1SiteMaterialSpecificationsEvidenceListSuspenseQueryOptions(objectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve = (
    objectId: number,
    id: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Evidence>(
      {url: `/api/specifications/v1/site-material-specifications/${objectId}/evidence/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryKey = (objectId: number,
    id: number,) => {
    return [
    `/api/specifications/v1/site-material-specifications/${objectId}/evidence/${id}/`
    ] as const;
    }


export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(objectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryKey(objectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>> = ({ signal }) => apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve(objectId,id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: objectId !== null && objectId !== undefined && id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>>
export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryOptions(objectId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(objectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveQueryKey(objectId,id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>> = ({ signal }) => apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve(objectId,id, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>>
export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspense<TData = Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError = ErrorType<ErrorResponse>>(
 objectId: number,
    id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiSpecificationsV1SiteMaterialSpecificationsEvidenceRetrieveSuspenseQueryOptions(objectId,id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate = (
    objectId: number,
    bulkDeleteRequest: BodyType<BulkDeleteRequest>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/specifications/v1/site-material-specifications/${objectId}/evidence/bulk-delete/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkDeleteRequest, signal
    },
      options);
    }




export const getApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreateMutationOptions = <TError = ErrorType<ApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate>>, TError,{objectId: number;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate>>, TError,{objectId: number;data: BodyType<BulkDeleteRequest>}, TContext> => {

const mutationKey = ['apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate>>, {objectId: number;data: BodyType<BulkDeleteRequest>}> = (props) => {
          const {objectId,data} = props ?? {};

          return  apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate(objectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate>>>
    export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreateMutationBody = BodyType<BulkDeleteRequest>
    export type ApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreateMutationError = ErrorType<ApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate400 | ErrorResponse>

    export const useApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate = <TError = ErrorType<ApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate>>, TError,{objectId: number;data: BodyType<BulkDeleteRequest>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreate>>,
        TError,
        {objectId: number;data: BodyType<BulkDeleteRequest>},
        TContext
      > => {
      return useMutation(getApiSpecificationsV1SiteMaterialSpecificationsEvidenceBulkDeleteCreateMutationOptions(options), queryClient);
    }
    /**
 * Verify that the current user is authenticated.
 */
export const apiSupportV1TicketCreate = (
    createSupportTicket: BodyType<CreateSupportTicket>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Ticket>(
      {url: `/api/support/v1/ticket/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSupportTicket, signal
    },
      options);
    }




export const getApiSupportV1TicketCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSupportV1TicketCreate>>, TError,{data: BodyType<CreateSupportTicket>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiSupportV1TicketCreate>>, TError,{data: BodyType<CreateSupportTicket>}, TContext> => {

const mutationKey = ['apiSupportV1TicketCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiSupportV1TicketCreate>>, {data: BodyType<CreateSupportTicket>}> = (props) => {
          const {data} = props ?? {};

          return  apiSupportV1TicketCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiSupportV1TicketCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiSupportV1TicketCreate>>>
    export type ApiSupportV1TicketCreateMutationBody = BodyType<CreateSupportTicket>
    export type ApiSupportV1TicketCreateMutationError = ErrorType<unknown>

    export const useApiSupportV1TicketCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiSupportV1TicketCreate>>, TError,{data: BodyType<CreateSupportTicket>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiSupportV1TicketCreate>>,
        TError,
        {data: BodyType<CreateSupportTicket>},
        TContext
      > => {
      return useMutation(getApiSupportV1TicketCreateMutationOptions(options), queryClient);
    }
    /**
 * Verify that the current user is authenticated.
 */
export const apiTicketsV1FindList = (
    params?: ApiTicketsV1FindListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedGetTicketsOutputList>(
      {url: `/api/tickets/v1/find/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTicketsV1FindListQueryKey = (params?: ApiTicketsV1FindListParams,) => {
    return [
    `/api/tickets/v1/find/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTicketsV1FindListQueryOptions = <TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(params?: ApiTicketsV1FindListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTicketsV1FindListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTicketsV1FindList>>> = ({ signal }) => apiTicketsV1FindList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTicketsV1FindListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTicketsV1FindList>>>
export type ApiTicketsV1FindListQueryError = ErrorType<ErrorResponse>


export function useApiTicketsV1FindList<TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiTicketsV1FindListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTicketsV1FindList>>,
          TError,
          Awaited<ReturnType<typeof apiTicketsV1FindList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTicketsV1FindList<TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTicketsV1FindListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTicketsV1FindList>>,
          TError,
          Awaited<ReturnType<typeof apiTicketsV1FindList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTicketsV1FindList<TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTicketsV1FindListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTicketsV1FindList<TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTicketsV1FindListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTicketsV1FindListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTicketsV1FindListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(params?: ApiTicketsV1FindListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTicketsV1FindListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTicketsV1FindList>>> = ({ signal }) => apiTicketsV1FindList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTicketsV1FindListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTicketsV1FindList>>>
export type ApiTicketsV1FindListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTicketsV1FindListSuspense<TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiTicketsV1FindListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTicketsV1FindListSuspense<TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTicketsV1FindListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTicketsV1FindListSuspense<TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTicketsV1FindListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTicketsV1FindListSuspense<TData = Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTicketsV1FindListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTicketsV1FindList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTicketsV1FindListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1BuyerMaterialSpecificationsCreate = (
    upsertBuyerMaterialSpecification: BodyType<UpsertBuyerMaterialSpecification>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CreateBuyerMaterialSpecificationResponse>(
      {url: `/api/trade/v1/buyer-material-specifications/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertBuyerMaterialSpecification, signal
    },
      options);
    }




export const getApiTradeV1BuyerMaterialSpecificationsCreateMutationOptions = <TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>, TError,{data: BodyType<UpsertBuyerMaterialSpecification>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>, TError,{data: BodyType<UpsertBuyerMaterialSpecification>}, TContext> => {

const mutationKey = ['apiTradeV1BuyerMaterialSpecificationsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>, {data: BodyType<UpsertBuyerMaterialSpecification>}> = (props) => {
          const {data} = props ?? {};

          return  apiTradeV1BuyerMaterialSpecificationsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1BuyerMaterialSpecificationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>>
    export type ApiTradeV1BuyerMaterialSpecificationsCreateMutationBody = BodyType<UpsertBuyerMaterialSpecification>
    export type ApiTradeV1BuyerMaterialSpecificationsCreateMutationError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsCreate400 | ErrorResponse>

    export const useApiTradeV1BuyerMaterialSpecificationsCreate = <TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>, TError,{data: BodyType<UpsertBuyerMaterialSpecification>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsCreate>>,
        TError,
        {data: BodyType<UpsertBuyerMaterialSpecification>},
        TContext
      > => {
      return useMutation(getApiTradeV1BuyerMaterialSpecificationsCreateMutationOptions(options), queryClient);
    }
    export const apiTradeV1BuyerMaterialSpecificationsRetrieve = (
    buyerMaterialSpecificationId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullBuyerMaterialSpecification>(
      {url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryKey = (buyerMaterialSpecificationId: number,) => {
    return [
    `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/`
    ] as const;
    }


export const getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(buyerMaterialSpecificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryKey(buyerMaterialSpecificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>> = ({ signal }) => apiTradeV1BuyerMaterialSpecificationsRetrieve(buyerMaterialSpecificationId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: buyerMaterialSpecificationId !== null && buyerMaterialSpecificationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1BuyerMaterialSpecificationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>>
export type ApiTradeV1BuyerMaterialSpecificationsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1BuyerMaterialSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerMaterialSpecificationId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1BuyerMaterialSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerMaterialSpecificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1BuyerMaterialSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerMaterialSpecificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1BuyerMaterialSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerMaterialSpecificationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryOptions(buyerMaterialSpecificationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1BuyerMaterialSpecificationsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(buyerMaterialSpecificationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1BuyerMaterialSpecificationsRetrieveQueryKey(buyerMaterialSpecificationId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>> = ({ signal }) => apiTradeV1BuyerMaterialSpecificationsRetrieve(buyerMaterialSpecificationId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1BuyerMaterialSpecificationsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>>
export type ApiTradeV1BuyerMaterialSpecificationsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerMaterialSpecificationId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerMaterialSpecificationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerMaterialSpecificationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 buyerMaterialSpecificationId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1BuyerMaterialSpecificationsRetrieveSuspenseQueryOptions(buyerMaterialSpecificationId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1BuyerMaterialSpecificationsUpdate = (
    buyerMaterialSpecificationId: number,
    upsertBuyerMaterialSpecification: BodyType<UpsertBuyerMaterialSpecification>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertBuyerMaterialSpecification, signal
    },
      options);
    }




export const getApiTradeV1BuyerMaterialSpecificationsUpdateMutationOptions = <TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<UpsertBuyerMaterialSpecification>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<UpsertBuyerMaterialSpecification>}, TContext> => {

const mutationKey = ['apiTradeV1BuyerMaterialSpecificationsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>, {buyerMaterialSpecificationId: number;data: BodyType<UpsertBuyerMaterialSpecification>}> = (props) => {
          const {buyerMaterialSpecificationId,data} = props ?? {};

          return  apiTradeV1BuyerMaterialSpecificationsUpdate(buyerMaterialSpecificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1BuyerMaterialSpecificationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>>
    export type ApiTradeV1BuyerMaterialSpecificationsUpdateMutationBody = BodyType<UpsertBuyerMaterialSpecification>
    export type ApiTradeV1BuyerMaterialSpecificationsUpdateMutationError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsUpdate400 | ErrorResponse>

    export const useApiTradeV1BuyerMaterialSpecificationsUpdate = <TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<UpsertBuyerMaterialSpecification>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsUpdate>>,
        TError,
        {buyerMaterialSpecificationId: number;data: BodyType<UpsertBuyerMaterialSpecification>},
        TContext
      > => {
      return useMutation(getApiTradeV1BuyerMaterialSpecificationsUpdateMutationOptions(options), queryClient);
    }
    export const apiTradeV1BuyerMaterialSpecificationsDestroy = (
    buyerMaterialSpecificationId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiTradeV1BuyerMaterialSpecificationsDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>, TError,{buyerMaterialSpecificationId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>, TError,{buyerMaterialSpecificationId: number}, TContext> => {

const mutationKey = ['apiTradeV1BuyerMaterialSpecificationsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>, {buyerMaterialSpecificationId: number}> = (props) => {
          const {buyerMaterialSpecificationId} = props ?? {};

          return  apiTradeV1BuyerMaterialSpecificationsDestroy(buyerMaterialSpecificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1BuyerMaterialSpecificationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>>

    export type ApiTradeV1BuyerMaterialSpecificationsDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiTradeV1BuyerMaterialSpecificationsDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>, TError,{buyerMaterialSpecificationId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDestroy>>,
        TError,
        {buyerMaterialSpecificationId: number},
        TContext
      > => {
      return useMutation(getApiTradeV1BuyerMaterialSpecificationsDestroyMutationOptions(options), queryClient);
    }
    /**
 * Generate an upload URL for documents.
 */
export const apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate = (
    buyerMaterialSpecificationId: number,
    documentPreSignedURLInput: BodyType<DocumentPreSignedURLInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DocumentPreSignedURLOutput>(
      {url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/documents/pre-signed-url/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentPreSignedURLInput, signal
    },
      options);
    }




export const getApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<DocumentPreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<DocumentPreSignedURLInput>}, TContext> => {

const mutationKey = ['apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>, {buyerMaterialSpecificationId: number;data: BodyType<DocumentPreSignedURLInput>}> = (props) => {
          const {buyerMaterialSpecificationId,data} = props ?? {};

          return  apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate(buyerMaterialSpecificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>>
    export type ApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationBody = BodyType<DocumentPreSignedURLInput>
    export type ApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationError = ErrorType<ErrorResponse>

    export const useApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<DocumentPreSignedURLInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate>>,
        TError,
        {buyerMaterialSpecificationId: number;data: BodyType<DocumentPreSignedURLInput>},
        TContext
      > => {
      return useMutation(getApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreateMutationOptions(options), queryClient);
    }
    export const apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate = (
    buyerMaterialSpecificationId: number,
    input: BodyType<Input>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/trade/v1/buyer-material-specifications/${buyerMaterialSpecificationId}/documents/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: input, signal
    },
      options);
    }




export const getApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationOptions = <TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<Input>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<Input>}, TContext> => {

const mutationKey = ['apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>, {buyerMaterialSpecificationId: number;data: BodyType<Input>}> = (props) => {
          const {buyerMaterialSpecificationId,data} = props ?? {};

          return  apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate(buyerMaterialSpecificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>>
    export type ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationBody = BodyType<Input>
    export type ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate400 | ErrorResponse>

    export const useApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate = <TError = ErrorType<ApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>, TError,{buyerMaterialSpecificationId: number;data: BodyType<Input>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate>>,
        TError,
        {buyerMaterialSpecificationId: number;data: BodyType<Input>},
        TContext
      > => {
      return useMutation(getApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreateMutationOptions(options), queryClient);
    }
    export const apiTradeV1PackagingSpecificationsUpdate = (
    packagingSpecificationId: number,
    updatePackagingSpecificationDTO: BodyType<UpdatePackagingSpecificationDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/trade/v1/packaging-specifications/${packagingSpecificationId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePackagingSpecificationDTO, signal
    },
      options);
    }




export const getApiTradeV1PackagingSpecificationsUpdateMutationOptions = <TError = ErrorType<ApiTradeV1PackagingSpecificationsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>, TError,{packagingSpecificationId: number;data: BodyType<UpdatePackagingSpecificationDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>, TError,{packagingSpecificationId: number;data: BodyType<UpdatePackagingSpecificationDTO>}, TContext> => {

const mutationKey = ['apiTradeV1PackagingSpecificationsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>, {packagingSpecificationId: number;data: BodyType<UpdatePackagingSpecificationDTO>}> = (props) => {
          const {packagingSpecificationId,data} = props ?? {};

          return  apiTradeV1PackagingSpecificationsUpdate(packagingSpecificationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1PackagingSpecificationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>>
    export type ApiTradeV1PackagingSpecificationsUpdateMutationBody = BodyType<UpdatePackagingSpecificationDTO>
    export type ApiTradeV1PackagingSpecificationsUpdateMutationError = ErrorType<ApiTradeV1PackagingSpecificationsUpdate400 | ErrorResponse>

    export const useApiTradeV1PackagingSpecificationsUpdate = <TError = ErrorType<ApiTradeV1PackagingSpecificationsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>, TError,{packagingSpecificationId: number;data: BodyType<UpdatePackagingSpecificationDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsUpdate>>,
        TError,
        {packagingSpecificationId: number;data: BodyType<UpdatePackagingSpecificationDTO>},
        TContext
      > => {
      return useMutation(getApiTradeV1PackagingSpecificationsUpdateMutationOptions(options), queryClient);
    }
    export const apiTradeV1PackagingSpecificationsDestroy = (
    packagingSpecificationId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/trade/v1/packaging-specifications/${packagingSpecificationId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getApiTradeV1PackagingSpecificationsDestroyMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>, TError,{packagingSpecificationId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>, TError,{packagingSpecificationId: number}, TContext> => {

const mutationKey = ['apiTradeV1PackagingSpecificationsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>, {packagingSpecificationId: number}> = (props) => {
          const {packagingSpecificationId} = props ?? {};

          return  apiTradeV1PackagingSpecificationsDestroy(packagingSpecificationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1PackagingSpecificationsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>>

    export type ApiTradeV1PackagingSpecificationsDestroyMutationError = ErrorType<ErrorResponse>

    export const useApiTradeV1PackagingSpecificationsDestroy = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>, TError,{packagingSpecificationId: number}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1PackagingSpecificationsDestroy>>,
        TError,
        {packagingSpecificationId: number},
        TContext
      > => {
      return useMutation(getApiTradeV1PackagingSpecificationsDestroyMutationOptions(options), queryClient);
    }
    export const apiTradeV1SiteMaterialsCreate = (
    createSiteMaterialDTO: BodyType<CreateSiteMaterialDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CreateSiteMaterialResponse>(
      {url: `/api/trade/v1/site-materials/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSiteMaterialDTO, signal
    },
      options);
    }




export const getApiTradeV1SiteMaterialsCreateMutationOptions = <TError = ErrorType<ApiTradeV1SiteMaterialsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>, TError,{data: BodyType<CreateSiteMaterialDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>, TError,{data: BodyType<CreateSiteMaterialDTO>}, TContext> => {

const mutationKey = ['apiTradeV1SiteMaterialsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>, {data: BodyType<CreateSiteMaterialDTO>}> = (props) => {
          const {data} = props ?? {};

          return  apiTradeV1SiteMaterialsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1SiteMaterialsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>>
    export type ApiTradeV1SiteMaterialsCreateMutationBody = BodyType<CreateSiteMaterialDTO>
    export type ApiTradeV1SiteMaterialsCreateMutationError = ErrorType<ApiTradeV1SiteMaterialsCreate400 | ErrorResponse>

    export const useApiTradeV1SiteMaterialsCreate = <TError = ErrorType<ApiTradeV1SiteMaterialsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>, TError,{data: BodyType<CreateSiteMaterialDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsCreate>>,
        TError,
        {data: BodyType<CreateSiteMaterialDTO>},
        TContext
      > => {
      return useMutation(getApiTradeV1SiteMaterialsCreateMutationOptions(options), queryClient);
    }
    export const apiTradeV1SiteMaterialsRetrieve = (
    siteMaterialId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SiteMaterialDetail>(
      {url: `/api/trade/v1/site-materials/${siteMaterialId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiTradeV1SiteMaterialsRetrieveQueryKey = (siteMaterialId: string,) => {
    return [
    `/api/trade/v1/site-materials/${siteMaterialId}/`
    ] as const;
    }


export const getApiTradeV1SiteMaterialsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(siteMaterialId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsRetrieveQueryKey(siteMaterialId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>> = ({ signal }) => apiTradeV1SiteMaterialsRetrieve(siteMaterialId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: siteMaterialId !== null && siteMaterialId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1SiteMaterialsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>>
export type ApiTradeV1SiteMaterialsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1SiteMaterialsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteMaterialId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1SiteMaterialsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteMaterialId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1SiteMaterialsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteMaterialId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1SiteMaterialsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteMaterialId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1SiteMaterialsRetrieveQueryOptions(siteMaterialId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1SiteMaterialsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(siteMaterialId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1SiteMaterialsRetrieveQueryKey(siteMaterialId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>> = ({ signal }) => apiTradeV1SiteMaterialsRetrieve(siteMaterialId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1SiteMaterialsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>>
export type ApiTradeV1SiteMaterialsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1SiteMaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteMaterialId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1SiteMaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteMaterialId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1SiteMaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteMaterialId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1SiteMaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteMaterialId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1SiteMaterialsRetrieveSuspenseQueryOptions(siteMaterialId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1SiteMaterialsUpdate = (
    siteMaterialId: string,
    updateSiteMaterialDTO?: BodyType<UpdateSiteMaterialDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/trade/v1/site-materials/${siteMaterialId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateSiteMaterialDTO, signal
    },
      options);
    }




export const getApiTradeV1SiteMaterialsUpdateMutationOptions = <TError = ErrorType<ApiTradeV1SiteMaterialsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>, TError,{siteMaterialId: string;data?: BodyType<UpdateSiteMaterialDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>, TError,{siteMaterialId: string;data?: BodyType<UpdateSiteMaterialDTO>}, TContext> => {

const mutationKey = ['apiTradeV1SiteMaterialsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>, {siteMaterialId: string;data?: BodyType<UpdateSiteMaterialDTO>}> = (props) => {
          const {siteMaterialId,data} = props ?? {};

          return  apiTradeV1SiteMaterialsUpdate(siteMaterialId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1SiteMaterialsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>>
    export type ApiTradeV1SiteMaterialsUpdateMutationBody = BodyType<UpdateSiteMaterialDTO> | undefined
    export type ApiTradeV1SiteMaterialsUpdateMutationError = ErrorType<ApiTradeV1SiteMaterialsUpdate400 | ErrorResponse>

    export const useApiTradeV1SiteMaterialsUpdate = <TError = ErrorType<ApiTradeV1SiteMaterialsUpdate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>, TError,{siteMaterialId: string;data?: BodyType<UpdateSiteMaterialDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1SiteMaterialsUpdate>>,
        TError,
        {siteMaterialId: string;data?: BodyType<UpdateSiteMaterialDTO>},
        TContext
      > => {
      return useMutation(getApiTradeV1SiteMaterialsUpdateMutationOptions(options), queryClient);
    }
    /**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV1TradeCompaniesList = (
    params?: ApiTradeV1TradeCompaniesListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedSimpleTradeCompanyListItemList>(
      {url: `/api/trade/v1/trade-companies/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesListQueryKey = (params?: ApiTradeV1TradeCompaniesListParams,) => {
    return [
    `/api/trade/v1/trade-companies/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeCompaniesListQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiTradeV1TradeCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>> = ({ signal }) => apiTradeV1TradeCompaniesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>>
export type ApiTradeV1TradeCompaniesListQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiTradeV1TradeCompaniesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiTradeV1TradeCompaniesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>> = ({ signal }) => apiTradeV1TradeCompaniesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>>
export type ApiTradeV1TradeCompaniesListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiTradeV1TradeCompaniesListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV1TradeCompaniesCreate = (
    tradeCompanyCreateEndUser: BodyType<TradeCompanyCreateEndUser>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<TradeCompanyCreateResponse>(
      {url: `/api/trade/v1/trade-companies/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradeCompanyCreateEndUser, signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesCreateMutationOptions = <TError = ErrorType<ApiTradeV1TradeCompaniesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>, TError,{data: BodyType<TradeCompanyCreateEndUser>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>, TError,{data: BodyType<TradeCompanyCreateEndUser>}, TContext> => {

const mutationKey = ['apiTradeV1TradeCompaniesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>, {data: BodyType<TradeCompanyCreateEndUser>}> = (props) => {
          const {data} = props ?? {};

          return  apiTradeV1TradeCompaniesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1TradeCompaniesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>>
    export type ApiTradeV1TradeCompaniesCreateMutationBody = BodyType<TradeCompanyCreateEndUser>
    export type ApiTradeV1TradeCompaniesCreateMutationError = ErrorType<ApiTradeV1TradeCompaniesCreate400 | ErrorResponse>

    export const useApiTradeV1TradeCompaniesCreate = <TError = ErrorType<ApiTradeV1TradeCompaniesCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>, TError,{data: BodyType<TradeCompanyCreateEndUser>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesCreate>>,
        TError,
        {data: BodyType<TradeCompanyCreateEndUser>},
        TContext
      > => {
      return useMutation(getApiTradeV1TradeCompaniesCreateMutationOptions(options), queryClient);
    }
    export const apiTradeV1TradeCompaniesRetrieve = (
    tradeCompanyId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<FullTradeCompany>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesRetrieveQueryKey = (tradeCompanyId: number,) => {
    return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/`
    ] as const;
    }


export const getApiTradeV1TradeCompaniesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesRetrieveQueryKey(tradeCompanyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesRetrieve(tradeCompanyId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>>
export type ApiTradeV1TradeCompaniesRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesRetrieveQueryOptions(tradeCompanyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesRetrieveQueryKey(tradeCompanyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesRetrieve(tradeCompanyId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>>
export type ApiTradeV1TradeCompaniesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesRetrieveSuspenseQueryOptions(tradeCompanyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve = (
    tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BuyerMaterialSpecificationsListResponse>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/buyer-material-specifications/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryKey = (tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams,) => {
    return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/buyer-material-specifications/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>>
export type ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryOptions(tradeCompanyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>>
export type ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesBuyerMaterialSpecificationsRetrieveSuspenseQueryOptions(tradeCompanyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1TradeCompaniesEmployeesRetrieve = (
    tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<TradeCompanyEmployeesListResponse>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/employees/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesEmployeesRetrieveQueryKey = (tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams,) => {
    return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/employees/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeCompaniesEmployeesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesEmployeesRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesEmployeesRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesEmployeesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>>
export type ApiTradeV1TradeCompaniesEmployeesRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesEmployeesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesEmployeesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesEmployeesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesEmployeesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesEmployeesRetrieveQueryOptions(tradeCompanyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesEmployeesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesEmployeesRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesEmployeesRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesEmployeesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>>
export type ApiTradeV1TradeCompaniesEmployeesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesEmployeesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesEmployeesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesEmployeesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesEmployeesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesEmployeesRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesEmployeesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesEmployeesRetrieveSuspenseQueryOptions(tradeCompanyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve = (
    tradeCompanyId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PackagingSpecificationsListResponse>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/packaging-specifications/`, method: 'GET', signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryKey = (tradeCompanyId: number,) => {
    return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/packaging-specifications/`
    ] as const;
    }


export const getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryKey(tradeCompanyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve(tradeCompanyId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>>
export type ApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryOptions(tradeCompanyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveQueryKey(tradeCompanyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve(tradeCompanyId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>>
export type ApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesPackagingSpecificationsRetrieveSuspenseQueryOptions(tradeCompanyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1TradeCompaniesPackagingSpecificationsCreate = (
    tradeCompanyId: number,
    createPackagingSpecificationDTO: BodyType<CreatePackagingSpecificationDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<CreatePackagingSpecificationsResponse>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/packaging-specifications/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPackagingSpecificationDTO, signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationOptions = <TError = ErrorType<ApiTradeV1TradeCompaniesPackagingSpecificationsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>, TError,{tradeCompanyId: number;data: BodyType<CreatePackagingSpecificationDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>, TError,{tradeCompanyId: number;data: BodyType<CreatePackagingSpecificationDTO>}, TContext> => {

const mutationKey = ['apiTradeV1TradeCompaniesPackagingSpecificationsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>, {tradeCompanyId: number;data: BodyType<CreatePackagingSpecificationDTO>}> = (props) => {
          const {tradeCompanyId,data} = props ?? {};

          return  apiTradeV1TradeCompaniesPackagingSpecificationsCreate(tradeCompanyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>>
    export type ApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationBody = BodyType<CreatePackagingSpecificationDTO>
    export type ApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationError = ErrorType<ApiTradeV1TradeCompaniesPackagingSpecificationsCreate400 | ErrorResponse>

    export const useApiTradeV1TradeCompaniesPackagingSpecificationsCreate = <TError = ErrorType<ApiTradeV1TradeCompaniesPackagingSpecificationsCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>, TError,{tradeCompanyId: number;data: BodyType<CreatePackagingSpecificationDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPackagingSpecificationsCreate>>,
        TError,
        {tradeCompanyId: number;data: BodyType<CreatePackagingSpecificationDTO>},
        TContext
      > => {
      return useMutation(getApiTradeV1TradeCompaniesPackagingSpecificationsCreateMutationOptions(options), queryClient);
    }
    /**
 * List payment terms for a specific trade company
 */
export const apiTradeV1TradeCompaniesPaymentTermsList = (
    tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedSimpleCompanyPaymentTermsList>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/payment-terms/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesPaymentTermsListQueryKey = (tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams,) => {
    return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/payment-terms/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeCompaniesPaymentTermsListQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesPaymentTermsListQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>> = ({ signal }) => apiTradeV1TradeCompaniesPaymentTermsList(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesPaymentTermsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>>
export type ApiTradeV1TradeCompaniesPaymentTermsListQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesPaymentTermsList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesPaymentTermsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesPaymentTermsList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesPaymentTermsList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesPaymentTermsList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesPaymentTermsListQueryOptions(tradeCompanyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesPaymentTermsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesPaymentTermsListQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>> = ({ signal }) => apiTradeV1TradeCompaniesPaymentTermsList(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesPaymentTermsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>>
export type ApiTradeV1TradeCompaniesPaymentTermsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesPaymentTermsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesPaymentTermsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesPaymentTermsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesPaymentTermsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesPaymentTermsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesPaymentTermsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesPaymentTermsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesPaymentTermsListSuspenseQueryOptions(tradeCompanyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Export trade company sessions as CSV. Returns all matching sessions without pagination.
 */
export const apiTradeV1TradeCompaniesSessionsExportRetrieve = (
    tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<Blob>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/sessions/export/`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesSessionsExportRetrieveQueryKey = (tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams,) => {
    return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/sessions/export/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeCompaniesSessionsExportRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesSessionsExportRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesSessionsExportRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesSessionsExportRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>>
export type ApiTradeV1TradeCompaniesSessionsExportRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesSessionsExportRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesSessionsExportRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesSessionsExportRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesSessionsExportRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesSessionsExportRetrieveQueryOptions(tradeCompanyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesSessionsExportRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesSessionsExportRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesSessionsExportRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesSessionsExportRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>>
export type ApiTradeV1TradeCompaniesSessionsExportRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesSessionsExportRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesSessionsExportRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesSessionsExportRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesSessionsExportRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSessionsExportRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSessionsExportRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesSessionsExportRetrieveSuspenseQueryOptions(tradeCompanyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1TradeCompaniesSiteMaterialsRetrieve = (
    tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SiteMaterialListResponse>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/site-materials/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryKey = (tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams,) => {
    return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/site-materials/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesSiteMaterialsRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>>
export type ApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryOptions(tradeCompanyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesSiteMaterialsRetrieveQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesSiteMaterialsRetrieve(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>>
export type ApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV1TradeCompaniesSiteMaterialsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesSiteMaterialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesSiteMaterialsRetrieveSuspenseQueryOptions(tradeCompanyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1TradeCompaniesTradeSitesRetrieve = (
    tradeCompanyId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SimpleTradeSiteListResponse>(
      {url: `/api/trade/v1/trade-companies/${tradeCompanyId}/trade-sites/`, method: 'GET', signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryKey = (tradeCompanyId: number,) => {
    return [
    `/api/trade/v1/trade-companies/${tradeCompanyId}/trade-sites/`
    ] as const;
    }


export const getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryKey(tradeCompanyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesTradeSitesRetrieve(tradeCompanyId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesTradeSitesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>>
export type ApiTradeV1TradeCompaniesTradeSitesRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesTradeSitesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesTradeSitesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesTradeSitesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesTradeSitesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryOptions(tradeCompanyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesTradeSitesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesTradeSitesRetrieveQueryKey(tradeCompanyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesTradeSitesRetrieve(tradeCompanyId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesTradeSitesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>>
export type ApiTradeV1TradeCompaniesTradeSitesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompaniesTradeSitesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesTradeSitesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesTradeSitesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesTradeSitesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesTradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesTradeSitesRetrieveSuspenseQueryOptions(tradeCompanyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve = (
    params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<AssignedAccountManagersResponse>(
      {url: `/api/trade/v1/trade-companies/assigned-account-managers/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryKey = (params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams,) => {
    return [
    `/api/trade/v1/trade-companies/assigned-account-managers/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>>
export type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>


export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(
 params: undefined |  ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>> = ({ signal }) => apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>>
export type ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspenseQueryError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>


export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(
 params: undefined |  ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError = ErrorType<ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieve400 | ErrorResponse>>(
 params?: ApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompaniesAssignedAccountManagersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompaniesAssignedAccountManagersRetrieveSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV1TradeCompanyLeadsList = (
    params?: ApiTradeV1TradeCompanyLeadsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedSimpleTradeCompanyLeadListItemList>(
      {url: `/api/trade/v1/trade-company-leads/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV1TradeCompanyLeadsListQueryKey = (params?: ApiTradeV1TradeCompanyLeadsListParams,) => {
    return [
    `/api/trade/v1/trade-company-leads/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeCompanyLeadsListQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiTradeV1TradeCompanyLeadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompanyLeadsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>> = ({ signal }) => apiTradeV1TradeCompanyLeadsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompanyLeadsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>>
export type ApiTradeV1TradeCompanyLeadsListQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompanyLeadsList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiTradeV1TradeCompanyLeadsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompanyLeadsList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompanyLeadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompanyLeadsList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompanyLeadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompanyLeadsList<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompanyLeadsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompanyLeadsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeCompanyLeadsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(params?: ApiTradeV1TradeCompanyLeadsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeCompanyLeadsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>> = ({ signal }) => apiTradeV1TradeCompanyLeadsList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeCompanyLeadsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>>
export type ApiTradeV1TradeCompanyLeadsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeCompanyLeadsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiTradeV1TradeCompanyLeadsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompanyLeadsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompanyLeadsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeCompanyLeadsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompanyLeadsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeCompanyLeadsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeCompanyLeadsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeCompanyLeadsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeCompanyLeadsListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV1TradeSitesList = (
    params?: ApiTradeV1TradeSitesListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedSimpleTradeSiteListItemList>(
      {url: `/api/trade/v1/trade-sites/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV1TradeSitesListQueryKey = (params?: ApiTradeV1TradeSitesListParams,) => {
    return [
    `/api/trade/v1/trade-sites/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV1TradeSitesListQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiTradeV1TradeSitesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeSitesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>> = ({ signal }) => apiTradeV1TradeSitesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeSitesListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>>
export type ApiTradeV1TradeSitesListQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeSitesList<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiTradeV1TradeSitesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeSitesList<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeSitesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeSitesList<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeSitesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeSitesList<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeSitesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeSitesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeSitesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(params?: ApiTradeV1TradeSitesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeSitesListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>> = ({ signal }) => apiTradeV1TradeSitesList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeSitesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>>
export type ApiTradeV1TradeSitesListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeSitesListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(
 params: undefined |  ApiTradeV1TradeSitesListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeSitesListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeSitesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeSitesListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeSitesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeSitesListSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError = ErrorType<ErrorResponse>>(
 params?: ApiTradeV1TradeSitesListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeSitesListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const apiTradeV1TradeSitesRetrieve = (
    siteId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<SiteWithTradeCompany>(
      {url: `/api/trade/v1/trade-sites/${siteId}/`, method: 'GET', signal
    },
      options);
    }




export const getApiTradeV1TradeSitesRetrieveQueryKey = (siteId: number,) => {
    return [
    `/api/trade/v1/trade-sites/${siteId}/`
    ] as const;
    }


export const getApiTradeV1TradeSitesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(siteId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeSitesRetrieveQueryKey(siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>> = ({ signal }) => apiTradeV1TradeSitesRetrieve(siteId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeSitesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>>
export type ApiTradeV1TradeSitesRetrieveQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeSitesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeSitesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeSitesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeSitesRetrieve<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeSitesRetrieveQueryOptions(siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV1TradeSitesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(siteId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV1TradeSitesRetrieveQueryKey(siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>> = ({ signal }) => apiTradeV1TradeSitesRetrieve(siteId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV1TradeSitesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>>
export type ApiTradeV1TradeSitesRetrieveSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV1TradeSitesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteId: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeSitesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV1TradeSitesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV1TradeSitesRetrieveSuspense<TData = Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError = ErrorType<ErrorResponse>>(
 siteId: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV1TradeSitesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV1TradeSitesRetrieveSuspenseQueryOptions(siteId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV2TradeCompaniesSessionsList = (
    tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PaginatedTradeCompanySessionListItemList>(
      {url: `/api/trade/v2/trade-companies/${tradeCompanyId}/sessions/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getApiTradeV2TradeCompaniesSessionsListQueryKey = (tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams,) => {
    return [
    `/api/trade/v2/trade-companies/${tradeCompanyId}/sessions/`, ...(params ? [params] : [])
    ] as const;
    }


export const getApiTradeV2TradeCompaniesSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV2TradeCompaniesSessionsListQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>> = ({ signal }) => apiTradeV2TradeCompaniesSessionsList(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: tradeCompanyId !== null && tradeCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV2TradeCompaniesSessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>>
export type ApiTradeV2TradeCompaniesSessionsListQueryError = ErrorType<ErrorResponse>


export function useApiTradeV2TradeCompaniesSessionsList<TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV2TradeCompaniesSessionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV2TradeCompaniesSessionsList<TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>,
          TError,
          Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV2TradeCompaniesSessionsList<TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV2TradeCompaniesSessionsList<TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV2TradeCompaniesSessionsListQueryOptions(tradeCompanyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiTradeV2TradeCompaniesSessionsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTradeV2TradeCompaniesSessionsListQueryKey(tradeCompanyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>> = ({ signal }) => apiTradeV2TradeCompaniesSessionsList(tradeCompanyId,params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiTradeV2TradeCompaniesSessionsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>>
export type ApiTradeV2TradeCompaniesSessionsListSuspenseQueryError = ErrorType<ErrorResponse>


export function useApiTradeV2TradeCompaniesSessionsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params: undefined |  ApiTradeV2TradeCompaniesSessionsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV2TradeCompaniesSessionsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiTradeV2TradeCompaniesSessionsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useApiTradeV2TradeCompaniesSessionsListSuspense<TData = Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError = ErrorType<ErrorResponse>>(
 tradeCompanyId: number,
    params?: ApiTradeV2TradeCompaniesSessionsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiTradeV2TradeCompaniesSessionsListSuspenseQueryOptions(tradeCompanyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * A base view that returns paginated results.
 *
 * Developers should handle pagination manually using selector methods and then
 * use `common.api.pagination.ResultsPageFormatter` to format the results.
 */
export const apiTradeV2TradeCompaniesSessionsCreate = (
    tradeCompanyId: number,
    tradeCompanySessionCreateDTO: BodyType<TradeCompanySessionCreateDTO>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<TradeCompanySessionCreateResponse>(
      {url: `/api/trade/v2/trade-companies/${tradeCompanyId}/sessions/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tradeCompanySessionCreateDTO, signal
    },
      options);
    }




export const getApiTradeV2TradeCompaniesSessionsCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsCreate>>, TError,{tradeCompanyId: number;data: BodyType<TradeCompanySessionCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsCreate>>, TError,{tradeCompanyId: number;data: BodyType<TradeCompanySessionCreateDTO>}, TContext> => {

const mutationKey = ['apiTradeV2TradeCompaniesSessionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsCreate>>, {tradeCompanyId: number;data: BodyType<TradeCompanySessionCreateDTO>}> = (props) => {
          const {tradeCompanyId,data} = props ?? {};

          return  apiTradeV2TradeCompaniesSessionsCreate(tradeCompanyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTradeV2TradeCompaniesSessionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsCreate>>>
    export type ApiTradeV2TradeCompaniesSessionsCreateMutationBody = BodyType<TradeCompanySessionCreateDTO>
    export type ApiTradeV2TradeCompaniesSessionsCreateMutationError = ErrorType<ErrorResponse>

    export const useApiTradeV2TradeCompaniesSessionsCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsCreate>>, TError,{tradeCompanyId: number;data: BodyType<TradeCompanySessionCreateDTO>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTradeV2TradeCompaniesSessionsCreate>>,
        TError,
        {tradeCompanyId: number;data: BodyType<TradeCompanySessionCreateDTO>},
        TContext
      > => {
      return useMutation(getApiTradeV2TradeCompaniesSessionsCreateMutationOptions(options), queryClient);
    }
    export const apiTransportPricesV1BulkRefreshOceanRatesCreate = (
    bulkRefreshOceanRatesInput: BodyType<BulkRefreshOceanRatesInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<BulkRefreshOceanRatesOutput>(
      {url: `/api/transport-prices/v1/bulk-refresh-ocean-rates/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkRefreshOceanRatesInput, signal
    },
      options);
    }




export const getApiTransportPricesV1BulkRefreshOceanRatesCreateMutationOptions = <TError = ErrorType<unknown | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>, TError,{data: BodyType<BulkRefreshOceanRatesInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>, TError,{data: BodyType<BulkRefreshOceanRatesInput>}, TContext> => {

const mutationKey = ['apiTransportPricesV1BulkRefreshOceanRatesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>, {data: BodyType<BulkRefreshOceanRatesInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiTransportPricesV1BulkRefreshOceanRatesCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTransportPricesV1BulkRefreshOceanRatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>>
    export type ApiTransportPricesV1BulkRefreshOceanRatesCreateMutationBody = BodyType<BulkRefreshOceanRatesInput>
    export type ApiTransportPricesV1BulkRefreshOceanRatesCreateMutationError = ErrorType<unknown | ErrorResponse>

    export const useApiTransportPricesV1BulkRefreshOceanRatesCreate = <TError = ErrorType<unknown | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>, TError,{data: BodyType<BulkRefreshOceanRatesInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTransportPricesV1BulkRefreshOceanRatesCreate>>,
        TError,
        {data: BodyType<BulkRefreshOceanRatesInput>},
        TContext
      > => {
      return useMutation(getApiTransportPricesV1BulkRefreshOceanRatesCreateMutationOptions(options), queryClient);
    }
    /**
 * Clears all cached transport costs data
 * @summary Clear transport costs cache
 */
export const apiTransportPricesV1ClearCacheCreate = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/transport-prices/v1/clear-cache/`, method: 'POST', signal
    },
      options);
    }




export const getApiTransportPricesV1ClearCacheCreateMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>, TError,void, TContext> => {

const mutationKey = ['apiTransportPricesV1ClearCacheCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>, void> = () => {


          return  apiTransportPricesV1ClearCacheCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTransportPricesV1ClearCacheCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>>

    export type ApiTransportPricesV1ClearCacheCreateMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Clear transport costs cache
 */
export const useApiTransportPricesV1ClearCacheCreate = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTransportPricesV1ClearCacheCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getApiTransportPricesV1ClearCacheCreateMutationOptions(options), queryClient);
    }
    /**
 * Estimate transport costs
 * @summary Estimate transport costs
 */
export const apiTransportPricesV1EstimateCreate = (
    transportCostEstimateInput: BodyType<TransportCostEstimateInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PointToPointTransportCostBreakdownResultDTO>(
      {url: `/api/transport-prices/v1/estimate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transportCostEstimateInput, signal
    },
      options);
    }




export const getApiTransportPricesV1EstimateCreateMutationOptions = <TError = ErrorType<ApiTransportPricesV1EstimateCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>, TError,{data: BodyType<TransportCostEstimateInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>, TError,{data: BodyType<TransportCostEstimateInput>}, TContext> => {

const mutationKey = ['apiTransportPricesV1EstimateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>, {data: BodyType<TransportCostEstimateInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiTransportPricesV1EstimateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTransportPricesV1EstimateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>>
    export type ApiTransportPricesV1EstimateCreateMutationBody = BodyType<TransportCostEstimateInput>
    export type ApiTransportPricesV1EstimateCreateMutationError = ErrorType<ApiTransportPricesV1EstimateCreate400 | ErrorResponse>

    /**
 * @summary Estimate transport costs
 */
export const useApiTransportPricesV1EstimateCreate = <TError = ErrorType<ApiTransportPricesV1EstimateCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>, TError,{data: BodyType<TransportCostEstimateInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTransportPricesV1EstimateCreate>>,
        TError,
        {data: BodyType<TransportCostEstimateInput>},
        TContext
      > => {
      return useMutation(getApiTransportPricesV1EstimateCreateMutationOptions(options), queryClient);
    }
    /**
 * Estimate transit time for transport routes
 * @summary Estimate transit time
 */
export const apiTransportPricesV1TransitTimeEstimateCreate = (
    transitTimeEstimateInput?: BodyType<TransitTimeEstimateInput>,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<TransitTimeEstimateResultDTO>(
      {url: `/api/transport-prices/v1/transit-time-estimate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transitTimeEstimateInput, signal
    },
      options);
    }




export const getApiTransportPricesV1TransitTimeEstimateCreateMutationOptions = <TError = ErrorType<ApiTransportPricesV1TransitTimeEstimateCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>, TError,{data?: BodyType<TransitTimeEstimateInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>, TError,{data?: BodyType<TransitTimeEstimateInput>}, TContext> => {

const mutationKey = ['apiTransportPricesV1TransitTimeEstimateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>, {data?: BodyType<TransitTimeEstimateInput>}> = (props) => {
          const {data} = props ?? {};

          return  apiTransportPricesV1TransitTimeEstimateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApiTransportPricesV1TransitTimeEstimateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>>
    export type ApiTransportPricesV1TransitTimeEstimateCreateMutationBody = BodyType<TransitTimeEstimateInput> | undefined
    export type ApiTransportPricesV1TransitTimeEstimateCreateMutationError = ErrorType<ApiTransportPricesV1TransitTimeEstimateCreate400 | ErrorResponse>

    /**
 * @summary Estimate transit time
 */
export const useApiTransportPricesV1TransitTimeEstimateCreate = <TError = ErrorType<ApiTransportPricesV1TransitTimeEstimateCreate400 | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>, TError,{data?: BodyType<TransitTimeEstimateInput>}, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiTransportPricesV1TransitTimeEstimateCreate>>,
        TError,
        {data?: BodyType<TransitTimeEstimateInput>},
        TContext
      > => {
      return useMutation(getApiTransportPricesV1TransitTimeEstimateCreateMutationOptions(options), queryClient);
    }
